[
	{
		"currency": "AFN",
		"callingCode": "93",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "afghanistan",
		"name": {
			"common": "Afghanistan",
			"ar": "أفغانستان",
			"de": "Afghanistan",
			"en": "Afghanistan",
			"es": "Afganistán",
			"fr": "Afghanistan",
			"hi": "अफ़ग़ानिस्तान",
			"ja": "アフガニスタン",
			"ko": "아프가니스탄",
			"pt": "Afeganistão",
			"ru": "Афганистан",
			"tr": "Afganistan",
			"zh": "阿富汗"
		},
		"countryCode": "AF",
		"visaCode": "1",
		"states": [
			"Badakhshan",
			"Badghis",
			"Baghlan",
			"Balkh",
			"Bamyan",
			"Daykundi",
			"Farah",
			"Faryab",
			"Ghazni",
			"Ghor",
			"Helmand",
			"Herat",
			"Jowzjan",
			"Kabul",
			"Kandahar",
			"Kapisa",
			"Khost",
			"Kunar",
			"Kunduz",
			"Laghman",
			"Logar",
			"Maidan Wardak",
			"Nangarhar",
			"Nimruz",
			"Nuristan",
			"Paktia",
			"Paktika",
			"Panjshir",
			"Parwan",
			"Samangan",
			"Sar-e Pol",
			"Takhar",
			"Urozgan",
			"Zabul"
		]
	},
	{
		"currency": "ALL",
		"callingCode": "355",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "albania",
		"name": {
			"common": "Albania",
			"ar": "ألبانيا",
			"de": "Albanien",
			"en": "Albania",
			"es": "Albania",
			"fr": "Albanie",
			"hi": "अल्बानिया",
			"ja": "アルバニア",
			"ko": "알바니아",
			"pt": "Albânia",
			"ru": "Албания",
			"tr": "Arnavutluk",
			"zh": "阿尔巴尼亚"
		},
		"countryCode": "AL",
		"visaCode": "2",
		"states": [
			"Berat",
			"Dibër",
			"Durrës",
			"Elbasan",
			"Fier",
			"Gjirokastër",
			"Korçë",
			"Kukës",
			"Lezhë",
			"Shkodër",
			"Tirana",
			"Vlorë"
		]
	},
	{
		"currency": "DZD",
		"callingCode": "213",
		"region": "Africa",
		"subregion": "Northern Africa",
		"slug": "algeria",
		"name": {
			"common": "Algeria",
			"ar": "الجزائر",
			"de": "Algerien",
			"en": "Algeria",
			"es": "Argelia",
			"fr": "Algérie",
			"hi": "अल्जीरिया",
			"ja": "アルジェリア",
			"ko": "알제리",
			"pt": "Argélia",
			"ru": "Алжир",
			"tr": "Cezayir",
			"zh": "阿尔及利亚"
		},
		"countryCode": "DZ",
		"visaCode": "3",
		"states": [
			"Adrar",
			"Aïn Defla",
			"Aïn Témouchent",
			"Algiers",
			"Annaba",
			"Batna",
			"Béchar",
			"Béjaïa",
			"Biskra",
			"Blida",
			"Bordj Bou Arréridj",
			"Bouïra",
			"Boumerdès",
			"Chlef",
			"Constantine",
			"Djelfa",
			"El Bayadh",
			"El Oued",
			"El Tarf",
			"Ghardaïa",
			"Guelma",
			"Illizi",
			"Jijel",
			"Khenchela",
			"Laghouat",
			"Mascara",
			"Médéa",
			"Mila",
			"Mostaganem",
			"Msila",
			"Naâma",
			"Oran",
			"Ouargla",
			"Oum el Bouaghi",
			"Relizane",
			"Saïda",
			"Sétif",
			"Sidi Bel Abbès",
			"Skikda",
			"Souk Ahras",
			"Tamanghasset",
			"Tébessa",
			"Tiaret",
			"Tindouf",
			"Tipaza",
			"Tissemsilt",
			"Tizi Ouzou",
			"Tlemcen"
		]
	},
	{
		"currency": "USD",
		"callingCode": "1684",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "american-samoa",
		"name": {
			"common": "American Samoa",
			"ar": "ساموا الأمريكية",
			"de": "Amerikanisch-Samoa",
			"en": "American Samoa",
			"es": "Samoa Americana",
			"fr": "Samoa américaines",
			"hi": "अमेरिकी समोआ",
			"ja": "アメリカ領サモア",
			"ko": "아메리칸사모아",
			"pt": "Samoa Americana",
			"ru": "Американское Самоа",
			"tr": "Amerikan Samoası",
			"zh": "美属萨摩亚"
		},
		"countryCode": "AS",
		"visaCode": "4",
		"states": ["Tutuila", "Aunu'u", "Ta'ū", "Ofu‑Olosega", "Rose Atoll", "Swains Island"]
	},
	{
		"currency": "EUR",
		"callingCode": "376",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "andorra",
		"name": {
			"common": "Andorra",
			"ar": "أندورا",
			"de": "Andorra",
			"en": "Andorra",
			"es": "Andorra",
			"fr": "Andorre",
			"hi": "एंडोरा",
			"ja": "アンドラ",
			"ko": "안도라",
			"pt": "Andorra",
			"ru": "Андорра",
			"tr": "Andorra",
			"zh": "安道尔"
		},
		"countryCode": "AD",
		"visaCode": "5",
		"states": [
			"Andorra la Vella",
			"Canillo",
			"Encamp",
			"Escaldes-Engordany",
			"La Massana",
			"Ordino",
			"Sant Julià de Lòria"
		]
	},
	{
		"currency": "AOA",
		"callingCode": "244",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "angola",
		"name": {
			"common": "Angola",
			"ar": "أنغولا",
			"de": "Angola",
			"en": "Angola",
			"es": "Angola",
			"fr": "Angola",
			"hi": "अंगोला",
			"ja": "アンゴラ",
			"ko": "앙골라",
			"pt": "Angola",
			"ru": "Ангола",
			"tr": "Angola",
			"zh": "安哥拉"
		},
		"countryCode": "AO",
		"visaCode": "6",
		"states": [
			"Bengo",
			"Benguela",
			"Bié",
			"Cabinda",
			"Cuando Cubango",
			"Cuanza Norte",
			"Cuanza Sul",
			"Cunene",
			"Huambo",
			"Huíla",
			"Luanda",
			"Lunda Norte",
			"Lunda Sul",
			"Malanje",
			"Moxico",
			"Namibe",
			"Uíge",
			"Zaire"
		]
	},
	{
		"currency": "XCD",
		"callingCode": "1264",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "anguilla",
		"name": {
			"common": "Anguilla",
			"ar": "أنغويلا",
			"de": "Anguilla",
			"en": "Anguilla",
			"es": "Anguila",
			"fr": "Anguilla",
			"hi": "एंगुइला",
			"ja": "アンギラ",
			"ko": "앵귈라",
			"pt": "Anguilla",
			"ru": "Ангилья",
			"tr": "Anguilla",
			"zh": "安圭拉"
		},
		"countryCode": "AI",
		"visaCode": "7",
		"states": [
			"Anguilla",
			"Anguillita Island",
			"Blowing Rock",
			"Cove Cay",
			"Crocus Cay",
			"Deadman's Cay",
			"Dog Island",
			"East Cay",
			"Little Island",
			"Little Scrub Island",
			"Mid Cay",
			"North Cay",
			"Prickly Pear Cays",
			"Rabbit Island",
			"Sandy Island/Sand Island",
			"Scilly Cay",
			"Scrub Island",
			"Seal Island",
			"Sombrero/Hat Island",
			"South Cay",
			"South Wager Island",
			"West Cay"
		]
	},
	{
		"currency": "XCD",
		"callingCode": "1268",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "antigua-and-barbuda",
		"name": {
			"common": "Antigua and Barbuda",
			"ar": "أنتيغوا وبربودا",
			"de": "Antigua und Barbuda",
			"en": "Antigua and Barbuda",
			"es": "Antigua y Barbuda",
			"fr": "Antigua-et-Barbuda",
			"hi": "एंटीगुआ और बारबुडा",
			"ja": "アンティグア・バーブーダ",
			"ko": "앤티가 바부다",
			"pt": "Antígua e Barbuda",
			"ru": "Антигуа и Барбуда",
			"tr": "Antigua ve Barbuda",
			"zh": "安提瓜和巴布达"
		},
		"countryCode": "AG",
		"visaCode": "8",
		"states": [
			"Antigua Island",
			"Barbuda Island",
			"Bird Island",
			"Bishop Island",
			"Blake Island",
			"Crump Island",
			"Dulcina Island",
			"Exchange Island",
			"Five Islands",
			"Great Bird Island",
			"Green Island",
			"Guiana Island",
			"Hawes Island",
			"Hells Gate Island",
			"Henry Island",
			"Johnson Island",
			"Kid Island",
			"Lobster Island",
			"Maiden Island",
			"Moor Island",
			"Nanny Island",
			"Pelican Island",
			"Prickly Pear Island",
			"Rabbit Island",
			"Red Head Island",
			"Redonda Island",
			"Sandy Island",
			"Smith Island",
			"The Sisters",
			"Vernon Island",
			"Wicked Will Island",
			"York Island"
		]
	},
	{
		"currency": "ARS",
		"callingCode": "54",
		"region": "Americas",
		"subregion": "South America",
		"slug": "argentina",
		"name": {
			"common": "Argentina",
			"ar": "الأرجنتين",
			"de": "Argentinien",
			"en": "Argentina",
			"es": "Argentina",
			"fr": "Argentine",
			"hi": "अर्जेंटीना",
			"ja": "アルゼンチン",
			"ko": "아르헨티나",
			"pt": "Argentina",
			"ru": "Аргентина",
			"tr": "Arjantin",
			"zh": "阿根廷"
		},
		"countryCode": "AR",
		"visaCode": "9",
		"states": [
			"Buenos Aires",
			"Capital Federal",
			"Catamarca",
			"Chaco",
			"Chubut",
			"Córdoba",
			"Corrientes",
			"Entre Ríos",
			"Formosa",
			"Jujuy",
			"La Pampa",
			"La Rioja",
			"Mendoza",
			"Misiones",
			"Neuquén",
			"Río Negro",
			"Salta",
			"San Juan",
			"San Luis",
			"Santa Cruz",
			"Santa Fe",
			"Santiago del Estero",
			"Tierra del Fuego",
			"Tucumán"
		]
	},
	{
		"currency": "AMD",
		"callingCode": "374",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "armenia",
		"name": {
			"common": "Armenia",
			"ar": "أرمينيا",
			"de": "Armenien",
			"en": "Armenia",
			"es": "Armenia",
			"fr": "Arménie",
			"hi": "आर्मेनिया",
			"ja": "アルメニア",
			"ko": "아르메니아",
			"pt": "Arménia",
			"ru": "Армения",
			"tr": "Ermenistan",
			"zh": "亚美尼亚"
		},
		"countryCode": "AM",
		"visaCode": "10",
		"states": [
			"Aragatsotn",
			"Ararat",
			"Armavir",
			"Gegharkunik",
			"Kotayk",
			"Lori",
			"Shirak",
			"Syunik",
			"Tavush",
			"Vayots Dzor",
			"Yerevan"
		]
	},
	{
		"currency": "AWG",
		"callingCode": "297",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "aruba",
		"name": {
			"common": "Aruba",
			"ar": "أروبا",
			"de": "Aruba",
			"en": "Aruba",
			"es": "Aruba",
			"fr": "Aruba",
			"hi": "अरूबा",
			"ja": "アルバ",
			"ko": "아루바",
			"pt": "Aruba",
			"ru": "Аруба",
			"tr": "Aruba",
			"zh": "阿鲁巴"
		},
		"countryCode": "AW",
		"visaCode": "11",
		"states": ["Aruba"]
	},
	{
		"currency": "AUD",
		"callingCode": "61",
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"slug": "australia",
		"name": {
			"common": "Australia",
			"ar": "أستراليا",
			"de": "Australien",
			"en": "Australia",
			"es": "Australia",
			"fr": "Australie",
			"hi": "ऑस्ट्रेलिया",
			"ja": "オーストラリア",
			"ko": "호주",
			"pt": "Austrália",
			"ru": "Австралия",
			"tr": "Avustralya",
			"zh": "澳大利亚"
		},
		"countryCode": "AU",
		"visaCode": "13",
		"states": [
			"Australian Capital Territory",
			"New South Wales",
			"Northern Territory",
			"Queensland",
			"South Australia",
			"Tasmania",
			"Victoria",
			"Western Australia"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "43",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "austria",
		"name": {
			"common": "Austria",
			"ar": "النمسا",
			"de": "Österreich",
			"en": "Austria",
			"es": "Austria",
			"fr": "Autriche",
			"hi": "ऑस्ट्रिया",
			"ja": "オーストリア",
			"ko": "오스트리아",
			"pt": "Áustria",
			"ru": "Австрия",
			"tr": "Avusturya",
			"zh": "奥地利"
		},
		"countryCode": "AT",
		"visaCode": "14",
		"states": [
			"Burgenland",
			"Kärnten",
			"Niederösterreich",
			"Oberösterreich",
			"Salzburg",
			"Steiermark",
			"Tirol",
			"Vorarlberg",
			"Wien"
		]
	},
	{
		"currency": "AZN",
		"callingCode": "994",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "azerbaijan",
		"name": {
			"common": "Azerbaijan",
			"ar": "أذربيجان",
			"de": "Aserbaidschan",
			"en": "Azerbaijan",
			"es": "Azerbaiyán",
			"fr": "Azerbaïdjan",
			"hi": "अज़रबैजान",
			"ja": "アゼルバイジャン",
			"ko": "아제르바이잔",
			"pt": "Azerbaijão",
			"ru": "Азербайджан",
			"tr": "Azerbaycan",
			"zh": "阿塞拜疆"
		},
		"countryCode": "AZ",
		"visaCode": "15",
		"states": [
			"Abşeron",
			"Ağcabədi",
			"Ağdam",
			"Ağdaş",
			"Ağstafa",
			"Ağsu",
			"Astara",
			"Bakı",
			"Babək",
			"Balakən",
			"Bərdə",
			"Beyləqan",
			"Biləsuvar",
			"Cəbrayıl",
			"Cəlilabad",
			"Culfa",
			"Daşkəsən",
			"Füzuli",
			"Gədəbəy",
			"Goranboy",
			"Göyçay",
			"Göygöl",
			"Hacıqabul",
			"İmişli",
			"İsmayıllı",
			"Kəlbəcər",
			"Kǝngǝrli",
			"Kürdəmir",
			"Laçın",
			"Lənkəran",
			"Lerik",
			"Masallı",
			"Neftçala",
			"Oğuz",
			"Ordubad",
			"Qəbələ",
			"Qax",
			"Qazax",
			"Qobustan",
			"Quba",
			"Qubadli",
			"Qusar",
			"Saatlı",
			"Sabirabad",
			"Şabran",
			"Sədərək",
			"Şahbuz",
			"Şəki",
			"Salyan",
			"Şamaxı",
			"Şəmkir",
			"Samux",
			"Şərur",
			"Siyəzən",
			"Şuşa",
			"Tərtər",
			"Tovuz",
			"Ucar",
			"Xaçmaz",
			"Xızı",
			"Xocalı",
			"Xocavənd",
			"Yardımlı",
			"Yevlax",
			"Zəngilan",
			"Zaqatala",
			"Zərdab"
		]
	},
	{
		"currency": "BSD",
		"callingCode": "1242",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "bahamas",
		"name": {
			"common": "Bahamas",
			"ar": "باهاماس",
			"de": "Bahamas",
			"en": "Bahamas",
			"es": "Bahamas",
			"fr": "Bahamas",
			"hi": "बहामास",
			"ja": "バハマ",
			"ko": "바하마",
			"pt": "Bahamas",
			"ru": "Багамские Острова",
			"tr": "Bahamalar",
			"zh": "巴哈马"
		},
		"countryCode": "BS",
		"visaCode": "16",
		"states": [
			"Acklins Island",
			"Berry Islands",
			"Bimini",
			"Black Point",
			"Cat Island",
			"Central Abaco",
			"Crooked Island and Long Cay",
			"East Grand Bahama",
			"Exuma",
			"Freeport",
			"Fresh Creek",
			"Governor's Harbour",
			"Green Turtle Cay",
			"Harbour Island",
			"High Rock",
			"Inagua",
			"Kemps Bay",
			"Long Island",
			"Marsh Harbour",
			"Mayaguana",
			"Moore’s Island",
			"New Providence",
			"Nichollstown and Berry Islands",
			"North Abaco",
			"North Andros",
			"North Eleuthera",
			"Ragged Island",
			"Rock Sound",
			"San Salvador and Rum Cay",
			"Sandy Point",
			"South Abaco",
			"South Andros",
			"South Eleuthera",
			"West Grand Bahama",
			"Central Andros",
			"Central Eleuthera",
			"Grand Cay",
			"Hope Town",
			"Mangrove Cay",
			"Spanish Wells"
		]
	},
	{
		"currency": "BHD",
		"callingCode": "973",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "bahrain",
		"name": {
			"common": "Bahrain",
			"ar": "البحرين",
			"de": "Bahrain",
			"en": "Bahrain",
			"es": "Baréin",
			"fr": "Bahreïn",
			"hi": "बहरीन",
			"ja": "バーレーン",
			"ko": "바레인",
			"pt": "Bahrein",
			"ru": "Бахрейн",
			"tr": "Bahreyn",
			"zh": "巴林"
		},
		"countryCode": "BH",
		"visaCode": "17",
		"states": ["Al Janūbīyah", "Al Manāmah", "Al Muḩarraq", "Al Wusţá", "Ash Shamālīyah"]
	},
	{
		"currency": "BDT",
		"callingCode": "880",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "bangladesh",
		"name": {
			"common": "Bangladesh",
			"ar": "بنغلاديش",
			"de": "Bangladesch",
			"en": "Bangladesh",
			"es": "Bangladés",
			"fr": "Bangladesh",
			"hi": "बांग्लादेश",
			"ja": "バングラデシュ",
			"ko": "방글라데시",
			"pt": "Bangladesh",
			"ru": "Бангладеш",
			"tr": "Bangladeş",
			"zh": "孟加拉国"
		},
		"countryCode": "BD",
		"visaCode": "18",
		"states": [
			"Barisal",
			"Chittagong",
			"Dhaka",
			"Khulna",
			"Mymensingh",
			"Rajshahi",
			"Rangpur",
			"Sylhet"
		]
	},
	{
		"currency": "BBD",
		"callingCode": "1246",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "barbados",
		"name": {
			"common": "Barbados",
			"ar": "باربادوس",
			"de": "Barbados",
			"en": "Barbados",
			"es": "Barbados",
			"fr": "Barbade",
			"hi": "बारबाडोस",
			"ja": "バルバドス",
			"ko": "바베이도스",
			"pt": "Barbados",
			"ru": "Барбадос",
			"tr": "Barbados",
			"zh": "巴巴多斯"
		},
		"countryCode": "BB",
		"visaCode": "19",
		"states": [
			"Christ Church",
			"Saint Andrew",
			"Saint George",
			"Saint James",
			"Saint John",
			"Saint Joseph",
			"Saint Lucy",
			"Saint Michael",
			"Saint Peter",
			"Saint Philip",
			"Saint Thomas"
		]
	},
	{
		"currency": "BYN",
		"callingCode": "375",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "belarus",
		"name": {
			"common": "Belarus",
			"ar": "بيلاروس",
			"de": "Belarus",
			"en": "Belarus",
			"es": "Bielorrusia",
			"fr": "Biélorussie",
			"hi": "बेलारूस",
			"ja": "ベラルーシ",
			"ko": "벨라루스",
			"pt": "Bielorrússia",
			"ru": "Белоруссия",
			"tr": "Belarus",
			"zh": "白俄罗斯"
		},
		"countryCode": "BY",
		"visaCode": "20",
		"states": [
			"Brest voblast",
			"Gorod Minsk",
			"Homiel voblast",
			"Hrodna voblast",
			"Mahilyow voblast",
			"Minsk voblast",
			"Vitsebsk voblast"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "32",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "belgium",
		"name": {
			"common": "Belgium",
			"ar": "بلجيكا",
			"de": "Belgien",
			"en": "Belgium",
			"es": "Bélgica",
			"fr": "Belgique",
			"hi": "बेल्जियम",
			"ja": "ベルギー",
			"ko": "벨기에",
			"pt": "Bélgica",
			"ru": "Бельгия",
			"tr": "Belçika",
			"zh": "比利时"
		},
		"countryCode": "BE",
		"visaCode": "21",
		"states": ["Brussels", "Flanders", "Wallonia"]
	},
	{
		"currency": "BZD",
		"callingCode": "501",
		"region": "Americas",
		"subregion": "Central America",
		"slug": "belize",
		"name": {
			"common": "Belize",
			"ar": "بليز",
			"de": "Belize",
			"en": "Belize",
			"es": "Belice",
			"fr": "Belize",
			"hi": "बेलीज़",
			"ja": "ベリーズ",
			"ko": "벨리즈",
			"pt": "Belize",
			"ru": "Белиз",
			"tr": "Belize",
			"zh": "伯利兹"
		},
		"countryCode": "BZ",
		"visaCode": "22",
		"states": [
			"Belize District",
			"Cayo District",
			"Corozal District",
			"Orange Walk District",
			"Stann Creek District",
			"Toledo District"
		]
	},
	{
		"currency": "XOF",
		"callingCode": "229",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "benin",
		"name": {
			"common": "Benin",
			"ar": "بنين",
			"de": "Benin",
			"en": "Benin",
			"es": "Benín",
			"fr": "Bénin",
			"hi": "बेनिन",
			"ja": "ベナン",
			"ko": "베냉",
			"pt": "Benim",
			"ru": "Бенин",
			"tr": "Benin",
			"zh": "贝宁"
		},
		"countryCode": "BJ",
		"visaCode": "23",
		"states": [
			"Alibori",
			"Atakora",
			"Atlantique",
			"Borgou",
			"Collines Department",
			"Donga",
			"Kouffo",
			"Littoral Department",
			"Mono Department",
			"Ouémé",
			"Plateau",
			"Zou"
		]
	},
	{
		"currency": "BMD",
		"callingCode": "1441",
		"region": "Americas",
		"subregion": "North America",
		"slug": "bermuda",
		"name": {
			"common": "Bermuda",
			"ar": "برمودا",
			"de": "Bermuda",
			"en": "Bermuda",
			"es": "Bermudas",
			"fr": "Bermudes",
			"hi": "बरमूडा",
			"ja": "バミューダ",
			"ko": "버뮤다",
			"pt": "Bermudas",
			"ru": "Бермудские Острова",
			"tr": "Bermuda",
			"zh": "百慕大"
		},
		"countryCode": "BM",
		"visaCode": "24",
		"states": [
			"City of Hamilton",
			"Devonshire Parish",
			"Hamilton Parish",
			"Paget Parish",
			"Pembroke Parish",
			"Sandys Parish",
			"Smith's Parish",
			"Southampton Parish",
			"St. George's Parish",
			"Town of St. George",
			"Warwick Parish"
		]
	},
	{
		"currency": "BTN",
		"callingCode": "975",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "bhutan",
		"name": {
			"common": "Bhutan",
			"ar": "بوتان",
			"de": "Bhutan",
			"en": "Bhutan",
			"es": "Bután",
			"fr": "Bhoutan",
			"hi": "भूटान",
			"ja": "ブータン",
			"ko": "부탄",
			"pt": "Butão",
			"ru": "Бутан",
			"tr": "Butan",
			"zh": "不丹"
		},
		"countryCode": "BT",
		"visaCode": "25",
		"states": [
			"Bumthang",
			"Chhukha",
			"Dagana",
			"Gasa",
			"Haa",
			"Lhuntse",
			"Mongar",
			"Paro",
			"Pemagatshel",
			"Punakha",
			"Samdrup Jongkhar",
			"Samtse",
			"Sarpang",
			"Thimphu",
			"Trashigang",
			"Trashiyangtse",
			"Trongsa",
			"Tsirang",
			"Wangdue Phodrang",
			"Zhemgang"
		]
	},
	{
		"currency": "BOB",
		"callingCode": "591",
		"region": "Americas",
		"subregion": "South America",
		"slug": "bolivia",
		"name": {
			"common": "Bolivia",
			"ar": "بوليفيا",
			"de": "Bolivien",
			"en": "Bolivia",
			"es": "Bolivia",
			"fr": "Bolivie",
			"hi": "बोलिविया",
			"ja": "ボリビア",
			"ko": "볼리비아",
			"pt": "Bolívia",
			"ru": "Боливия",
			"tr": "Bolivya",
			"zh": "玻利维亚"
		},
		"countryCode": "BO",
		"visaCode": "26",
		"states": [
			"Beni",
			"Chuquisaca",
			"Cochabamba",
			"La Paz",
			"Oruro",
			"Pando",
			"Potosí",
			"Santa Cruz",
			"Tarija"
		]
	},
	{
		"currency": "BAM",
		"callingCode": "387",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "bosnia-and-herzegovina",
		"name": {
			"common": "Bosnia and Herzegovina",
			"ar": "البوسنة والهرسك",
			"de": "Bosnien und Herzegowina",
			"en": "Bosnia and Herzegovina",
			"es": "Bosnia y Herzegovina",
			"fr": "Bosnie-Herzégovine",
			"hi": "बोस्निया और हर्ज़ेगोविना",
			"ja": "ボスニア・ヘルツェゴビナ",
			"ko": "보스니아 헤르체고비나",
			"pt": "Bósnia e Herzegovina",
			"ru": "Босния и Герцеговина",
			"tr": "Bosna Hersek",
			"zh": "波斯尼亚和黑塞哥维那"
		},
		"countryCode": "BA",
		"visaCode": "27",
		"states": ["Brčko Distrikt", "Federacija Bosne i Hercegovine", "Republika Srpska"]
	},
	{
		"currency": "BWP",
		"callingCode": "267",
		"region": "Africa",
		"subregion": "Southern Africa",
		"slug": "botswana",
		"name": {
			"common": "Botswana",
			"ar": "بوتسوانا",
			"de": "Botswana",
			"en": "Botswana",
			"es": "Botsuana",
			"fr": "Botswana",
			"hi": "बोत्सवाना",
			"ja": "ボツワナ",
			"ko": "보츠와나",
			"pt": "Botsuana",
			"ru": "Ботсвана",
			"tr": "Botsvana",
			"zh": "博茨瓦纳"
		},
		"countryCode": "BW",
		"visaCode": "28",
		"states": [
			"Central",
			"Ghanzi",
			"Kgalagadi",
			"Kgatleng",
			"Kweneng",
			"North West",
			"North-East",
			"South East",
			"Southern"
		]
	},
	{
		"currency": "NOK",
		"region": "Antarctic",
		"subregion": "",
		"slug": "bouvet-island",
		"name": {
			"common": "Bouvet Island",
			"ar": "جزيرة بوفيه",
			"de": "Bouvetinsel",
			"en": "Bouvet Island",
			"es": "Isla Bouvet",
			"fr": "Île Bouvet",
			"hi": "बोवेट द्वीप",
			"ja": "ブーベ島",
			"ko": "부베 섬",
			"pt": "Ilha Bouvet",
			"ru": "Остров Буве",
			"tr": "Bouvet Adası",
			"zh": "布韦岛"
		},
		"countryCode": "BV",
		"visaCode": "29",
		"states": ["Bouvet Island"]
	},
	{
		"currency": "BRL",
		"callingCode": "55",
		"region": "Americas",
		"subregion": "South America",
		"slug": "brazil",
		"name": {
			"common": "Brazil",
			"ar": "البرازيل",
			"de": "Brasilien",
			"en": "Brazil",
			"es": "Brasil",
			"fr": "Brésil",
			"hi": "ब्राज़ील",
			"ja": "ブラジル",
			"ko": "브라질",
			"pt": "Brasil",
			"ru": "Бразилия",
			"tr": "Brezilya",
			"zh": "巴西"
		},
		"countryCode": "BR",
		"visaCode": "30",
		"states": [
			"Acre",
			"Alagoas",
			"Amapá",
			"Amazonas",
			"Bahia",
			"Ceará",
			"Distrito Federal",
			"Espírito Santo",
			"Goiás",
			"Maranhão",
			"Mato Grosso",
			"Mato Grosso do Sul",
			"Minas Gerais",
			"Pará",
			"Paraíba",
			"Paraná",
			"Pernambuco",
			"Piauí",
			"Rio de Janeiro",
			"Rio Grande do Norte",
			"Rio Grande do Sul",
			"Rondônia",
			"Roraima",
			"Santa Catarina",
			"São Paulo",
			"Sergipe",
			"Tocantins"
		]
	},
	{
		"currency": "USD",
		"callingCode": "246",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "british-indian-ocean-territory",
		"name": {
			"common": "British Indian Ocean Territory",
			"ar": "إقليم المحيط الهندي البريطاني",
			"de": "Britisches Territorium im Indischen Ozean",
			"en": "British Indian Ocean Territory",
			"es": "Territorio Británico del Océano Índico",
			"fr": "Territoire britannique de l'océan Indien",
			"hi": "ब्रिटिश हिंद महासागर क्षेत्र",
			"ja": "イギリス領インド洋地域",
			"ko": "영국령 인도양 지역",
			"pt": "Território Britânico do Oceano Índico",
			"ru": "Британская территория в Индийском океане",
			"tr": "Britanya Hint Okyanusu Toprakları",
			"zh": "英属印度洋领地"
		},
		"countryCode": "IO",
		"visaCode": "31",
		"states": ["British Indian Ocean Territory"]
	},
	{
		"currency": "USD",
		"callingCode": "1284",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "british-virgin-islands",
		"name": {
			"common": "British Virgin Islands",
			"ar": "جزر العذراء البريطانية",
			"de": "Britische Jungferninseln",
			"en": "British Virgin Islands",
			"es": "Islas Vírgenes Británicas",
			"fr": "Îles Vierges britanniques",
			"hi": "ब्रिटिश वर्जिन द्वीपसमूह",
			"ja": "イギリス領ヴァージン諸島",
			"ko": "영국령 버진아일랜드",
			"pt": "Ilhas Virgens Britânicas",
			"ru": "Британские Виргинские острова",
			"tr": "Britanya Virjin Adaları",
			"zh": "英属维尔京群岛"
		},
		"countryCode": "VG",
		"visaCode": "241",
		"states": ["Anegada", "Jost Van Dyke", "Tortola", "Virgin Gorda"]
	},
	{
		"currency": "BND",
		"callingCode": "673",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "brunei",
		"name": {
			"common": "Brunei",
			"ar": "بروناي",
			"de": "Brunei",
			"en": "Brunei",
			"es": "Brunéi",
			"fr": "Brunei",
			"hi": "ब्रुनेई",
			"ja": "ブルネイ",
			"ko": "브루나이",
			"pt": "Brunei",
			"ru": "Бруней",
			"tr": "Brunei",
			"zh": "文莱"
		},
		"countryCode": "BN",
		"visaCode": "32",
		"states": ["Belait", "Brunei Muara", "Temburong", "Tutong"]
	},
	{
		"currency": "BGN",
		"callingCode": "359",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "bulgaria",
		"name": {
			"common": "Bulgaria",
			"ar": "بلغاريا",
			"de": "Bulgarien",
			"en": "Bulgaria",
			"es": "Bulgaria",
			"fr": "Bulgarie",
			"hi": "बुल्गारिया",
			"ja": "ブルガリア",
			"ko": "불가리아",
			"pt": "Bulgária",
			"ru": "Болгария",
			"tr": "Bulgaristan",
			"zh": "保加利亚"
		},
		"countryCode": "BG",
		"visaCode": "33",
		"states": [
			"Blagoevgrad",
			"Burgas",
			"Dobrich",
			"Gabrovo",
			"Jambol",
			"Khaskovo",
			"Kjustendil",
			"Kurdzhali",
			"Lovech",
			"Montana",
			"Pazardzhik",
			"Pernik",
			"Pleven",
			"Plovdiv",
			"Razgrad",
			"Ruse",
			"Shumen",
			"Silistra",
			"Sliven",
			"Smoljan",
			"Sofija",
			"Sofija-Grad",
			"Stara Zagora",
			"Turgovishhe",
			"Varna",
			"Veliko Turnovo",
			"Vidin",
			"Vraca"
		]
	},
	{
		"currency": "XOF",
		"callingCode": "226",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "burkina-faso",
		"name": {
			"common": "Burkina Faso",
			"ar": "بوركينا فاسو",
			"de": "Burkina Faso",
			"en": "Burkina Faso",
			"es": "Burkina Faso",
			"fr": "Burkina Faso",
			"hi": "बुर्किना फासो",
			"ja": "ブルキナファソ",
			"ko": "부르키나파소",
			"pt": "Burquina Faso",
			"ru": "Буркина-Фасо",
			"tr": "Burkina Faso",
			"zh": "布基纳法索"
		},
		"countryCode": "BF",
		"visaCode": "34",
		"states": [
			"Balé",
			"Bam/Lake Bam",
			"Banwa Province",
			"Bazèga",
			"Bougouriba",
			"Boulgou Province",
			"Boulkiemdé",
			"Comoé/Komoe",
			"Ganzourgou Province",
			"Gnagna",
			"Gourma Province",
			"Houet",
			"Ioba",
			"Kadiogo",
			"Kénédougou",
			"Komondjari",
			"Kompienga",
			"Kossi Province",
			"Koulpélogo",
			"Kouritenga",
			"Kourwéogo",
			"Léraba",
			"Loroum",
			"Mouhoun",
			"Namentenga",
			"Naouri/Nahouri",
			"Nayala",
			"Noumbiel",
			"Oubritenga",
			"Oudalan",
			"Passoré",
			"Poni",
			"Sanguié",
			"Sanmatenga",
			"Séno",
			"Sissili",
			"Soum",
			"Sourou",
			"Tapoa",
			"Tui/Tuy",
			"Yagha",
			"Yatenga",
			"Ziro",
			"Zondoma",
			"Zoundwéogo"
		]
	},
	{
		"currency": "BIF",
		"callingCode": "257",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "burundi",
		"name": {
			"common": "Burundi",
			"ar": "بوروندي",
			"de": "Burundi",
			"en": "Burundi",
			"es": "Burundi",
			"fr": "Burundi",
			"hi": "बुरुंडी",
			"ja": "ブルンジ",
			"ko": "부룬디",
			"pt": "Burundi",
			"ru": "Бурунди",
			"tr": "Burundi",
			"zh": "布隆迪"
		},
		"countryCode": "BI",
		"visaCode": "35",
		"states": [
			"Bubanza",
			"Bujumbura Mairie",
			"Bujumbura Rural",
			"Bururi",
			"Cankuzo",
			"Cibitoke",
			"Gitega",
			"Karuzi",
			"Kayanza",
			"Kirundo",
			"Makamba",
			"Muramvya",
			"Muyinga",
			"Mwaro",
			"Ngozi",
			"Rutana",
			"Ruyigi"
		]
	},
	{
		"currency": "KHR",
		"callingCode": "855",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "cambodia",
		"name": {
			"common": "Cambodia",
			"ar": "كمبوديا",
			"de": "Kambodscha",
			"en": "Cambodia",
			"es": "Camboya",
			"fr": "Cambodge",
			"hi": "कंबोडिया",
			"ja": "カンボジア",
			"ko": "캄보디아",
			"pt": "Camboja",
			"ru": "Камбоджа",
			"tr": "Kamboçya",
			"zh": "柬埔寨"
		},
		"countryCode": "KH",
		"visaCode": "36",
		"states": [
			"Baat Dambang",
			"Banteay Mean Chey",
			"Kampong Chaam",
			"Kampong Chhnang",
			"Kampong Spueu",
			"Kampong Thum",
			"Kampot",
			"Kandaal",
			"Kaoh Kong",
			"Kracheh",
			"Krong Kaeb",
			"Krong Pailin",
			"Krong Preah Sihanouk",
			"Mondol Kiri",
			"Otdar Mean Chey",
			"Phnom Penh",
			"Pousaat",
			"Preah Vihear",
			"Prey Veaeng",
			"Rotanah Kiri",
			"Siem Reab",
			"Stueng Treng",
			"Svaay Rieng",
			"Taakaev",
			"Tbong Khmum"
		]
	},
	{
		"currency": "XAF",
		"callingCode": "237",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "cameroon",
		"name": {
			"common": "Cameroon",
			"ar": "الكاميرون",
			"de": "Kamerun",
			"en": "Cameroon",
			"es": "Camerún",
			"fr": "Cameroun",
			"hi": "कैमरून",
			"ja": "カメルーン",
			"ko": "카메룬",
			"pt": "Camarões",
			"ru": "Камерун",
			"tr": "Kamerun",
			"zh": "喀麦隆"
		},
		"countryCode": "CM",
		"visaCode": "37",
		"states": [
			"Adamaoua",
			"Centre",
			"Est",
			"Extrême-Nord",
			"Littoral",
			"Nord",
			"Nord-Ouest",
			"Ouest",
			"Sud",
			"Sud-Ouest"
		]
	},
	{
		"currency": "CAD",
		"callingCode": "1",
		"region": "Americas",
		"subregion": "North America",
		"slug": "canada",
		"name": {
			"common": "Canada",
			"ar": "كندا",
			"de": "Kanada",
			"en": "Canada",
			"es": "Canadá",
			"fr": "Canada",
			"hi": "कनाडा",
			"ja": "カナダ",
			"ko": "캐나다",
			"pt": "Canadá",
			"ru": "Канада",
			"tr": "Kanada",
			"zh": "加拿大"
		},
		"countryCode": "CA",
		"visaCode": "38",
		"states": [
			"Alberta",
			"British Columbia",
			"Manitoba",
			"New Brunswick",
			"Newfoundland and Labrador",
			"Northwest Territories",
			"Nova Scotia",
			"Nunavut",
			"Ontario",
			"Prince Edward Island",
			"Quebec",
			"Saskatchewan",
			"Yukon"
		]
	},
	{
		"currency": "CVE",
		"callingCode": "238",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "cape-verde",
		"name": {
			"common": "Cape Verde",
			"ar": "الرأس الأخضر",
			"de": "Kap Verde",
			"en": "Cape Verde",
			"es": "Cabo Verde",
			"fr": "Cap-Vert",
			"hi": "केप वर्ड",
			"ja": "カーボベルデ",
			"ko": "카보베르데",
			"pt": "Cabo Verde",
			"ru": "Кабо-Верде",
			"tr": "Yeşil Burun Adaları",
			"zh": "佛得角"
		},
		"countryCode": "CV",
		"visaCode": "39",
		"states": [
			"Boa Vista",
			"Brava",
			"Calheta de São Miguel",
			"Maio",
			"Mosteiros",
			"Paúl",
			"Porto Novo",
			"Praia",
			"Ribeira Brava",
			"Ribeira Grande",
			"Sal",
			"Santa Catarina",
			"Santa Cruz",
			"São Domingos",
			"São Filipe",
			"São Nicolau",
			"São Vicente",
			"Tarrafal",
			"Tarrafal de São Nicolau"
		]
	},
	{
		"currency": "USD",
		"callingCode": "599",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "caribbean-netherlands",
		"name": {
			"common": "Caribbean Netherlands",
			"ar": "الجزر الكاريبية الهولندية",
			"de": "Karibische Niederlande",
			"en": "Caribbean Netherlands",
			"es": "Caribe Neerlandés",
			"fr": "Pays-Bas caribéens",
			"hi": "कैरेबियाई नीदरलैंड",
			"ja": "カリブ・オランダ",
			"ko": "카리브 네덜란드",
			"pt": "Países Baixos Caribenhos",
			"ru": "Карибские Нидерланды",
			"tr": "Karayip Hollandası",
			"zh": "荷属加勒比区"
		},
		"countryCode": "BQ",
		"visaCode": "158",
		"states": ["Bonaire", "Saba Isand", "Sint Eustatius"]
	},
	{
		"currency": "KYD",
		"callingCode": "1345",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "cayman-islands",
		"name": {
			"common": "Cayman Islands",
			"ar": "جزر كايمان",
			"de": "Kaimaninseln",
			"en": "Cayman Islands",
			"es": "Islas Caimán",
			"fr": "Îles Caïmans",
			"hi": "केमैन द्वीप",
			"ja": "ケイマン諸島",
			"ko": "케이맨 제도",
			"pt": "Ilhas Caimã",
			"ru": "Каймановы острова",
			"tr": "Cayman Adaları",
			"zh": "开曼群岛"
		},
		"countryCode": "KY",
		"visaCode": "40",
		"states": [
			"Bodden Town",
			"East End",
			"George Town",
			"North Side",
			"Sister Islands",
			"West Bay"
		]
	},
	{
		"currency": "XAF",
		"callingCode": "236",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "central-african-republic",
		"name": {
			"common": "Central African Republic",
			"ar": "جمهورية أفريقيا الوسطى",
			"de": "Zentralafrikanische Republik",
			"en": "Central African Republic",
			"es": "República Centroafricana",
			"fr": "République centrafricaine",
			"hi": "मध्य अफ्रीकी गणराज्य",
			"ja": "中央アフリカ共和国",
			"ko": "중앙아프리카 공화국",
			"pt": "República Centro-Africana",
			"ru": "Центральноафриканская Республика",
			"tr": "Orta Afrika Cumhuriyeti",
			"zh": "中非共和国"
		},
		"countryCode": "CF",
		"visaCode": "41",
		"states": [
			"Bamingui-Bangoran",
			"Bangui",
			"Basse-Kotto",
			"Haute-Kotto",
			"Haut-Mbomou",
			"Kémo",
			"Lobaye",
			"Mambéré-Kadéï",
			"Mbomou",
			"Nana-Grebizi",
			"Nana-Mambéré",
			"Ombella-M'Poko",
			"Ouaka",
			"Ouham",
			"Ouham Péndé",
			"Sangha-Mbaéré",
			"Vakaga"
		]
	},
	{
		"currency": "XAF",
		"callingCode": "235",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "chad",
		"name": {
			"common": "Chad",
			"ar": "تشاد",
			"de": "Tschad",
			"en": "Chad",
			"es": "Chad",
			"fr": "Tchad",
			"hi": "चाड",
			"ja": "チャド",
			"ko": "차드",
			"pt": "Chade",
			"ru": "Чад",
			"tr": "Çad",
			"zh": "乍得"
		},
		"countryCode": "TD",
		"visaCode": "42",
		"states": [
			"Bahr el Ghazal",
			"Batha",
			"Borkou",
			"Chari-Baguirmi",
			"Ennedi-Est",
			"Ennedi-Ouest",
			"Guéra",
			"Hadjer Lamis",
			"Kanem",
			"Lac",
			"Logone Occidental",
			"Logone Oriental",
			"Mondoul",
			"Mayo-Kébbi-Est",
			"Moyen-Chari",
			"Ouaddai",
			"Salamat",
			"Sila",
			"Tandjilé",
			"Tibesti",
			"Ville de Ndjamena",
			"Wadi Fira"
		]
	},
	{
		"currency": "CLP",
		"callingCode": "56",
		"region": "Americas",
		"subregion": "South America",
		"slug": "chile",
		"name": {
			"common": "Chile",
			"ar": "تشيلي",
			"de": "Chile",
			"en": "Chile",
			"es": "Chile",
			"fr": "Chili",
			"hi": "चिली",
			"ja": "チリ",
			"ko": "칠레",
			"pt": "Chile",
			"ru": "Чили",
			"tr": "Şili",
			"zh": "智利"
		},
		"countryCode": "CL",
		"visaCode": "43",
		"states": [
			"Aisén del General Carlos Ibáñez del Campo",
			"Antofagasta",
			"Araucanía",
			"Arica y Parinacota",
			"Atacama",
			"Bío-Bío",
			"Coquimbo",
			"Libertador General Bernardo O'Higgins",
			"Los Lagos",
			"Los Ríos",
			"Magallanes y Antartica Chilena",
			"Marga-Marga",
			"Maule",
			"Ñuble",
			"Región Metropolitana de Santiago",
			"Tarapacá",
			"Valparaíso"
		]
	},
	{
		"currency": "CNY",
		"callingCode": "86",
		"region": "Asia",
		"subregion": "Eastern Asia",
		"slug": "china",
		"name": {
			"common": "China",
			"ar": "الصين",
			"de": "China",
			"en": "China",
			"es": "China",
			"fr": "Chine",
			"hi": "चीन",
			"ja": "中国",
			"ko": "중국",
			"pt": "China",
			"ru": "Китай",
			"tr": "Çin",
			"zh": "中国"
		},
		"countryCode": "CN",
		"states": [
			"Anhui",
			"Beijing",
			"Chongqing",
			"Fujian",
			"Gansu",
			"Guangdong",
			"Guangxi",
			"Guizhou",
			"Hainan",
			"Hebei",
			"Heilongjiang",
			"Henan",
			"Hong Kong",
			"Hubei",
			"Hunan",
			"Inner Mongolia",
			"Jiangsu",
			"Jiangxi",
			"Jilin",
			"Liaoning",
			"Macau",
			"Ningxia",
			"Qinghai",
			"Shaanxi",
			"Shandong",
			"Shanghai",
			"Shanxi",
			"Sichuan",
			"Tianjin",
			"Tibet",
			"Xinjiang",
			"Yunnan",
			"Zhejiang"
		]
	},
	{
		"currency": "AUD",
		"callingCode": "61",
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"slug": "christmas-island",
		"name": {
			"common": "Christmas Island",
			"ar": "جزيرة عيد الميلاد",
			"de": "Weihnachtsinsel",
			"en": "Christmas Island",
			"es": "Isla de Navidad",
			"fr": "Île Christmas",
			"hi": "क्रिसमस द्वीप",
			"ja": "クリスマス島",
			"ko": "크리스마스섬",
			"pt": "Ilha do Natal",
			"ru": "Остров Рождества",
			"tr": "Christmas Adası",
			"zh": "圣诞岛"
		},
		"countryCode": "CX",
		"visaCode": "45",
		"states": ["Christmas Island"]
	},
	{
		"currency": "AUD",
		"callingCode": "61",
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"slug": "cocos-keeling-islands",
		"name": {
			"common": "Cocos (Keeling) Islands",
			"ar": "جزر كوكوس (كيلينغ)",
			"de": "Kokosinseln",
			"en": "Cocos (Keeling) Islands",
			"es": "Islas Cocos o Islas Keeling",
			"fr": "Îles Cocos",
			"hi": "कोकोस (कीलिंग) द्वीप",
			"ja": "ココス（キーリング）諸島",
			"ko": "코코스 제도",
			"pt": "Ilhas Cocos (Keeling)",
			"ru": "Кокосовые острова",
			"tr": "Cocos Adaları",
			"zh": "科科斯（基林）群岛"
		},
		"countryCode": "CC",
		"visaCode": "46",
		"states": [
			"Direction Island",
			"Home Island",
			"Horsburgh Island",
			"North Keeling Island",
			"South Island",
			"West Island"
		]
	},
	{
		"currency": "COP",
		"callingCode": "57",
		"region": "Americas",
		"subregion": "South America",
		"slug": "colombia",
		"name": {
			"common": "Colombia",
			"ar": "كولومبيا",
			"de": "Kolumbien",
			"en": "Colombia",
			"es": "Colombia",
			"fr": "Colombie",
			"hi": "कोलंबिया",
			"ja": "コロンビア",
			"ko": "콜롬비아",
			"pt": "Colômbia",
			"ru": "Колумбия",
			"tr": "Kolombiya",
			"zh": "哥伦比亚"
		},
		"countryCode": "CO",
		"visaCode": "47",
		"states": [
			"Amazonas",
			"Antioquia",
			"Arauca",
			"Archipiélago de San Andrés",
			"Atlántico",
			"Bogotá D.C.",
			"Bolívar",
			"Boyacá",
			"Caldas",
			"Caquetá",
			"Casanare",
			"Cauca",
			"Cesar",
			"Chocó",
			"Córdoba",
			"Cundinamarca",
			"Guainía",
			"Guaviare",
			"Huila",
			"La Guajira",
			"Magdalena",
			"Meta",
			"Nariño",
			"Norte de Santander",
			"Putumayo",
			"Quindío",
			"Risaralda",
			"Santander",
			"Sucre",
			"Tolima",
			"Valle del Cauca",
			"Vaupés",
			"Vichada"
		]
	},
	{
		"currency": "KMF",
		"callingCode": "269",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "comoros",
		"name": {
			"common": "Comoros",
			"ar": "جزر القمر",
			"de": "Komoren",
			"en": "Comoros",
			"es": "Comoras",
			"fr": "Comores",
			"hi": "कोमोरोस",
			"ja": "コモロ",
			"ko": "코모로",
			"pt": "Comores",
			"ru": "Коморы",
			"tr": "Komorlar",
			"zh": "科摩罗"
		},
		"countryCode": "KM",
		"visaCode": "48",
		"states": ["Andjazîdja", "Andjouân", "Moûhîlî"]
	},
	{
		"currency": "CKD",
		"callingCode": "682",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "cook-islands",
		"name": {
			"common": "Cook Islands",
			"ar": "جزر كوك",
			"de": "Cookinseln",
			"en": "Cook Islands",
			"es": "Islas Cook",
			"fr": "Îles Cook",
			"hi": "कुक द्वीपसमूह",
			"ja": "クック諸島",
			"ko": "쿡 제도",
			"pt": "Ilhas Cook",
			"ru": "Острова Кука",
			"tr": "Cook Adaları",
			"zh": "库克群岛"
		},
		"countryCode": "CK",
		"visaCode": "51",
		"states": [
			"Aitutaki",
			"Atiu",
			"Avarua",
			"Mangaia",
			"Manihiki",
			"Ma'uke",
			"Mitiaro",
			"Nassau",
			"Palmerston",
			"Penrhyn",
			"Pukapuka",
			"Rakahanga"
		]
	},
	{
		"currency": "CRC",
		"callingCode": "506",
		"region": "Americas",
		"subregion": "Central America",
		"slug": "costa-rica",
		"name": {
			"common": "Costa Rica",
			"ar": "كوستاريكا",
			"de": "Costa Rica",
			"en": "Costa Rica",
			"es": "Costa Rica",
			"fr": "Costa Rica",
			"hi": "कोस्टा रिका",
			"ja": "コスタリカ",
			"ko": "코스타리카",
			"pt": "Costa Rica",
			"ru": "Коста-Рика",
			"tr": "Kosta Rika",
			"zh": "哥斯达黎加"
		},
		"countryCode": "CR",
		"visaCode": "52",
		"states": [
			"Alajuela",
			"Cartago",
			"Guanacaste",
			"Heredia",
			"Limón",
			"Puntarenas",
			"San José"
		]
	},
	{
		"currency": "HRK",
		"callingCode": "385",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "croatia",
		"name": {
			"common": "Croatia",
			"ar": "كرواتيا",
			"de": "Kroatien",
			"en": "Croatia",
			"es": "Croacia",
			"fr": "Croatie",
			"hi": "क्रोएशिया",
			"ja": "クロアチア",
			"ko": "크로아티아",
			"pt": "Croácia",
			"ru": "Хорватия",
			"tr": "Hırvatistan",
			"zh": "克罗地亚"
		},
		"countryCode": "HR",
		"visaCode": "54",
		"states": [
			"Bjelovarsko-bilogorska županija",
			"Brodsko-posavska županija",
			"Dubrovačko-neretvanska županija",
			"Grad Zagreb",
			"Istarska županija",
			"Karlovačka županija",
			"Koprivničko-križevačka županija",
			"Krapinsko-zagorska županija",
			"Ličko-senjska županija",
			"Međimurska županija",
			"Osječko-baranjska županija",
			"Požeško-slavonska županija",
			"Primorsko-goranska županija",
			"Sisačko-moslavačka županija",
			"Splitsko-dalmatinska županija",
			"Šibensko-kninska županija",
			"Varaždinska županija",
			"Virovitičko-podravska županija",
			"Vukovarsko-srijemska županija",
			"Zadarska županija",
			"Zagrebačka županija"
		]
	},
	{
		"currency": "CUP",
		"callingCode": "53",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "cuba",
		"name": {
			"common": "Cuba",
			"ar": "كوبا",
			"de": "Kuba",
			"en": "Cuba",
			"es": "Cuba",
			"fr": "Cuba",
			"hi": "क्यूबा",
			"ja": "キューバ",
			"ko": "쿠바",
			"pt": "Cuba",
			"ru": "Куба",
			"tr": "Küba",
			"zh": "古巴"
		},
		"countryCode": "CU",
		"visaCode": "55",
		"states": [
			"Artemisa",
			"Camagüey",
			"Ciego de Ávila",
			"Cienfuegos",
			"Granma",
			"Guantánamo",
			"Holguín",
			"Isla de la Juventud",
			"La Habana",
			"Las Tunas",
			"Matanzas",
			"Mayabeque",
			"Pinar del Río",
			"Sancti Spíritus",
			"Santiago de Cuba",
			"Villa Clara"
		]
	},
	{
		"currency": "ANG",
		"callingCode": "5999",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "curacao",
		"name": {
			"common": "Curaçao",
			"ar": "كوراساو",
			"de": "Curaçao",
			"en": "Curaçao",
			"es": "Curazao",
			"fr": "Curaçao",
			"hi": "कुराकाओ",
			"ja": "キュラソー",
			"ko": "퀴라소",
			"pt": "Curaçao",
			"ru": "Кюрасао",
			"tr": "Curaçao",
			"zh": "库拉索"
		},
		"countryCode": "CW",
		"visaCode": "253",
		"states": ["Curaçao"]
	},
	{
		"currency": "EUR",
		"callingCode": "357",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "cyprus",
		"name": {
			"common": "Cyprus",
			"ar": "قبرص",
			"de": "Zypern",
			"en": "Cyprus",
			"es": "Chipre",
			"fr": "Chypre",
			"hi": "साइप्रस",
			"ja": "キプロス",
			"ko": "키프로스",
			"pt": "Chipre",
			"ru": "Кипр",
			"tr": "Kıbrıs",
			"zh": "塞浦路斯"
		},
		"countryCode": "CY",
		"visaCode": "56",
		"states": ["Ammochostos", "Keryneia", "Larnaka", "Lefkosia", "Lemesos", "Pafos"]
	},
	{
		"currency": "CZK",
		"callingCode": "420",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "czechia",
		"name": {
			"common": "Czechia",
			"ar": "جمهورية التشيك",
			"de": "Tschechien",
			"en": "Czechia",
			"es": "Chequia",
			"fr": "Tchéquie",
			"hi": "चेकिया",
			"ja": "チェコ",
			"ko": "체코",
			"pt": "Chéquia",
			"ru": "Чехия",
			"tr": "Çekya",
			"zh": "捷克"
		},
		"countryCode": "CZ",
		"visaCode": "57",
		"states": [
			"Hlavní město Praha",
			"Jihočeský kraj",
			"Jihomoravský kraj",
			"Karlovarský kraj",
			"Královéhradecký kraj",
			"Liberecký kraj",
			"Moravskoslezský kraj",
			"Olomoucký kraj",
			"Pardubický kraj",
			"Plzeňský kraj",
			"Středočeský kraj",
			"Ústecký kraj",
			"Vysočina",
			"Zlínský kraj"
		]
	},
	{
		"currency": "CDF",
		"callingCode": "243",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "dr-congo",
		"name": {
			"common": "DR Congo",
			"ar": "جمهورية الكونغو الديمقراطية",
			"de": "Kongo (DR)",
			"en": "DR Congo",
			"es": "República Democrática del Congo",
			"fr": "République démocratique du Congo",
			"hi": "डीआर कांगो",
			"ja": "コンゴ民主共和国",
			"ko": "콩고 민주 공화국",
			"pt": "RD Congo",
			"ru": "ДР Конго",
			"tr": "Kongo Demokratik Cumhuriyeti",
			"zh": "刚果民主共和国"
		},
		"countryCode": "CD",
		"visaCode": "12",
		"states": [
			"Bandundu",
			"Bas-Congo",
			"Équateur",
			"Kasaï-Occidental",
			"Kasaï-Oriental",
			"Katanga",
			"Kinshasa",
			"Maniema",
			"Nord-Kivu",
			"Orientale",
			"Sud-Kivu"
		]
	},
	{
		"currency": "DKK",
		"callingCode": "45",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "denmark",
		"name": {
			"common": "Denmark",
			"ar": "الدنمارك",
			"de": "Dänemark",
			"en": "Denmark",
			"es": "Dinamarca",
			"fr": "Danemark",
			"hi": "डेनमार्क",
			"ja": "デンマーク",
			"ko": "덴마크",
			"pt": "Dinamarca",
			"ru": "Дания",
			"tr": "Danimarka",
			"zh": "丹麦"
		},
		"countryCode": "DK",
		"visaCode": "58",
		"states": ["Hovedstaden", "Midtjylland", "Nordjylland", "Sjælland", "Syddanmark"]
	},
	{
		"currency": "DJF",
		"callingCode": "253",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "djibouti",
		"name": {
			"common": "Djibouti",
			"ar": "جيبوتي",
			"de": "Dschibuti",
			"en": "Djibouti",
			"es": "Yibuti",
			"fr": "Djibouti",
			"hi": "जिबूती",
			"ja": "ジブチ",
			"ko": "지부티",
			"pt": "Djibouti",
			"ru": "Джибути",
			"tr": "Cibuti",
			"zh": "吉布提"
		},
		"countryCode": "DJ",
		"visaCode": "59",
		"states": ["Ali Sabieh", "Arta", "Dikhil", "Obock", "Tadjourah"]
	},
	{
		"currency": "XCD",
		"callingCode": "1767",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "dominica",
		"name": {
			"common": "Dominica",
			"ar": "دومينيكا",
			"de": "Dominica",
			"en": "Dominica",
			"es": "Dominica",
			"fr": "Dominique",
			"hi": "डोमिनिका",
			"ja": "ドミニカ国",
			"ko": "도미니카 연방",
			"pt": "Dominica",
			"ru": "Доминика",
			"tr": "Dominika",
			"zh": "多米尼克"
		},
		"countryCode": "DM",
		"visaCode": "60",
		"states": [
			"Saint Andrew Parish",
			"Saint David Parish",
			"Saint George Parish",
			"Saint John Parish",
			"Saint Joseph Parish",
			"Saint Luke Parish",
			"Saint Mark Parish",
			"Saint Patrick Parish",
			"Saint Paul Parish",
			"Saint Peter Parish"
		]
	},
	{
		"currency": "DOP",
		"callingCode": "1809",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "dominican-republic",
		"name": {
			"common": "Dominican Republic",
			"ar": "جمهورية الدومينيكان",
			"de": "Dominikanische Republik",
			"en": "Dominican Republic",
			"es": "República Dominicana",
			"fr": "République dominicaine",
			"hi": "डोमिनिकन गणराज्य",
			"ja": "ドミニカ共和国",
			"ko": "도미니카 공화국",
			"pt": "República Dominicana",
			"ru": "Доминиканская Республика",
			"tr": "Dominik Cumhuriyeti",
			"zh": "多米尼加共和国"
		},
		"countryCode": "DO",
		"states": [
			"Cibao Central",
			"Del Valle",
			"Distrito Nacional",
			"Enriquillo",
			"Norcentral",
			"Nordeste",
			"Noroeste",
			"Norte",
			"Valdesia"
		]
	},
	{
		"currency": "USD",
		"callingCode": "593",
		"region": "Americas",
		"subregion": "South America",
		"slug": "ecuador",
		"name": {
			"common": "Ecuador",
			"ar": "الإكوادور",
			"de": "Ecuador",
			"en": "Ecuador",
			"es": "Ecuador",
			"fr": "Équateur",
			"hi": "इक्वाडोर",
			"ja": "エクアドル",
			"ko": "에콰도르",
			"pt": "Equador",
			"ru": "Эквадор",
			"tr": "Ekvador",
			"zh": "厄瓜多尔"
		},
		"countryCode": "EC",
		"visaCode": "63",
		"states": [
			"Azuay",
			"Bolívar",
			"Cañar",
			"Carchi",
			"Chimborazo",
			"Cotopaxi",
			"El Oro",
			"Esmeraldas",
			"Galápagos",
			"Guayas",
			"Imbabura",
			"Loja",
			"Los Ríos",
			"Manabí",
			"Morona-Santiago",
			"Napo",
			"Orellana",
			"Pastaza",
			"Pichincha",
			"Santa Elena",
			"Santo Domingo de los Tsáchilas",
			"Sucumbíos",
			"Tungurahua",
			"Zamora-Chinchipe"
		]
	},
	{
		"currency": "EGP",
		"callingCode": "20",
		"region": "Africa",
		"subregion": "Northern Africa",
		"slug": "egypt",
		"name": {
			"common": "Egypt",
			"ar": "مصر",
			"de": "Ägypten",
			"en": "Egypt",
			"es": "Egipto",
			"fr": "Égypte",
			"hi": "मिस्र",
			"ja": "エジプト",
			"ko": "이집트",
			"pt": "Egito",
			"ru": "Египет",
			"tr": "Mısır",
			"zh": "埃及"
		},
		"countryCode": "EG",
		"visaCode": "64",
		"states": [
			"Alexandria",
			"Aswan",
			"Asyout",
			"Bani Sueif",
			"Beheira",
			"Cairo",
			"Daqahlia",
			"Dumiat",
			"El Bahr El Ahmar",
			"El Ismailia",
			"El Suez",
			"El Wadi El Gedeed",
			"Fayoum",
			"Gharbia",
			"Giza",
			"Helwan",
			"Kafr El Sheikh",
			"Luxor",
			"Matrouh",
			"Menia",
			"Menofia",
			"North Sinai",
			"Port Said",
			"Qalubia",
			"Qena",
			"Sharqia",
			"Sixth of October",
			"Sohag",
			"South Sinai"
		]
	},
	{
		"currency": "SVC",
		"callingCode": "503",
		"region": "Americas",
		"subregion": "Central America",
		"slug": "el-salvador",
		"name": {
			"common": "El Salvador",
			"ar": "السلفادور",
			"de": "El Salvador",
			"en": "El Salvador",
			"es": "El Salvador",
			"fr": "Salvador",
			"hi": "एल साल्वाडोर",
			"ja": "エルサルバドル",
			"ko": "엘살바도르",
			"pt": "El Salvador",
			"ru": "Сальвадор",
			"tr": "El Salvador",
			"zh": "萨尔瓦多"
		},
		"countryCode": "SV",
		"visaCode": "65",
		"states": [
			"Ahuachapán",
			"Cabañas",
			"Cuscatlán",
			"Chalatenango",
			"La Libertad",
			"La Paz",
			"La Unión",
			"Morazán",
			"San Miguel",
			"San Salvador",
			"Santa Ana",
			"San Vicente",
			"Sonsonate",
			"Usulután"
		]
	},
	{
		"currency": "XAF",
		"callingCode": "240",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "equatorial-guinea",
		"name": {
			"common": "Equatorial Guinea",
			"ar": "غينيا الاستوائية",
			"de": "Äquatorialguinea",
			"en": "Equatorial Guinea",
			"es": "Guinea Ecuatorial",
			"fr": "Guinée équatoriale",
			"hi": "इक्वेटोरियल गिनी",
			"ja": "赤道ギニア",
			"ko": "적도 기니",
			"pt": "Guiné Equatorial",
			"ru": "Экваториальная Гвинея",
			"tr": "Ekvator Ginesi",
			"zh": "赤道几内亚"
		},
		"countryCode": "GQ",
		"visaCode": "66",
		"states": [
			"Annobón",
			"Bioko Norte",
			"Bioko Sur",
			"Centro Sur",
			"Kié-Ntem",
			"Litoral",
			"Wele-Nzas"
		]
	},
	{
		"currency": "ERN",
		"callingCode": "291",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "eritrea",
		"name": {
			"common": "Eritrea",
			"ar": "إريتريا",
			"de": "Eritrea",
			"en": "Eritrea",
			"es": "Eritrea",
			"fr": "Érythrée",
			"hi": "इरिट्रिया",
			"ja": "エリトリア",
			"ko": "에리트레아",
			"pt": "Eritreia",
			"ru": "Эритрея",
			"tr": "Eritre",
			"zh": "厄立特里亚"
		},
		"countryCode": "ER",
		"visaCode": "67",
		"states": [
			"Anseba",
			"Debub",
			"Debub-Keih-Bahri",
			"Gash-Barka",
			"Maekel",
			"Semien-Keih-Bahri"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "372",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "estonia",
		"name": {
			"common": "Estonia",
			"ar": "إستونيا",
			"de": "Estland",
			"en": "Estonia",
			"es": "Estonia",
			"fr": "Estonie",
			"hi": "एस्टोनिया",
			"ja": "エストニア",
			"ko": "에스토니아",
			"pt": "Estónia",
			"ru": "Эстония",
			"tr": "Estonya",
			"zh": "爱沙尼亚"
		},
		"countryCode": "EE",
		"visaCode": "68",
		"states": [
			"Harjumaa (Tallinn)",
			"Hiiumaa (Kardla)",
			"Ida-Virumaa (Johvi)",
			"Järvamaa (Paide)",
			"Jõgevamaa (Jogeva)",
			"Läänemaa",
			"Lääne-Virumaa (Rakvere)",
			"Pärnumaa (Parnu)",
			"Põlvamaa (Polva)",
			"Raplamaa (Rapla)",
			"Saaremaa (Kuessaare)",
			"Tartumaa (Tartu)",
			"Valgamaa (Valga)",
			"Viljandimaa (Viljandi)",
			"Võrumaa (Voru)"
		]
	},
	{
		"currency": "SZL",
		"callingCode": "268",
		"region": "Africa",
		"subregion": "Southern Africa",
		"slug": "eswatini",
		"name": {
			"common": "Eswatini",
			"ar": "إسواتيني",
			"de": "Eswatini",
			"en": "Eswatini",
			"es": "Esuatini",
			"fr": "Eswatini",
			"hi": "इस्वातिनी",
			"ja": "エスワティニ",
			"ko": "에스와티니",
			"pt": "Essuatíni",
			"ru": "Эсватини",
			"tr": "Esvatini",
			"zh": "斯威士兰"
		},
		"countryCode": "SZ",
		"visaCode": "211",
		"states": ["Hhohho", "Lubombo", "Manzini", "Shiselweni"]
	},
	{
		"currency": "ETB",
		"callingCode": "251",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "ethiopia",
		"name": {
			"common": "Ethiopia",
			"ar": "إثيوبيا",
			"de": "Äthiopien",
			"en": "Ethiopia",
			"es": "Etiopía",
			"fr": "Éthiopie",
			"hi": "इथियोपिया",
			"ja": "エチオピア",
			"ko": "에티오피아",
			"pt": "Etiópia",
			"ru": "Эфиопия",
			"tr": "Etiyopya",
			"zh": "埃塞俄比亚"
		},
		"countryCode": "ET",
		"visaCode": "69",
		"states": [
			"Addis Ababa",
			"Afar",
			"Amhara",
			"Benshangul-Gumaz",
			"Dire Dawa",
			"Gambela",
			"Harari",
			"Oromia",
			"Somali",
			"Southern Nations Nationalities and People's Region",
			"Tigray"
		]
	},
	{
		"currency": "FKP",
		"callingCode": "500",
		"region": "Americas",
		"subregion": "South America",
		"slug": "falkland-islands",
		"name": {
			"common": "Falkland Islands",
			"ar": "جزر فوكلاند",
			"de": "Falklandinseln",
			"en": "Falkland Islands",
			"es": "Islas Malvinas",
			"fr": "Îles Malouines",
			"hi": "फ़ॉकलैंड द्वीप",
			"ja": "フォークランド（マルビナス）諸島",
			"ko": "포클랜드 제도",
			"pt": "Ilhas Malvinas",
			"ru": "Фолклендские острова",
			"tr": "Falkland Adaları",
			"zh": "福克兰群岛"
		},
		"countryCode": "FK",
		"visaCode": "70",
		"states": ["Falkland Islands (Islas Malvinas)"]
	},
	{
		"currency": "DKK",
		"callingCode": "298",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "faroe-islands",
		"name": {
			"common": "Faroe Islands",
			"ar": "جزر فارو",
			"de": "Färöer",
			"en": "Faroe Islands",
			"es": "Islas Feroe",
			"fr": "Îles Féroé",
			"hi": "फ़रो आइलैंड",
			"ja": "フェロー諸島",
			"ko": "페로 제도",
			"pt": "Ilhas Faroé",
			"ru": "Фарерские острова",
			"tr": "Faroe Adaları",
			"zh": "法罗群岛"
		},
		"countryCode": "FO",
		"visaCode": "71",
		"states": [
			"Bordoy",
			"Eysturoy",
			"Mykines",
			"Sandoy",
			"Skuvoy",
			"Streymoy",
			"Suduroy",
			"Tvoroyri",
			"Vagar"
		]
	},
	{
		"currency": "FJD",
		"callingCode": "679",
		"region": "Oceania",
		"subregion": "Melanesia",
		"slug": "fiji",
		"name": {
			"common": "Fiji",
			"ar": "فيجي",
			"de": "Fidschi",
			"en": "Fiji",
			"es": "Fiyi",
			"fr": "Fidji",
			"hi": "फ़िजी",
			"ja": "フィジー",
			"ko": "피지",
			"pt": "Fiji",
			"ru": "Фиджи",
			"tr": "Fiji",
			"zh": "斐济"
		},
		"countryCode": "FJ",
		"visaCode": "72",
		"states": [
			"Ba",
			"Bua",
			"Cakaudrove",
			"Kadavu",
			"Lau",
			"Lomaiviti",
			"Macuata",
			"Nadroga and Navosa",
			"Naitasiri",
			"Namosi",
			"Ra",
			"Rewa",
			"Rotuma",
			"Serua",
			"Tailevu"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "358",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "finland",
		"name": {
			"common": "Finland",
			"ar": "فنلندا",
			"de": "Finnland",
			"en": "Finland",
			"es": "Finlandia",
			"fr": "Finlande",
			"hi": "फ़िनलैंड",
			"ja": "フィンランド",
			"ko": "핀란드",
			"pt": "Finlândia",
			"ru": "Финляндия",
			"tr": "Finlandiya",
			"zh": "芬兰"
		},
		"countryCode": "FI",
		"visaCode": "73",
		"states": [
			"Ahvenanmaan maakunta",
			"Etelä-Karjala",
			"Etelä-Pohjanmaa",
			"Etelä-Savo",
			"Kainuu",
			"Kanta-Häme",
			"Keski-Pohjanmaa",
			"Keski-Suomi",
			"Kymenlaakso",
			"Lappi",
			"Pirkanmaa",
			"Pohjanmaa",
			"Pohjois-Karjala",
			"Pohjois-Pohjanmaa",
			"Pohjois-Savo",
			"Päijät-Häme",
			"Satakunta",
			"Uusimaa",
			"Varsinais-Suomi"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "33",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "france",
		"name": {
			"common": "France",
			"ar": "فرنسا",
			"de": "Frankreich",
			"en": "France",
			"es": "Francia",
			"fr": "France",
			"hi": "फ़्रांस",
			"ja": "フランス",
			"ko": "프랑스",
			"pt": "França",
			"ru": "Франция",
			"tr": "Fransa",
			"zh": "法国"
		},
		"countryCode": "FR",
		"visaCode": "74",
		"states": [
			"Auvergne-Rhône-Alpes",
			"Bourgogne-Franche-Comté",
			"Bretagne",
			"Centre-Val de Loire",
			"Corse",
			"Grand Est",
			"Hauts-de-France",
			"Île-de-France",
			"Normandie",
			"Nouvelle-Aquitaine",
			"Occitanie",
			"Pays de la Loire",
			"Provence-Alpes-Côte d'Azur",
			"Clipperton",
			"Guadeloupe",
			"Guyane",
			"Martinique",
			"Mayotte",
			"Nouvelle-Calédonie",
			"Polynésie",
			"Saint-Pierre-et-Miquelon",
			"Saint Barthélemy",
			"Saint Martin",
			"Réunion",
			"Terres Australes Françaises",
			"Wallis-et-Futuna"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "594",
		"region": "Americas",
		"subregion": "South America",
		"slug": "french-guiana",
		"name": {
			"common": "French Guiana",
			"ar": "غيانا الفرنسية",
			"de": "Französisch-Guayana",
			"en": "French Guiana",
			"es": "Guayana Francesa",
			"fr": "Guyane française",
			"hi": "फ़्रेंच गुयाना",
			"ja": "フランス領ギアナ",
			"ko": "프랑스령 기아나",
			"pt": "Guiana Francesa",
			"ru": "Французская Гвиана",
			"tr": "Fransız Guanası",
			"zh": "法属圭亚那"
		},
		"countryCode": "GF",
		"visaCode": "75",
		"states": ["French Guiana"]
	},
	{
		"currency": "XPF",
		"callingCode": "689",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "french-polynesia",
		"name": {
			"common": "French Polynesia",
			"ar": "بولينزيا الفرنسية",
			"de": "Französisch-Polynesien",
			"en": "French Polynesia",
			"es": "Polinesia Francesa",
			"fr": "Polynésie française",
			"hi": "फ्रेंच पोलिनेशिया",
			"ja": "フランス領ポリネシア",
			"ko": "프랑스령 폴리네시아",
			"pt": "Polinésia Francesa",
			"ru": "Французская Полинезия",
			"tr": "Fransız Polinezyası",
			"zh": "法属波利尼西亚"
		},
		"countryCode": "PF",
		"visaCode": "77",
		"states": [
			"Archipel des Marquises",
			"Archipel des Tuamotu",
			"Archipel des Tubuai",
			"Iles du Vent",
			"Iles Sous-le-Vent"
		]
	},
	{
		"currency": "EUR",
		"region": "Antarctic",
		"subregion": "",
		"slug": "french-southern-and-antarctic-lands",
		"name": {
			"common": "French Southern and Antarctic Lands",
			"ar": "أراض فرنسية جنوبية وأنتارتيكية",
			"de": "Französische Süd- und Antarktisgebiete",
			"en": "French Southern and Antarctic Lands",
			"es": "Tierras Australes y Antárticas Francesas",
			"fr": "Terres australes et antarctiques françaises",
			"hi": "फ्रांसीसी दक्षिणी और अंटार्कटिक भूमि",
			"ja": "フランス領南方・南極地域",
			"ko": "프랑스 남방 및 남극 지역",
			"pt": "Terras Austrais e Antárticas Francesas",
			"ru": "Французские Южные и Антарктические территории",
			"tr": "Fransız Güney ve Antarktika Toprakları",
			"zh": "法国南方和南极领地"
		},
		"countryCode": "TF",
		"visaCode": "78",
		"states": ["Adelie Land", "Ile Crozet", "Iles Kerguelen", "Iles Saint-Paul et Amsterdam"]
	},
	{
		"currency": "XAF",
		"callingCode": "241",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "gabon",
		"name": {
			"common": "Gabon",
			"ar": "الغابون",
			"de": "Gabun",
			"en": "Gabon",
			"es": "Gabón",
			"fr": "Gabon",
			"hi": "गैबोन",
			"ja": "ガボン",
			"ko": "가봉",
			"pt": "Gabão",
			"ru": "Габон",
			"tr": "Gabon",
			"zh": "加蓬"
		},
		"countryCode": "GA",
		"visaCode": "79",
		"states": [
			"Estuaire",
			"Haut-Ogooué",
			"Moyen-Ogooué",
			"Ngounié",
			"Nyanga",
			"Ogooué-Ivindo",
			"Ogooué-Lolo",
			"Ogooué-Maritime",
			"Woleu-Ntem"
		]
	},
	{
		"currency": "GMD",
		"callingCode": "220",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "gambia",
		"name": {
			"common": "Gambia",
			"ar": "غامبيا",
			"de": "Gambia",
			"en": "Gambia",
			"es": "Gambia",
			"fr": "Gambie",
			"hi": "गाम्बिया",
			"ja": "ガンビア",
			"ko": "감비아",
			"pt": "Gâmbia",
			"ru": "Гамбия",
			"tr": "Gambiya",
			"zh": "冈比亚"
		},
		"countryCode": "GM",
		"visaCode": "80",
		"states": ["Banjul", "Central River", "Lower River", "North Bank", "Upper River", "Western"]
	},
	{
		"currency": "GEL",
		"callingCode": "995",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "georgia",
		"name": {
			"common": "Georgia",
			"ar": "جورجيا",
			"de": "Georgien",
			"en": "Georgia",
			"es": "Georgia",
			"fr": "Géorgie",
			"hi": "जॉर्जिया",
			"ja": "ジョージア",
			"ko": "조지아",
			"pt": "Geórgia",
			"ru": "Грузия",
			"tr": "Gürcistan",
			"zh": "格鲁吉亚"
		},
		"countryCode": "GE",
		"visaCode": "81",
		"states": [
			"Abkhazia (Sokhumi)",
			"Ajaria (Bat'umi)",
			"Guria",
			"Imereti",
			"K'akheti",
			"Kvemo Kartli",
			"Mtshkheta-Mtianeti",
			"Rach'a-Lexhkumi-KvemoSvaneti",
			"Samegrelo-Zemo Svaneti",
			"Samtskhe-Javakheti",
			"Shida Kartli",
			"Tbilisi"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "49",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "germany",
		"name": {
			"common": "Germany",
			"ar": "ألمانيا",
			"de": "Deutschland",
			"en": "Germany",
			"es": "Alemania",
			"fr": "Allemagne",
			"hi": "जर्मनी",
			"ja": "ドイツ",
			"ko": "독일",
			"pt": "Alemanha",
			"ru": "Германия",
			"tr": "Almanya",
			"zh": "德国"
		},
		"countryCode": "DE",
		"visaCode": "82",
		"states": [
			"Baden-Württemberg",
			"Bayern",
			"Berlin",
			"Brandenburg",
			"Bremen",
			"Hamburg",
			"Hessen",
			"Mecklenburg-Vorpommern",
			"Niedersachsen",
			"Nordrhein-Westfalen",
			"Rheinland-Pfalz",
			"Saarland",
			"Sachsen",
			"Sachsen-Anhalt",
			"Schleswig-Holstein",
			"Thüringen"
		]
	},
	{
		"currency": "GHS",
		"callingCode": "233",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "ghana",
		"name": {
			"common": "Ghana",
			"ar": "غانا",
			"de": "Ghana",
			"en": "Ghana",
			"es": "Ghana",
			"fr": "Ghana",
			"hi": "घाना",
			"ja": "ガーナ",
			"ko": "가나",
			"pt": "Gana",
			"ru": "Гана",
			"tr": "Gana",
			"zh": "加纳"
		},
		"countryCode": "GH",
		"visaCode": "83",
		"states": [
			"Ahafo",
			"Ashanti",
			"Bono",
			"Bono East",
			"Central",
			"Eastern",
			"Greater Accra",
			"Northern",
			"North East",
			"Oti",
			"Savannah",
			"Upper East",
			"Upper West",
			"Volta",
			"Western",
			"Western North"
		]
	},
	{
		"currency": "GIP",
		"callingCode": "350",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "gibraltar",
		"name": {
			"common": "Gibraltar",
			"ar": "جبل طارق",
			"de": "Gibraltar",
			"en": "Gibraltar",
			"es": "Gibraltar",
			"fr": "Gibraltar",
			"hi": "जिब्राल्टर",
			"ja": "ジブラルタル",
			"ko": "지브롤터",
			"pt": "Gibraltar",
			"ru": "Гибралтар",
			"tr": "Cebelitarık",
			"zh": "直布罗陀"
		},
		"countryCode": "GI",
		"visaCode": "84",
		"states": ["Gibraltar"]
	},
	{
		"currency": "EUR",
		"callingCode": "30",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "greece",
		"name": {
			"common": "Greece",
			"ar": "اليونان",
			"de": "Griechenland",
			"en": "Greece",
			"es": "Grecia",
			"fr": "Grèce",
			"hi": "ग्रीस",
			"ja": "ギリシャ",
			"ko": "그리스",
			"pt": "Grécia",
			"ru": "Греция",
			"tr": "Yunanistan",
			"zh": "希腊"
		},
		"countryCode": "GR",
		"visaCode": "86",
		"states": [
			"Anatolikí Makedonía kai Thráki",
			"Attikḯ",
			"Dytikí Elláda",
			"Dytikí Makedonía",
			"Ionía Nísia",
			"Kentrikí Makedonía",
			"Krítí",
			"Notío Aigaío",
			"Peloponnísos",
			"Stereá Elláda",
			"Thessalía",
			"Voreío Aigaío",
			"Ípeiros",
			"Ágion Óros"
		]
	},
	{
		"currency": "DKK",
		"callingCode": "299",
		"region": "Americas",
		"subregion": "North America",
		"slug": "greenland",
		"name": {
			"common": "Greenland",
			"ar": "جرينلاند",
			"de": "Grönland",
			"en": "Greenland",
			"es": "Groenlandia",
			"fr": "Groenland",
			"hi": "ग्रीनलैंड",
			"ja": "グリーンランド",
			"ko": "그린란드",
			"pt": "Gronelândia",
			"ru": "Гренландия",
			"tr": "Grönland",
			"zh": "格陵兰"
		},
		"countryCode": "GL",
		"visaCode": "251",
		"states": [
			"Kommune Kujalleq",
			"Kommuneqarfik Sermersooq",
			"Qaasuitsup Kommunia",
			"Qeqqata Kommunia"
		]
	},
	{
		"currency": "XCD",
		"callingCode": "1473",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "grenada",
		"name": {
			"common": "Grenada",
			"ar": "غرينادا",
			"de": "Grenada",
			"en": "Grenada",
			"es": "Granada",
			"fr": "Grenade",
			"hi": "ग्रेनाडा",
			"ja": "グレナダ",
			"ko": "그레나다",
			"pt": "Granada",
			"ru": "Гренада",
			"tr": "Grenada",
			"zh": "格林纳达"
		},
		"countryCode": "GD",
		"visaCode": "88",
		"states": [
			"Saint Andrew",
			"Saint David",
			"Saint George",
			"Saint John",
			"Saint Mark",
			"Saint Patrick",
			"Southern Grenadine Islands"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "590",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "guadeloupe",
		"name": {
			"common": "Guadeloupe",
			"ar": "غوادلوب",
			"de": "Guadeloupe",
			"en": "Guadeloupe",
			"es": "Guadalupe",
			"fr": "Guadeloupe",
			"hi": "ग्वाडेलोप",
			"ja": "グアドループ",
			"ko": "과들루프",
			"pt": "Guadalupe",
			"ru": "Гваделупа",
			"tr": "Guadalupe",
			"zh": "瓜德罗普"
		},
		"countryCode": "GP",
		"visaCode": "89",
		"states": ["Guadeloupe"]
	},
	{
		"currency": "USD",
		"callingCode": "1671",
		"region": "Oceania",
		"subregion": "Micronesia",
		"slug": "guam",
		"name": {
			"common": "Guam",
			"ar": "غوام",
			"de": "Guam",
			"en": "Guam",
			"es": "Guam",
			"fr": "Guam",
			"hi": "गुआम",
			"ja": "グアム",
			"ko": "괌",
			"pt": "Guam",
			"ru": "Гуам",
			"tr": "Guam",
			"zh": "关岛"
		},
		"countryCode": "GU",
		"visaCode": "90",
		"states": ["Guam"]
	},
	{
		"currency": "GTQ",
		"callingCode": "502",
		"region": "Americas",
		"subregion": "Central America",
		"slug": "guatemala",
		"name": {
			"common": "Guatemala",
			"ar": "غواتيمالا",
			"de": "Guatemala",
			"en": "Guatemala",
			"es": "Guatemala",
			"fr": "Guatemala",
			"hi": "ग्वाटेमाला",
			"ja": "グアテマラ",
			"ko": "과테말라",
			"pt": "Guatemala",
			"ru": "Гватемала",
			"tr": "Guatemala",
			"zh": "危地马拉"
		},
		"countryCode": "GT",
		"visaCode": "91",
		"states": [
			"Alta Verapaz",
			"Baja Verapaz",
			"Chimaltenango",
			"Chiquimula",
			"El Progreso",
			"Escuintla",
			"Guatemala",
			"Huehuetenango",
			"Izabal",
			"Jalapa",
			"Jutiapa",
			"Petén",
			"Quetzaltenango",
			"Quiché",
			"Retalhuleu",
			"Sacatepéquez",
			"San Marcos",
			"Santa Rosa",
			"Sololá",
			"Suchitepéquez",
			"Totonicapán",
			"Zacapa"
		]
	},
	{
		"currency": "GBP",
		"callingCode": "44",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "guernsey",
		"name": {
			"common": "Guernsey",
			"ar": "غيرنزي",
			"de": "Guernsey",
			"en": "Guernsey",
			"es": "Guernsey",
			"fr": "Guernesey",
			"hi": "ग्वेर्नसे",
			"ja": "ガーンジー",
			"ko": "건지 섬",
			"pt": "Guernsey",
			"ru": "Гернси",
			"tr": "Guernsey",
			"zh": "根西岛"
		},
		"countryCode": "GG",
		"visaCode": "92",
		"states": [
			"Castel",
			"Forest",
			"St. Andrew",
			"St. Martin",
			"St. Peter Port",
			"St. Pierre du Bois",
			"St. Sampson",
			"St. Saviour",
			"Torteval",
			"Vale"
		]
	},
	{
		"currency": "GNF",
		"callingCode": "224",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "guinea",
		"name": {
			"common": "Guinea",
			"ar": "غينيا",
			"de": "Guinea",
			"en": "Guinea",
			"es": "Guinea",
			"fr": "Guinée",
			"hi": "गिनी",
			"ja": "ギニア",
			"ko": "기니",
			"pt": "Guiné",
			"ru": "Гвинея",
			"tr": "Gine",
			"zh": "几内亚"
		},
		"countryCode": "GN",
		"visaCode": "93",
		"states": ["Boké", "Conakry", "Faranah", "Kankan", "Kindia", "Labé", "Mamou", "Nzérékoré"]
	},
	{
		"currency": "XOF",
		"callingCode": "245",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "guinea-bissau",
		"name": {
			"common": "Guinea-Bissau",
			"ar": "غينيا بيساو",
			"de": "Guinea-Bissau",
			"en": "Guinea-Bissau",
			"es": "Guinea-Bisáu",
			"fr": "Guinée-Bissau",
			"hi": "गिनी-बिसाऊ",
			"ja": "ギニアビサウ",
			"ko": "기니비사우",
			"pt": "Guiné-Bissau",
			"ru": "Гвинея-Бисау",
			"tr": "Gine-Bissau",
			"zh": "几内亚比绍"
		},
		"countryCode": "GW",
		"visaCode": "94",
		"states": [
			"Bafatá",
			"Biombo",
			"Bissau",
			"Bolama-Bijagos",
			"Cacheu",
			"Gabú",
			"Oio",
			"Quinara",
			"Tombali"
		]
	},
	{
		"currency": "GYD",
		"callingCode": "592",
		"region": "Americas",
		"subregion": "South America",
		"slug": "guyana",
		"name": {
			"common": "Guyana",
			"ar": "غيانا",
			"de": "Guyana",
			"en": "Guyana",
			"es": "Guyana",
			"fr": "Guyana",
			"hi": "गुयाना",
			"ja": "ガイアナ",
			"ko": "가이아나",
			"pt": "Guiana",
			"ru": "Гайана",
			"tr": "Guyana",
			"zh": "圭亚那"
		},
		"countryCode": "GY",
		"visaCode": "95",
		"states": [
			"Barima-Waini",
			"Cuyuni-Mazaruni",
			"Demerara-Mahaica",
			"East Berbice-Corentyne",
			"Essequibo Islands-West Demerara",
			"Mahaica-Berbice",
			"Pomeroon-Supenaam",
			"Potaro-Siparuni",
			"Upper Demerara-Berbice",
			"Upper Takutu-Upper Essequibo"
		]
	},
	{
		"currency": "USD",
		"callingCode": "509",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "haiti",
		"name": {
			"common": "Haiti",
			"ar": "هايتي",
			"de": "Haiti",
			"en": "Haiti",
			"es": "Haití",
			"fr": "Haïti",
			"hi": "हैती",
			"ja": "ハイチ",
			"ko": "아이티",
			"pt": "Haiti",
			"ru": "Гаити",
			"tr": "Haiti",
			"zh": "海地"
		},
		"countryCode": "HT",
		"visaCode": "96",
		"states": [
			"Artibonite",
			"Centre",
			"Grand'Anse",
			"Nippes",
			"Nord",
			"Nord-Est",
			"Nord-Ouest",
			"Ouest",
			"Sud",
			"Sud-Est"
		]
	},
	{
		"currency": "AUD",
		"region": "Antarctic",
		"subregion": "",
		"slug": "heard-island-and-mcdonald-islands",
		"name": {
			"common": "Heard Island and McDonald Islands",
			"ar": "جزيرة هيرد وجزر ماكدونالد",
			"de": "Heard und McDonaldinseln",
			"en": "Heard Island and McDonald Islands",
			"es": "Islas Heard y McDonald",
			"fr": "Îles Heard-et-MacDonald",
			"hi": "हर्ड द्वीप और मैकडॉनल्ड द्वीप",
			"ja": "ハード島とマクドナルド諸島",
			"ko": "허드 맥도널드 제도",
			"pt": "Ilha Heard e Ilhas McDonald",
			"ru": "Остров Херд и острова Макдональд",
			"tr": "Heard Adası ve McDonald Adaları",
			"zh": "赫德岛和麦克唐纳群岛"
		},
		"countryCode": "HM",
		"states": ["Heard Island and McDonald Islands"]
	},
	{
		"currency": "HNL",
		"callingCode": "504",
		"region": "Americas",
		"subregion": "Central America",
		"slug": "honduras",
		"name": {
			"common": "Honduras",
			"ar": "هندوراس",
			"de": "Honduras",
			"en": "Honduras",
			"es": "Honduras",
			"fr": "Honduras",
			"hi": "होंडुरास",
			"ja": "ホンジュラス",
			"ko": "온두라스",
			"pt": "Honduras",
			"ru": "Гондурас",
			"tr": "Honduras",
			"zh": "洪都拉斯"
		},
		"countryCode": "HN",
		"visaCode": "99",
		"states": [
			"Atlántida",
			"Choluteca",
			"Colón",
			"Comayagua",
			"Copán",
			"Cortés",
			"El Paraíso",
			"Francisco Morazán",
			"Gracias a Dios",
			"Intibucá",
			"Islas de la Bahía",
			"La Paz",
			"Lempira",
			"Ocotepeque",
			"Olancho",
			"Santa Bárbara",
			"Valle",
			"Yoro"
		]
	},
	{
		"currency": "HKD",
		"callingCode": "852",
		"region": "Asia",
		"subregion": "Eastern Asia",
		"slug": "hong-kong",
		"name": {
			"common": "Hong Kong",
			"ar": "هونغ كونغ",
			"de": "Hongkong",
			"en": "Hong Kong",
			"es": "Hong Kong",
			"fr": "Hong Kong",
			"hi": "हाँगकाँग",
			"ja": "香港",
			"ko": "홍콩",
			"pt": "Hong Kong",
			"ru": "Гонконг",
			"tr": "Hong Kong",
			"zh": "香港"
		},
		"countryCode": "HK",
		"states": ["Hong Kong"]
	},
	{
		"currency": "HUF",
		"callingCode": "36",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "hungary",
		"name": {
			"common": "Hungary",
			"ar": "المجر",
			"de": "Ungarn",
			"en": "Hungary",
			"es": "Hungría",
			"fr": "Hongrie",
			"hi": "हंगरी",
			"ja": "ハンガリー",
			"ko": "헝가리",
			"pt": "Hungria",
			"ru": "Венгрия",
			"tr": "Macaristan",
			"zh": "匈牙利"
		},
		"countryCode": "HU",
		"visaCode": "101",
		"states": [
			"Bács-Kiskun",
			"Baranya",
			"Békés",
			"Békéscsaba",
			"Borsod-Abauj-Zemplen",
			"Budapest",
			"Csongrád",
			"Debrecen",
			"Dunaújváros",
			"Eger",
			"Érd",
			"Fejér",
			"Győr",
			"Győr-Moson-Sopron",
			"Hajdú-Bihar",
			"Heves",
			"Hódmezővásárhely",
			"Jász-Nagykun-Szolnok",
			"Kaposvár",
			"Kecskemét",
			"Komárom-Esztergom",
			"Miskolc",
			"Nagykanizsa",
			"Nógrád",
			"Nyíregyháza",
			"Pécs",
			"Pest",
			"Salgótarján",
			"Somogy",
			"Sopron",
			"Szabolcs-á-Bereg",
			"Szeged",
			"Székesfehérvár",
			"Szekszárd",
			"Szolnok",
			"Szombathely",
			"Tatabánya",
			"Tolna",
			"Vas",
			"Veszprém",
			"Veszprém (City)",
			"Zala",
			"Zalaegerszeg"
		]
	},
	{
		"currency": "ISK",
		"callingCode": "354",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "iceland",
		"name": {
			"common": "Iceland",
			"ar": "آيسلندا",
			"de": "Island",
			"en": "Iceland",
			"es": "Islandia",
			"fr": "Islande",
			"hi": "आइसलैंड",
			"ja": "アイスランド",
			"ko": "아이슬란드",
			"pt": "Islândia",
			"ru": "Исландия",
			"tr": "İzlanda",
			"zh": "冰岛"
		},
		"countryCode": "IS",
		"visaCode": "102",
		"states": [
			"Austurland",
			"Höfuðborgarsvæði",
			"Norðurland eystra",
			"Norðurland vestra",
			"Suðurland",
			"Suðurnes",
			"Vestfirðir",
			"Vesturland"
		]
	},
	{
		"currency": "INR",
		"callingCode": "91",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "india",
		"name": {
			"common": "India",
			"ar": "الهند",
			"de": "Indien",
			"en": "India",
			"es": "India",
			"fr": "Inde",
			"hi": "भारत",
			"ja": "インド",
			"ko": "인도",
			"pt": "Índia",
			"ru": "Индия",
			"tr": "Hindistan",
			"zh": "印度"
		},
		"countryCode": "IN",
		"visaCode": "103",
		"states": [
			"Andaman and Nicobar Islands",
			"Andhra Pradesh",
			"Arunachal Pradesh",
			"Assam",
			"Bihar",
			"Chandigarh",
			"Chhattisgarh",
			"Dadra and Nagar Haveli and Daman and Diu",
			"Delhi",
			"Goa",
			"Gujarat",
			"Haryana",
			"Himachal Pradesh",
			"Jammu and Kashmir",
			"Jharkhand",
			"Karnataka",
			"Kerala",
			"Ladakh",
			"Lakshadweep",
			"Madhya Pradesh",
			"Maharashtra",
			"Manipur",
			"Meghalaya",
			"Mizoram",
			"Nagaland",
			"Odisha",
			"Puducherry",
			"Punjab",
			"Rajasthan",
			"Sikkim",
			"Tamil Nadu",
			"Telangana",
			"Tripura",
			"Uttarakhand",
			"Uttar Pradesh",
			"West Bengal"
		]
	},
	{
		"currency": "IDR",
		"callingCode": "62",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "indonesia",
		"name": {
			"common": "Indonesia",
			"ar": "إندونيسيا",
			"de": "Indonesien",
			"en": "Indonesia",
			"es": "Indonesia",
			"fr": "Indonésie",
			"hi": "इंडोनेशिया",
			"ja": "インドネシア",
			"ko": "인도네시아",
			"pt": "Indonésia",
			"ru": "Индонезия",
			"tr": "Endonezya",
			"zh": "印度尼西亚"
		},
		"countryCode": "ID",
		"visaCode": "104",
		"states": [
			"Aceh",
			"Bali",
			"Bangka Belitung",
			"Banten",
			"Bengkulu",
			"Gorontalo",
			"Jakarta Raya",
			"Jambi",
			"Jawa Barat",
			"Jawa Tengah",
			"Jawa Timur",
			"Kalimantan Barat",
			"Kalimantan Selatan",
			"Kalimantan Tengah",
			"Kalimantan Timur",
			"Kalimantan Utara",
			"Kepulauan Riau",
			"Lampung",
			"Maluku",
			"Maluku Utara",
			"Nusa Tenggara Barat",
			"Nusa Tenggara Timur",
			"Papua",
			"Papua Barat",
			"Riau",
			"Sulawesi Selatan",
			"Sulawesi Tengah",
			"Sulawesi Tenggara",
			"Sulawesi Utara",
			"Sumatera Barat",
			"Sumatera Selatan",
			"Sumatera Utara",
			"Yogyakarta"
		]
	},
	{
		"currency": "IRR",
		"callingCode": "98",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "iran",
		"name": {
			"common": "Iran",
			"ar": "إيران",
			"de": "Iran",
			"en": "Iran",
			"es": "Irán",
			"fr": "Iran",
			"hi": "ईरान",
			"ja": "イラン",
			"ko": "이란",
			"pt": "Irão",
			"ru": "Иран",
			"tr": "İran",
			"zh": "伊朗"
		},
		"countryCode": "IR",
		"visaCode": "105",
		"states": [
			"Alborz",
			"Ardabīl",
			"Āz̄arbāyjān-e Gharbī",
			"Āz̄arbāyjān-e Sharqī",
			"Būshehr",
			"Chahār Maḩāl va Bakhtīārī",
			"Eşfahān",
			"Fārs",
			"Gīlān",
			"Golestān",
			"Hamadān",
			"Hormozgān",
			"Īlām",
			"Kermān",
			"Kermānshāh",
			"Khorāsān-e Jonūbī",
			"Khorāsān-e Raẕavī",
			"Khorāsān-e Shomālī",
			"Khūzestān",
			"Kohgīlūyeh va Bowyer Aḩmad",
			"Kordestān",
			"Lorestān",
			"Markazi",
			"Māzandarān",
			"Qazvīn",
			"Qom",
			"Semnān",
			"Sīstān va Balūchestān",
			"Tehrān",
			"Yazd",
			"Zanjān"
		]
	},
	{
		"currency": "IQD",
		"callingCode": "964",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "iraq",
		"name": {
			"common": "Iraq",
			"ar": "العراق",
			"de": "Irak",
			"en": "Iraq",
			"es": "Irak",
			"fr": "Irak",
			"hi": "इराक",
			"ja": "イラク",
			"ko": "이라크",
			"pt": "Iraque",
			"ru": "Ирак",
			"tr": "Irak",
			"zh": "伊拉克"
		},
		"countryCode": "IQ",
		"visaCode": "106",
		"states": [
			"Al Anbār",
			"Al Başrah",
			"Al Muthanná",
			"Al Qādisīyah",
			"An Najaf",
			"Arbīl",
			"As Sulaymānīyah",
			"Bābil",
			"Baghdād",
			"Dohuk",
			"Dhī Qār",
			"Diyālá",
			"Karbalā'",
			"Kirkuk",
			"Maysān",
			"Nīnawá",
			"Şalāḩ ad Dīn",
			"Wāsiţ"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "353",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "ireland",
		"name": {
			"common": "Ireland",
			"ar": "أيرلندا",
			"de": "Irland",
			"en": "Ireland",
			"es": "Irlanda",
			"fr": "Irlande",
			"hi": "आयरलैंड",
			"ja": "アイルランド",
			"ko": "아일랜드",
			"pt": "Irlanda",
			"ru": "Ирландия",
			"tr": "İrlanda",
			"zh": "爱尔兰"
		},
		"countryCode": "IE",
		"visaCode": "107",
		"states": [
			"Carlow",
			"Cavan",
			"Clare",
			"Cork",
			"Donegal",
			"Dublin",
			"Galway",
			"Kerry",
			"Kildare",
			"Kilkenny",
			"Laois",
			"Leitrim",
			"Limerick",
			"Longford",
			"Louth",
			"Mayo",
			"Meath",
			"Monaghan",
			"Offaly",
			"Roscommon",
			"Sligo",
			"Tipperary",
			"Waterford",
			"Westmeath",
			"Wexford",
			"Wicklow"
		]
	},
	{
		"currency": "GBP",
		"callingCode": "44",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "isle-of-man",
		"name": {
			"common": "Isle of Man",
			"ar": "جزيرة مان",
			"de": "Isle of Man",
			"en": "Isle of Man",
			"es": "Isla de Man",
			"fr": "Île de Man",
			"hi": "आइल ऑफ मैन",
			"ja": "マン島",
			"ko": "맨 섬",
			"pt": "Ilha de Man",
			"ru": "Остров Мэн",
			"tr": "Man Adası",
			"zh": "马恩岛"
		},
		"countryCode": "IM",
		"visaCode": "108",
		"states": ["Isle of Man"]
	},
	{
		"currency": "ILS",
		"callingCode": "972",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "israel",
		"name": {
			"common": "Israel",
			"ar": "إسرائيل",
			"de": "Israel",
			"en": "Israel",
			"es": "Israel",
			"fr": "Israël",
			"hi": "इज़राइल",
			"ja": "イスラエル",
			"ko": "이스라엘",
			"pt": "Israel",
			"ru": "Израиль",
			"tr": "İsrail",
			"zh": "以色列"
		},
		"countryCode": "IL",
		"visaCode": "109",
		"states": ["HaDarom", "HaMerkaz", "HaTsafon", "H̱efa", "Tel-Aviv", "Yerushalayim"]
	},
	{
		"currency": "EUR",
		"callingCode": "39",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "italy",
		"name": {
			"common": "Italy",
			"ar": "إيطاليا",
			"de": "Italien",
			"en": "Italy",
			"es": "Italia",
			"fr": "Italie",
			"hi": "इटली",
			"ja": "イタリア",
			"ko": "이탈리아",
			"pt": "Itália",
			"ru": "Италия",
			"tr": "İtalya",
			"zh": "意大利"
		},
		"countryCode": "IT",
		"visaCode": "110",
		"states": [
			"Abruzzo",
			"Basilicata",
			"Calabria",
			"Campania",
			"Emilia-Romagna",
			"Friuli-Venezia Giulia",
			"Lazio",
			"Liguria",
			"Lombardia",
			"Marche",
			"Molise",
			"Piemonte",
			"Puglia",
			"Sardegna",
			"Sicilia",
			"Toscana",
			"Trentino-Alto Adige",
			"Umbria",
			"Valle d'Aosta",
			"Veneto"
		]
	},
	{
		"currency": "XOF",
		"callingCode": "225",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "ivory-coast",
		"name": {
			"common": "Ivory Coast",
			"ar": "ساحل العاج",
			"de": "Elfenbeinküste",
			"en": "Ivory Coast",
			"es": "Costa de Marfil",
			"fr": "Côte d'Ivoire",
			"hi": "आइवरी कोस्ट",
			"ja": "コートジボワール",
			"ko": "코트디부아르",
			"pt": "Costa do Marfim",
			"ru": "Кот-д’Ивуар",
			"tr": "Fildişi Sahili",
			"zh": "科特迪瓦"
		},
		"countryCode": "CI",
		"states": [
			"Agnéby",
			"Bafing",
			"Bas-Sassandra",
			"Denguélé",
			"Dix-Huit Montagnes",
			"Fromager",
			"Haut-Sassandra",
			"Lacs",
			"Lagunes",
			"Marahoué",
			"Moyen-Cavally",
			"Moyen-Comoé",
			"N'zi-Comoé",
			"Savanes",
			"Sud-Bandama",
			"Sud-Comoé",
			"Vallée du Bandama",
			"Worodougou",
			"Zanzan"
		]
	},
	{
		"currency": "JMD",
		"callingCode": "1876",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "jamaica",
		"name": {
			"common": "Jamaica",
			"ar": "جامايكا",
			"de": "Jamaika",
			"en": "Jamaica",
			"es": "Jamaica",
			"fr": "Jamaïque",
			"hi": "जमैका",
			"ja": "ジャマイカ",
			"ko": "자메이카",
			"pt": "Jamaica",
			"ru": "Ямайка",
			"tr": "Jamaika",
			"zh": "牙买加"
		},
		"countryCode": "JM",
		"visaCode": "111",
		"states": [
			"Clarendon",
			"Hanover",
			"Kingston",
			"Manchester",
			"Portland",
			"Saint Andrew",
			"Saint Ann",
			"Saint Catherine",
			"Saint Elizabeth",
			"Saint James",
			"Saint Mary",
			"Saint Thomas",
			"Trelawny",
			"Westmoreland"
		]
	},
	{
		"currency": "JPY",
		"callingCode": "81",
		"region": "Asia",
		"subregion": "Eastern Asia",
		"slug": "japan",
		"name": {
			"common": "Japan",
			"ar": "اليابان",
			"de": "Japan",
			"en": "Japan",
			"es": "Japón",
			"fr": "Japon",
			"hi": "जापान",
			"ja": "日本",
			"ko": "일본",
			"pt": "Japão",
			"ru": "Япония",
			"tr": "Japonya",
			"zh": "日本"
		},
		"countryCode": "JP",
		"visaCode": "112",
		"states": [
			"Aichi",
			"Akita",
			"Aomori",
			"Chiba",
			"Ehime",
			"Fukui",
			"Fukuoka",
			"Fukushima",
			"Gifu",
			"Gunma",
			"Hiroshima",
			"Hokkaido",
			"Hyogo",
			"Ibaraki",
			"Ishikawa",
			"Iwate",
			"Kagawa",
			"Kagoshima",
			"Kanagawa",
			"Kochi",
			"Kumamoto",
			"Kyoto",
			"Mie",
			"Miyagi",
			"Miyazaki",
			"Nagano",
			"Nagasaki",
			"Nara",
			"Niigata",
			"Oita",
			"Okayama",
			"Okinawa",
			"Osaka",
			"Saga",
			"Saitama",
			"Shiga",
			"Shimane",
			"Shizuoka",
			"Tochigi",
			"Tokushima",
			"Tokyo",
			"Tottori",
			"Toyama",
			"Wakayama",
			"Yamagata",
			"Yamaguchi",
			"Yamanashi"
		]
	},
	{
		"currency": "GBP",
		"callingCode": "44",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "jersey",
		"name": {
			"common": "Jersey",
			"ar": "جيرزي",
			"de": "Jersey",
			"en": "Jersey",
			"es": "Jersey",
			"fr": "Jersey",
			"hi": "जर्सी",
			"ja": "ジャージー",
			"ko": "저지 섬",
			"pt": "Jersey",
			"ru": "Джерси",
			"tr": "Jersey",
			"zh": "泽西岛"
		},
		"countryCode": "JE",
		"visaCode": "113",
		"states": ["Jersey"]
	},
	{
		"currency": "JOD",
		"callingCode": "962",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "jordan",
		"name": {
			"common": "Jordan",
			"ar": "الأردن",
			"de": "Jordanien",
			"en": "Jordan",
			"es": "Jordania",
			"fr": "Jordanie",
			"hi": "जॉर्डन",
			"ja": "ヨルダン",
			"ko": "요르단",
			"pt": "Jordânia",
			"ru": "Иордания",
			"tr": "Ürdün",
			"zh": "约旦"
		},
		"countryCode": "JO",
		"visaCode": "114",
		"states": [
			"‘Ajlūn",
			"Al 'Aqabah",
			"Al Balqā’",
			"Al Karak",
			"Al Mafraq",
			"Al ‘A̅şimah",
			"Aţ Ţafīlah",
			"Az Zarqā’",
			"Irbid",
			"Jarash",
			"Ma‘ān",
			"Mādabā"
		]
	},
	{
		"currency": "KZT",
		"callingCode": "7",
		"region": "Asia",
		"subregion": "Central Asia",
		"slug": "kazakhstan",
		"name": {
			"common": "Kazakhstan",
			"ar": "كازاخستان",
			"de": "Kasachstan",
			"en": "Kazakhstan",
			"es": "Kazajistán",
			"fr": "Kazakhstan",
			"hi": "कजाखस्तान",
			"ja": "カザフスタン",
			"ko": "카자흐스탄",
			"pt": "Cazaquistão",
			"ru": "Казахстан",
			"tr": "Kazakistan",
			"zh": "哈萨克斯坦"
		},
		"countryCode": "KZ",
		"visaCode": "115",
		"states": [
			"Almaty",
			"Aqmola",
			"Aqtobe",
			"Astana",
			"Atyrau",
			"Batys Qazaqstan",
			"Bayqongyr",
			"Mangghystau",
			"Ongtustik Qazaqstan",
			"Pavlodar",
			"Qaraghandy",
			"Qostanay",
			"Qyzylorda",
			"Shyghys Qazaqstan",
			"Soltustik Qazaqstan",
			"Zhambyl"
		]
	},
	{
		"currency": "KES",
		"callingCode": "254",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "kenya",
		"name": {
			"common": "Kenya",
			"ar": "كينيا",
			"de": "Kenia",
			"en": "Kenya",
			"es": "Kenia",
			"fr": "Kenya",
			"hi": "केन्या",
			"ja": "ケニア",
			"ko": "케냐",
			"pt": "Quénia",
			"ru": "Кения",
			"tr": "Kenya",
			"zh": "肯尼亚"
		},
		"countryCode": "KE",
		"visaCode": "116",
		"states": [
			"Baringo",
			"Bomet",
			"Bungoma",
			"Busia",
			"Eleyo/Marakwet",
			"Embu",
			"Garissa",
			"Homa Bay",
			"Isiolo",
			"Kajiado",
			"Kakamega",
			"Kericho",
			"Kiambu",
			"Kilifi",
			"Kirinyaga",
			"Kisii",
			"Kisumu",
			"Kitui",
			"Kwale",
			"Laikipia",
			"Lamu",
			"Machakos",
			"Makueni",
			"Mandera",
			"Marsabit",
			"Meru",
			"Migori",
			"Mombasa",
			"Murang'a",
			"Nairobi City",
			"Nakuru",
			"Nandi",
			"Narok",
			"Nyamira",
			"Nyandarua",
			"Nyeri",
			"Samburu",
			"Siaya",
			"Taita/Taveta",
			"Tana River",
			"Tharaka-Nithi",
			"Trans Nzoia",
			"Turkana",
			"Uasin Gishu",
			"Vihiga",
			"Wajir",
			"West Pokot"
		]
	},
	{
		"currency": "AUD",
		"callingCode": "686",
		"region": "Oceania",
		"subregion": "Micronesia",
		"slug": "kiribati",
		"name": {
			"common": "Kiribati",
			"ar": "كيريباتي",
			"de": "Kiribati",
			"en": "Kiribati",
			"es": "Kiribati",
			"fr": "Kiribati",
			"hi": "किरिबाती",
			"ja": "キリバス",
			"ko": "키리바시",
			"pt": "Quiribati",
			"ru": "Кирибати",
			"tr": "Kiribati",
			"zh": "基里巴斯"
		},
		"countryCode": "KI",
		"visaCode": "117",
		"states": [
			"Abaiang",
			"Abemama",
			"Aranuka",
			"Arorae",
			"Banaba",
			"Beru",
			"Butaritari",
			"Central Gilberts",
			"Gilbert Islands",
			"Kanton",
			"Kiritimati",
			"Kuria",
			"Line Islands",
			"Maiana",
			"Makin",
			"Marakei",
			"Nikunau",
			"Nonouti",
			"Northern Gilberts",
			"Onotoa",
			"Phoenix Islands",
			"Southern Gilberts",
			"Tabiteuea",
			"Tabuaeran",
			"Tamana",
			"Tarawa",
			"Teraina"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "383",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "kosovo",
		"name": {
			"common": "Kosovo",
			"ar": "كوسوفو",
			"de": "Kosovo",
			"en": "Kosovo",
			"es": "Kosovo",
			"fr": "Kosovo",
			"hi": "कोसोवो",
			"ja": "コソボ",
			"ko": "코소보",
			"pt": "Kosovo",
			"ru": "Косово",
			"tr": "Kosova",
			"zh": "科索沃"
		},
		"countryCode": "XK",
		"visaCode": "249",
		"states": ["Farizaj", "Gjakova", "Gjilan", "Mitrovica", "Peja/Peć", "Pristina", "Prizren"]
	},
	{
		"currency": "KWD",
		"callingCode": "965",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "kuwait",
		"name": {
			"common": "Kuwait",
			"ar": "الكويت",
			"de": "Kuwait",
			"en": "Kuwait",
			"es": "Kuwait",
			"fr": "Koweït",
			"hi": "कुवैत",
			"ja": "クウェート",
			"ko": "쿠웨이트",
			"pt": "Kuwait",
			"ru": "Кувейт",
			"tr": "Kuveyt",
			"zh": "科威特"
		},
		"countryCode": "KW",
		"visaCode": "120",
		"states": [
			"Al Aḩmadi",
			"Al Farwānīyah",
			"Al Jahrā’",
			"Al ‘Āşimah",
			"Ḩawallī",
			"Mubārak al Kabir"
		]
	},
	{
		"currency": "KGS",
		"callingCode": "996",
		"region": "Asia",
		"subregion": "Central Asia",
		"slug": "kyrgyzstan",
		"name": {
			"common": "Kyrgyzstan",
			"ar": "قيرغيزستان",
			"de": "Kirgisistan",
			"en": "Kyrgyzstan",
			"es": "Kirguistán",
			"fr": "Kirghizistan",
			"hi": "किर्गिस्तान",
			"ja": "キルギス",
			"ko": "키르기스스탄",
			"pt": "Quirguistão",
			"ru": "Киргизия",
			"tr": "Kırgızistan",
			"zh": "吉尔吉斯斯坦"
		},
		"countryCode": "KG",
		"visaCode": "121",
		"states": [
			"Batken Oblasty",
			"Bishkek Shaary",
			"Chuy Oblasty (Bishkek)",
			"Jalal-Abad Oblasty",
			"Naryn Oblasty",
			"Osh Oblasty",
			"Talas Oblasty",
			"Ysyk-Kol Oblasty (Karakol)"
		]
	},
	{
		"currency": "LAK",
		"callingCode": "856",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "laos",
		"name": {
			"common": "Laos",
			"ar": "لاوس",
			"de": "Laos",
			"en": "Laos",
			"es": "Laos",
			"fr": "Laos",
			"hi": "लाओस",
			"ja": "ラオス",
			"ko": "라오스",
			"pt": "Laos",
			"ru": "Лаос",
			"tr": "Laos",
			"zh": "老挝"
		},
		"countryCode": "LA",
		"states": [
			"Attapu",
			"Bokèo",
			"Bolikhamxai",
			"Champasak",
			"Houaphan",
			"Khammouan",
			"Louang Namtha",
			"Louangphabang",
			"Oudômxai",
			"Phôngsali",
			"Salavan",
			"Savannakhét",
			"Vientiane",
			"Xaignabouli",
			"Xékong",
			"Xaisomboun",
			"Xiangkhouang"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "371",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "latvia",
		"name": {
			"common": "Latvia",
			"ar": "لاتفيا",
			"de": "Lettland",
			"en": "Latvia",
			"es": "Letonia",
			"fr": "Lettonie",
			"hi": "लातविया",
			"ja": "ラトビア",
			"ko": "라트비아",
			"pt": "Letónia",
			"ru": "Латвия",
			"tr": "Letonya",
			"zh": "拉脱维亚"
		},
		"countryCode": "LV",
		"visaCode": "123",
		"states": [
			"Aglona",
			"Aizkraukle",
			"Aizpute",
			"Aknīste",
			"Aloja",
			"Alsunga",
			"Alūksne",
			"Amata",
			"Ape",
			"Auce",
			"Ādaži",
			"Babīte",
			"Baldone",
			"Baltinava",
			"Balvi",
			"Bauska",
			"Beverīna",
			"Brocēni",
			"Burtnieki",
			"Carnikava",
			"Cesvaine",
			"Cēsis",
			"Cibla",
			"Dagda",
			"Daugavpils",
			"Daugavpils (City)",
			"Dobele",
			"Dundaga",
			"Durbe",
			"Engure",
			"Ērgļi",
			"Garkalne",
			"Grobiņa",
			"Gulbene",
			"Iecava",
			"Ikšķile",
			"Ilūkste",
			"Inčukalns",
			"Jaunjelgava",
			"Jaunpiebalga",
			"Jaunpils",
			"Jelgava",
			"Jelgava (City)",
			"Jēkabpils",
			"Jēkabpils (City)",
			"Jūrmala (City)",
			"Kandava",
			"Kārsava",
			"Kocēni",
			"Koknese",
			"Krāslava",
			"Krimulda",
			"Krustpils",
			"Kuldīga",
			"Ķegums",
			"Ķekava",
			"Lielvārde",
			"Liepāja",
			"Limbaži",
			"Līgatne",
			"Līvāni",
			"Lubāna",
			"Ludza",
			"Madona",
			"Mazsalaca",
			"Mālpils",
			"Mārupe",
			"Mērsrags",
			"Naukšēni",
			"Nereta",
			"Nīca",
			"Ogre",
			"Olaine",
			"Ozolnieki",
			"Pārgauja",
			"Pāvilosta",
			"Pļaviņas",
			"Preiļi",
			"Priekule",
			"Priekuļi",
			"Rauna",
			"Rēzekne",
			"Rēzekne (City)",
			"Riebiņi",
			"Rīga",
			"Roja",
			"Ropaži",
			"Rucava",
			"Rugāji",
			"Rundāle",
			"Rūjiena",
			"Sala",
			"Salacgrīva",
			"Salaspils",
			"Saldus",
			"Saulkrasti",
			"Sēja",
			"Sigulda",
			"Skrīveri",
			"Skrunda",
			"Smiltene",
			"Stopiņi",
			"Strenči",
			"Talsi",
			"Tērvete",
			"Tukums",
			"Vaiņode",
			"Valka",
			"Valmiera",
			"Varakļāni",
			"Vārkava",
			"Vecpiebalga",
			"Vecumnieki",
			"Ventspils",
			"Ventspils (City)",
			"Viesīte",
			"Viļaka",
			"Viļāni",
			"Zilupe"
		]
	},
	{
		"currency": "LBP",
		"callingCode": "961",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "lebanon",
		"name": {
			"common": "Lebanon",
			"ar": "لبنان",
			"de": "Libanon",
			"en": "Lebanon",
			"es": "Líbano",
			"fr": "Liban",
			"hi": "लेबनान",
			"ja": "レバノン",
			"ko": "레바논",
			"pt": "Líbano",
			"ru": "Ливан",
			"tr": "Lübnan",
			"zh": "黎巴嫩"
		},
		"countryCode": "LB",
		"visaCode": "124",
		"states": [
			"Aakkâr",
			"Baalbelk-Hermel",
			"Béqaa",
			"Beyrouth",
			"Liban-Nord",
			"Liban-Sud",
			"Mont-Liban",
			"Nabatîyé"
		]
	},
	{
		"currency": "LSL",
		"callingCode": "266",
		"region": "Africa",
		"subregion": "Southern Africa",
		"slug": "lesotho",
		"name": {
			"common": "Lesotho",
			"ar": "ليسوتو",
			"de": "Lesotho",
			"en": "Lesotho",
			"es": "Lesoto",
			"fr": "Lesotho",
			"hi": "लेसोथो",
			"ja": "レソト",
			"ko": "레소토",
			"pt": "Lesoto",
			"ru": "Лесото",
			"tr": "Lesotho",
			"zh": "莱索托"
		},
		"countryCode": "LS",
		"visaCode": "125",
		"states": [
			"Berea",
			"Butha-Buthe",
			"Leribe",
			"Mafeteng",
			"Maseru",
			"Mohales Hoek",
			"Mokhotlong",
			"Qacha's Nek",
			"Quthing",
			"Thaba-Tseka"
		]
	},
	{
		"currency": "LRD",
		"callingCode": "231",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "liberia",
		"name": {
			"common": "Liberia",
			"ar": "ليبيريا",
			"de": "Liberia",
			"en": "Liberia",
			"es": "Liberia",
			"fr": "Libéria",
			"hi": "लाइबेरिया",
			"ja": "リベリア",
			"ko": "라이베리아",
			"pt": "Libéria",
			"ru": "Либерия",
			"tr": "Liberya",
			"zh": "利比里亚"
		},
		"countryCode": "LR",
		"visaCode": "126",
		"states": [
			"Bomi",
			"Bong",
			"Gbarpolu",
			"Grand Bassa",
			"Grand Cape Mount",
			"Grand Gedeh",
			"Grand Kru",
			"Lofa",
			"Margibi",
			"Maryland",
			"Montserrado",
			"Nimba",
			"River Cess",
			"River Geee",
			"Sinoe"
		]
	},
	{
		"currency": "LYD",
		"callingCode": "218",
		"region": "Africa",
		"subregion": "Northern Africa",
		"slug": "libya",
		"name": {
			"common": "Libya",
			"ar": "ليبيا",
			"de": "Libyen",
			"en": "Libya",
			"es": "Libia",
			"fr": "Libye",
			"hi": "लीबिया",
			"ja": "リビア",
			"ko": "리비아",
			"pt": "Líbia",
			"ru": "Ливия",
			"tr": "Libya",
			"zh": "利比亚"
		},
		"countryCode": "LY",
		"visaCode": "127",
		"states": [
			"Al Buţnān",
			"Al Jabal al Akhḑar",
			"Al Jabal al Gharbī",
			"Al Jafārah",
			"Al Jufrah",
			"Al Kufrah",
			"Al Marj",
			"Al Marquab",
			"Al Wāḩāt",
			"An Nuqaţ al Khams",
			"Az Zāwiyah",
			"Banghāzī",
			"Darnah",
			"Ghāt",
			"Mişrātah",
			"Murzuq",
			"Nālūt",
			"Sabhā",
			"Surt",
			"Ţarābulus",
			"Yafran",
			"Wādī ash Shāţiʾ"
		]
	},
	{
		"currency": "CHF",
		"callingCode": "423",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "liechtenstein",
		"name": {
			"common": "Liechtenstein",
			"ar": "ليختنشتاين",
			"de": "Liechtenstein",
			"en": "Liechtenstein",
			"es": "Liechtenstein",
			"fr": "Liechtenstein",
			"hi": "लिकटेंस्टीन",
			"ja": "リヒテンシュタイン",
			"ko": "리히텐슈타인",
			"pt": "Listenstaine",
			"ru": "Лихтенштейн",
			"tr": "Lihtenştayn",
			"zh": "列支敦士登"
		},
		"countryCode": "LI",
		"visaCode": "128",
		"states": [
			"Balzers",
			"Eschen",
			"Gamprin",
			"Mauren",
			"Planken",
			"Ruggell",
			"Schaan",
			"Schellenberg",
			"Triesen",
			"Triesenberg",
			"Vaduz"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "370",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "lithuania",
		"name": {
			"common": "Lithuania",
			"ar": "ليتوانيا",
			"de": "Litauen",
			"en": "Lithuania",
			"es": "Lituania",
			"fr": "Lituanie",
			"hi": "लिथुआनिया",
			"ja": "リトアニア",
			"ko": "리투아니아",
			"pt": "Lituânia",
			"ru": "Литва",
			"tr": "Litvanya",
			"zh": "立陶宛"
		},
		"countryCode": "LT",
		"visaCode": "129",
		"states": [
			"Alytaus",
			"Kauno",
			"Klaipėdos",
			"Marijampolės",
			"Panevėžio",
			"Šiaulių",
			"Tauragės",
			"Telšių",
			"Utenos",
			"Vilniaus"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "352",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "luxembourg",
		"name": {
			"common": "Luxembourg",
			"ar": "لوكسمبورغ",
			"de": "Luxemburg",
			"en": "Luxembourg",
			"es": "Luxemburgo",
			"fr": "Luxembourg",
			"hi": "लक्जमबर्ग",
			"ja": "ルクセンブルク",
			"ko": "룩셈부르크",
			"pt": "Luxemburgo",
			"ru": "Люксембург",
			"tr": "Lüksemburg",
			"zh": "卢森堡"
		},
		"countryCode": "LU",
		"visaCode": "130",
		"states": [
			"Capellen",
			"Clevaux",
			"Diekirch",
			"Echternach",
			"Esch-sur-Alzette",
			"Grevenmacher",
			"Luxembourg",
			"Mersch",
			"Redange",
			"Remich",
			"Vianden",
			"Wiltz"
		]
	},
	{
		"currency": "MOP",
		"callingCode": "853",
		"region": "Asia",
		"subregion": "Eastern Asia",
		"slug": "macau",
		"name": {
			"common": "Macau",
			"ar": "ماكاو",
			"de": "Macau",
			"en": "Macau",
			"es": "Macao",
			"fr": "Macao",
			"hi": "मकाऊ",
			"ja": "マカオ",
			"ko": "마카오",
			"pt": "Macau",
			"ru": "Макао",
			"tr": "Makao",
			"zh": "澳门"
		},
		"countryCode": "MO",
		"states": ["Macao"]
	},
	{
		"currency": "MKD",
		"callingCode": "389",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "macedonia",
		"name": {
			"common": "Macedonia",
			"ar": "مقدونيا",
			"de": "Mazedonien",
			"en": "Macedonia",
			"es": "Macedonia",
			"fr": "Macédoine",
			"hi": "मेसेडोनिया",
			"ja": "マケドニア",
			"ko": "마케도니아",
			"pt": "Macedónia",
			"ru": "Македония",
			"tr": "Makedonya",
			"zh": "马其顿"
		},
		"countryCode": "MK",
		"visaCode": "132",
		"states": [
			"Aračinovo",
			"Berovo",
			"Bitola",
			"Bogdanci",
			"Bogovinje",
			"Bosilovo",
			"Brvenica",
			"Centar Župa",
			"Čaška",
			"Češinovo-Obleševo",
			"Čučer Sandevo",
			"Debar",
			"Debarca",
			"Delčevo",
			"Demir Hisar",
			"Demir Kapija",
			"Doran",
			"Dolneni",
			"Gevgelija",
			"Gostivar",
			"Gradsko",
			"Ilinden",
			"Jegunovce",
			"Karbinci",
			"Kavadarci",
			"Kičevo",
			"Kočani",
			"Konče",
			"Kratovo",
			"Kriva Palanka",
			"Krivogaštani",
			"Kruševo",
			"Kumanovo",
			"Lipkovo",
			"Lozovo",
			"Makedonska Kamenica",
			"Makedonski Brod",
			"Mavrovo i Rostuša",
			"Mogila",
			"Negotino",
			"Novaci",
			"Novo Selo",
			"Ohrid",
			"Pehčevo",
			"Petrovec",
			"Plasnica",
			"Prilep",
			"Probištip",
			"Radoviš",
			"Rankovce",
			"Resen",
			"Rosoman",
			"Skopje",
			"Sopište",
			"Staro Nagoričane",
			"Struga",
			"Strumica",
			"Studeničani",
			"Sveti Nikole",
			"Štip",
			"Tearce",
			"Tetovo",
			"Valandovo",
			"Vasilevo",
			"Veles",
			"Vevčani",
			"Vinica",
			"Vrapčište",
			"Zelenikovo",
			"Zrnovci",
			"Želino"
		]
	},
	{
		"currency": "MGA",
		"callingCode": "261",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "madagascar",
		"name": {
			"common": "Madagascar",
			"ar": "مدغشقر",
			"de": "Madagaskar",
			"en": "Madagascar",
			"es": "Madagascar",
			"fr": "Madagascar",
			"hi": "मैडागास्कर",
			"ja": "マダガスカル",
			"ko": "마다가스카르",
			"pt": "Madagáscar",
			"ru": "Мадагаскар",
			"tr": "Madagaskar",
			"zh": "马达加斯加"
		},
		"countryCode": "MG",
		"visaCode": "133",
		"states": [
			"Antananarivo",
			"Antsiranana",
			"Fianarantsoa",
			"Mahajanga",
			"Toamasina",
			"Toliara"
		]
	},
	{
		"currency": "MWK",
		"callingCode": "265",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "malawi",
		"name": {
			"common": "Malawi",
			"ar": "ملاوي",
			"de": "Malawi",
			"en": "Malawi",
			"es": "Malaui",
			"fr": "Malawi",
			"hi": "मलावी",
			"ja": "マラウイ",
			"ko": "말라위",
			"pt": "Maláui",
			"ru": "Малави",
			"tr": "Malavi",
			"zh": "马拉维"
		},
		"countryCode": "MW",
		"visaCode": "134",
		"states": [
			"Balaka",
			"Blantyre",
			"Chikwawa",
			"Chiradzulu",
			"Chitipa",
			"Dedza",
			"Dowa",
			"Karonga",
			"Kasungu",
			"Likoma",
			"Lilongwe",
			"Machinga",
			"Mangochi",
			"Mchinji",
			"Mulanje",
			"Mwanza",
			"Mzimba",
			"Nkhata Bay",
			"Nkhotakota",
			"Nsanje",
			"Ntcheu",
			"Ntchisi",
			"Phalombe",
			"Rumphi",
			"Salima",
			"Thyolo",
			"Zomba"
		]
	},
	{
		"currency": "MYR",
		"callingCode": "60",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "malaysia",
		"name": {
			"common": "Malaysia",
			"ar": "ماليزيا",
			"de": "Malaysia",
			"en": "Malaysia",
			"es": "Malasia",
			"fr": "Malaisie",
			"hi": "मलेशिया",
			"ja": "マレーシア",
			"ko": "말레이시아",
			"pt": "Malásia",
			"ru": "Малайзия",
			"tr": "Malezya",
			"zh": "马来西亚"
		},
		"countryCode": "MY",
		"visaCode": "135",
		"states": [
			"Johor",
			"Kedah",
			"Kelantan",
			"Melaka",
			"Negeri Sembilan",
			"Pahang",
			"Perak",
			"Perlis",
			"Pulau Pinang",
			"Sabah",
			"Sarawak",
			"Selangor",
			"Terengganu",
			"Wilayah Persekutuan (Kuala Lumpur)",
			"Wilayah Persekutuan (Labuan)",
			"Wilayah Persekutuan (Putrajaya)"
		]
	},
	{
		"currency": "MVR",
		"callingCode": "960",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "maldives",
		"name": {
			"common": "Maldives",
			"ar": "جزر المالديف",
			"de": "Malediven",
			"en": "Maldives",
			"es": "Maldivas",
			"fr": "Maldives",
			"hi": "मालदीव",
			"ja": "モルディブ",
			"ko": "몰디브",
			"pt": "Maldivas",
			"ru": "Мальдивы",
			"tr": "Maldivler",
			"zh": "马尔代夫"
		},
		"countryCode": "MV",
		"visaCode": "136",
		"states": [
			"Alifu Alifu",
			"Alifu Dhaalu",
			"Baa",
			"Dhaalu",
			"Faafu",
			"Gaafu Alifu",
			"Gaafu Dhaalu",
			"Gnaviyani",
			"Haa Alifu",
			"Haa Dhaalu",
			"Kaafu",
			"Laamu",
			"Lhaviyani",
			"Malé",
			"Meemu",
			"Noonu",
			"Raa",
			"Seenu",
			"Shaviyani",
			"Thaa",
			"Vaavu"
		]
	},
	{
		"currency": "XOF",
		"callingCode": "223",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "mali",
		"name": {
			"common": "Mali",
			"ar": "مالي",
			"de": "Mali",
			"en": "Mali",
			"es": "Malí",
			"fr": "Mali",
			"hi": "माली",
			"ja": "マリ",
			"ko": "말리",
			"pt": "Mali",
			"ru": "Мали",
			"tr": "Mali",
			"zh": "马里"
		},
		"countryCode": "ML",
		"visaCode": "137",
		"states": [
			"Bamako",
			"Gao",
			"Kayes",
			"Kidal",
			"Koulikoro",
			"Mopti",
			"Segou",
			"Sikasso",
			"Tombouctou",
			"Taoudénit",
			"Ménaka"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "356",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "malta",
		"name": {
			"common": "Malta",
			"ar": "مالطا",
			"de": "Malta",
			"en": "Malta",
			"es": "Malta",
			"fr": "Malte",
			"hi": "माल्टा",
			"ja": "マルタ",
			"ko": "몰타",
			"pt": "Malta",
			"ru": "Мальта",
			"tr": "Malta",
			"zh": "马耳他"
		},
		"countryCode": "MT",
		"visaCode": "138",
		"states": [
			"Attard",
			"Balzan",
			"Birgu",
			"Birkirkara",
			"Birżebbuġa",
			"Bormla",
			"Dingli",
			"Fgura",
			"Floriana",
			"Fontana",
			"Guda",
			"Gżira",
			"Għajnsielem",
			"Għarb",
			"Għargħur",
			"Għasri",
			"Għaxaq",
			"Ħamrun",
			"Iklin",
			"Isla",
			"Kalkara",
			"Kerċem",
			"Kirkop",
			"Lija",
			"Luqa",
			"Marsa",
			"Marsaskala",
			"Marsaxlokk",
			"Mdina",
			"Mellieħa",
			"Mġarr",
			"Mosta",
			"Mqabba",
			"Msida",
			"Mtarfa",
			"Munxar",
			"Nadur",
			"Naxxar",
			"Paola",
			"Pembroke",
			"Pietà",
			"Qala",
			"Qormi",
			"Qrendi",
			"Rabat Għawdex",
			"Rabat Malta",
			"Safi",
			"San Ġiljan",
			"San Ġwann",
			"San Lawrenz",
			"San Pawl il-Baħar",
			"Sannat",
			"Santa Luċija",
			"Santa Venera",
			"Siġġiewi",
			"Sliema",
			"Swieqi",
			"Tai Xbiex",
			"Tarzien",
			"Valletta",
			"Xagħra",
			"Xewkija",
			"Xgħajra",
			"Żabbar",
			"Żebbuġ Għawde",
			"Żebbuġ Malta",
			"Żejtun",
			"Żurrieq"
		]
	},
	{
		"currency": "USD",
		"callingCode": "692",
		"region": "Oceania",
		"subregion": "Micronesia",
		"slug": "marshall-islands",
		"name": {
			"common": "Marshall Islands",
			"ar": "جزر مارشال",
			"de": "Marshallinseln",
			"en": "Marshall Islands",
			"es": "Islas Marshall",
			"fr": "Îles Marshall",
			"hi": "मार्शल द्वीप",
			"ja": "マーシャル諸島",
			"ko": "마셜 제도",
			"pt": "Ilhas Marshall",
			"ru": "Маршалловы Острова",
			"tr": "Marshall Adaları",
			"zh": "马绍尔群岛"
		},
		"countryCode": "MH",
		"visaCode": "139",
		"states": [
			"Ailinglaplap",
			"Ailuk",
			"Arno",
			"Aur",
			"Bikini and Kili",
			"Ebon",
			"Jabat",
			"Jaluit",
			"Kwajalein",
			"Lae",
			"Lib",
			"Likiep",
			"Majuro",
			"Maloelap",
			"Mejit",
			"Namdrik",
			"Namu",
			"Rongelap",
			"Ujae",
			"Utrik",
			"Wotho",
			"Wotje"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "596",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "martinique",
		"name": {
			"common": "Martinique",
			"ar": "مارتينيك",
			"de": "Martinique",
			"en": "Martinique",
			"es": "Martinica",
			"fr": "Martinique",
			"hi": "मार्टीनिक",
			"ja": "マルティニーク",
			"ko": "마르티니크",
			"pt": "Martinica",
			"ru": "Мартиника",
			"tr": "Martinik",
			"zh": "马提尼克"
		},
		"countryCode": "MQ",
		"visaCode": "140",
		"states": ["Martinique"]
	},
	{
		"currency": "MRO",
		"callingCode": "222",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "mauritania",
		"name": {
			"common": "Mauritania",
			"ar": "موريتانيا",
			"de": "Mauretanien",
			"en": "Mauritania",
			"es": "Mauritania",
			"fr": "Mauritanie",
			"hi": "मॉरिटानिया",
			"ja": "モーリタニア",
			"ko": "모리타니",
			"pt": "Mauritânia",
			"ru": "Мавритания",
			"tr": "Moritanya",
			"zh": "毛里塔尼亚"
		},
		"countryCode": "MR",
		"visaCode": "141",
		"states": [
			"Adrar",
			"Assaba",
			"Brakna",
			"Dakhlet Nouadhibou",
			"Gorgol",
			"Guidimaka",
			"Hodh Ech Chargui",
			"Hodh El Gharbi",
			"Inchiri",
			"Nouakchott Nord",
			"Nouakchott Ouest",
			"Nouakchott Sud",
			"Tagant",
			"Tiris Zemmour",
			"Trarza"
		]
	},
	{
		"currency": "MUR",
		"callingCode": "230",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "mauritius",
		"name": {
			"common": "Mauritius",
			"ar": "موريشيوس",
			"de": "Mauritius",
			"en": "Mauritius",
			"es": "Mauricio",
			"fr": "Maurice",
			"hi": "मॉरीशस",
			"ja": "モーリシャス",
			"ko": "모리셔스",
			"pt": "Maurícia",
			"ru": "Маврикий",
			"tr": "Mauritius",
			"zh": "毛里求斯"
		},
		"countryCode": "MU",
		"visaCode": "142",
		"states": [
			"Agalega Islands",
			"Beau Bassin-Rose Hill",
			"Black River",
			"Cargados Carajos Shoals",
			"Curepipe",
			"Flacq",
			"Grand Port",
			"Moka",
			"Pamplemousses",
			"Plaines Wilhems",
			"Port Louis (City)",
			"Port Louis",
			"Riviere du Rempart",
			"Rodrigues Island",
			"Savanne",
			"Vacoas-Phoenix"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "262",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "mayotte",
		"name": {
			"common": "Mayotte",
			"ar": "مايوت",
			"de": "Mayotte",
			"en": "Mayotte",
			"es": "Mayotte",
			"fr": "Mayotte",
			"hi": "मायोटे",
			"ja": "マヨット",
			"ko": "마요트",
			"pt": "Maiote",
			"ru": "Майотта",
			"tr": "Mayotte",
			"zh": "马约特"
		},
		"countryCode": "YT",
		"visaCode": "143",
		"states": [
			"Dzaoudzi",
			"Pamandzi",
			"Mamoudzou",
			"Dembeni",
			"Bandrélé",
			"Kani-Kéli",
			"Bouéni",
			"Chirongui",
			"Sada",
			"Ouangani",
			"Chiconi",
			"Tsingoni",
			"M'Tsangamouji",
			"Acoua",
			"Mtsamboro",
			"Bandraboua",
			"Koungou"
		]
	},
	{
		"currency": "MXN",
		"callingCode": "52",
		"region": "Americas",
		"subregion": "North America",
		"slug": "mexico",
		"name": {
			"common": "Mexico",
			"ar": "المكسيك",
			"de": "Mexiko",
			"en": "Mexico",
			"es": "México",
			"fr": "Mexique",
			"hi": "मेक्सिको",
			"ja": "メキシコ",
			"ko": "멕시코",
			"pt": "México",
			"ru": "Мексика",
			"tr": "Meksika",
			"zh": "墨西哥"
		},
		"countryCode": "MX",
		"visaCode": "144",
		"states": [
			"Aguascalientes",
			"Baja California",
			"Baja California Sur",
			"Campeche",
			"Ciudad de México",
			"Chiapas",
			"Chihuahua",
			"Coahuila de Zaragoza",
			"Colima",
			"Durango",
			"Estado de México",
			"Guanajuato",
			"Guerrero",
			"Hidalgo",
			"Jalisco",
			"Michoacán de Ocampo",
			"Morelos",
			"Nayarit",
			"Nuevo León",
			"Oaxaca",
			"Puebla",
			"Querétaro de Arteaga",
			"Quintana Roo",
			"San Luis Potosí",
			"Sinaloa",
			"Sonora",
			"Tabasco",
			"Tamaulipas",
			"Tlaxcala",
			"Veracruz",
			"Yucatán",
			"Zacatecas"
		]
	},
	{
		"currency": "USD",
		"callingCode": "691",
		"region": "Oceania",
		"subregion": "Micronesia",
		"slug": "micronesia",
		"name": {
			"common": "Micronesia",
			"ar": "ميكرونيسيا",
			"de": "Mikronesien",
			"en": "Micronesia",
			"es": "Micronesia",
			"fr": "Micronésie",
			"hi": "माइक्रोनेशिया",
			"ja": "ミクロネシア連邦",
			"ko": "미크로네시아 연방",
			"pt": "Micronésia",
			"ru": "Микронезия",
			"tr": "Mikronezya",
			"zh": "密克罗尼西亚"
		},
		"countryCode": "FM",
		"states": ["Chuuk (Truk)", "Kosrae", "Pohnpei", "Yap"]
	},
	{
		"currency": "MDL",
		"callingCode": "373",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "moldova",
		"name": {
			"common": "Moldova",
			"ar": "مولدوفا",
			"de": "Moldawien",
			"en": "Moldova",
			"es": "Moldavia",
			"fr": "Moldavie",
			"hi": "मोल्दोवा",
			"ja": "モルドバ",
			"ko": "몰도바",
			"pt": "Moldávia",
			"ru": "Молдавия",
			"tr": "Moldova",
			"zh": "摩尔多瓦"
		},
		"countryCode": "MD",
		"visaCode": "146",
		"states": [
			"Anenii Noi",
			"Basarabeasca",
			"Bălți",
			"Bender",
			"Briceni",
			"Cahul",
			"Cantemir",
			"Călărași",
			"Căușeni",
			"Chișinău",
			"Cimișlia",
			"Criuleni",
			"Dondușeni",
			"Drochia",
			"Dubăsari",
			"Edineț",
			"Fălești",
			"Florești",
			"Găgăuzia",
			"Glodeni",
			"Hîncești",
			"Ialoveni",
			"Leova",
			"Nisporeni",
			"Ocnița",
			"Orhei",
			"Rezina",
			"Rîșcani",
			"Sîngerei",
			"Soroca",
			"Stânga Nistrului",
			"Strășeni",
			"Șoldănești",
			"Ștefan Vodă",
			"Taraclia",
			"Telenești",
			"Ungheni"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "377",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "monaco",
		"name": {
			"common": "Monaco",
			"ar": "موناكو",
			"de": "Monaco",
			"en": "Monaco",
			"es": "Mónaco",
			"fr": "Monaco",
			"hi": "मोनाको",
			"ja": "モナコ",
			"ko": "모나코",
			"pt": "Mónaco",
			"ru": "Монако",
			"tr": "Monako",
			"zh": "摩纳哥"
		},
		"countryCode": "MC",
		"visaCode": "147",
		"states": [
			"Colle",
			"Condamine",
			"Fontvieille",
			"Gare",
			"Jardin Exotique",
			"Larvotto",
			"Malbousquet",
			"Monaco-Ville",
			"Moneghetti",
			"Monte-Carlo",
			"Moulins",
			"Port-Hercule",
			"Saint-Roman",
			"Sainte-Dévote",
			"Source",
			"Spélugues",
			"Vallon de la Rousse"
		]
	},
	{
		"currency": "MNT",
		"callingCode": "976",
		"region": "Asia",
		"subregion": "Eastern Asia",
		"slug": "mongolia",
		"name": {
			"common": "Mongolia",
			"ar": "منغوليا",
			"de": "Mongolei",
			"en": "Mongolia",
			"es": "Mongolia",
			"fr": "Mongolie",
			"hi": "मंगोलिया",
			"ja": "モンゴル",
			"ko": "몽골",
			"pt": "Mongólia",
			"ru": "Монголия",
			"tr": "Moğolistan",
			"zh": "蒙古"
		},
		"countryCode": "MN",
		"visaCode": "148",
		"states": [
			"Arhangay",
			"Bayan-Olgiy",
			"Bayanhongor",
			"Bulgan",
			"Darhan",
			"Dornod",
			"Dornogovi",
			"Dundgovi",
			"Dzavhan",
			"Govi-Altay",
			"Govi-Sumber",
			"Hovd",
			"Hovsgol",
			"Omnogovi",
			"Ovorhangay",
			"Selenge",
			"Suhbaatar",
			"Tov",
			"Ulaanbaatar",
			"Uvs",
			"Erdenet"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "382",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "montenegro",
		"name": {
			"common": "Montenegro",
			"ar": "الجبل الأسود",
			"de": "Montenegro",
			"en": "Montenegro",
			"es": "Montenegro",
			"fr": "Monténégro",
			"hi": "मोंटेनेग्रो",
			"ja": "モンテネグロ",
			"ko": "몬테네그로",
			"pt": "Montenegro",
			"ru": "Черногория",
			"tr": "Karadağ",
			"zh": "黑山"
		},
		"countryCode": "ME",
		"visaCode": "149",
		"states": [
			"Andrijevica",
			"Bar",
			"Berane",
			"Bijelo Polje",
			"Budva",
			"Cetinje",
			"Danilovgrad",
			"Gusinje",
			"Herceg Novi",
			"Kolašin",
			"Kotor",
			"Mojkovac",
			"Nikšić",
			"Petnica",
			"Plav",
			"Plužine",
			"Pljevlja",
			"Podgorica",
			"Rožaje",
			"Šavnik",
			"Tivat",
			"Ulcinj",
			"Žabljak"
		]
	},
	{
		"currency": "XCD",
		"callingCode": "1664",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "montserrat",
		"name": {
			"common": "Montserrat",
			"ar": "مونتسرات",
			"de": "Montserrat",
			"en": "Montserrat",
			"es": "Montserrat",
			"fr": "Montserrat",
			"hi": "मोंटेसेराट",
			"ja": "モントセラト",
			"ko": "몬트세랫",
			"pt": "Monserrate",
			"ru": "Монтсеррат",
			"tr": "Montserrat",
			"zh": "蒙特塞拉特"
		},
		"countryCode": "MS",
		"visaCode": "150",
		"states": ["Saint Anthony", "Saint Georges", "Saint Peter's"]
	},
	{
		"currency": "MAD",
		"callingCode": "212",
		"region": "Africa",
		"subregion": "Northern Africa",
		"slug": "morocco",
		"name": {
			"common": "Morocco",
			"ar": "المغرب",
			"de": "Marokko",
			"en": "Morocco",
			"es": "Marruecos",
			"fr": "Maroc",
			"hi": "मोरक्को",
			"ja": "モロッコ",
			"ko": "모로코",
			"pt": "Marrocos",
			"ru": "Марокко",
			"tr": "Fas",
			"zh": "摩洛哥"
		},
		"countryCode": "MA",
		"visaCode": "151",
		"states": [
			"Tanger-Tétouan-Al Hoceïma",
			"L'Oriental",
			"Fès-Meknès",
			"Rabat-Salé-Kénitra",
			"Béni Mellal-Khénifra",
			"Casablanca-Settat",
			"Marrakech-Safi",
			"Drâa-Tafilalet",
			"Souss-Massa",
			"Guelmim-Oued Noun",
			"Laâyoune-Sakia El Hamra",
			"Dakhla-Oued Ed-Dahab"
		]
	},
	{
		"currency": "MZN",
		"callingCode": "258",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "mozambique",
		"name": {
			"common": "Mozambique",
			"ar": "موزمبيق",
			"de": "Mosambik",
			"en": "Mozambique",
			"es": "Mozambique",
			"fr": "Mozambique",
			"hi": "मोज़ाम्बिक",
			"ja": "モザンビーク",
			"ko": "모잠비크",
			"pt": "Moçambique",
			"ru": "Мозамбик",
			"tr": "Mozambik",
			"zh": "莫桑比克"
		},
		"countryCode": "MZ",
		"visaCode": "152",
		"states": [
			"Cabo Delgado",
			"Gaza",
			"Inhambane",
			"Manica",
			"Maputo",
			"Maputo (City)",
			"Nampula",
			"Niassa",
			"Sofala",
			"Tete",
			"Zambezia"
		]
	},
	{
		"currency": "MMK",
		"callingCode": "95",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "myanmar",
		"name": {
			"common": "Myanmar",
			"ar": "ميانمار",
			"de": "Myanmar",
			"en": "Myanmar",
			"es": "Myanmar",
			"fr": "Birmanie",
			"hi": "म्यांमार",
			"ja": "ミャンマー",
			"ko": "미얀마",
			"pt": "Myanmar",
			"ru": "Мьянма",
			"tr": "Myanmar",
			"zh": "缅甸"
		},
		"countryCode": "MM",
		"visaCode": "153",
		"states": [
			"Ayeyarwady",
			"Bago",
			"Chin",
			"Kachin",
			"Kayah",
			"Kayin",
			"Magway",
			"Mandalay",
			"Mon",
			"Nay Pyi Taw",
			"Rakhine",
			"Sagaing",
			"Shan",
			"Tanintharyi",
			"Yangon"
		]
	},
	{
		"currency": "NAD",
		"callingCode": "264",
		"region": "Africa",
		"subregion": "Southern Africa",
		"slug": "namibia",
		"name": {
			"common": "Namibia",
			"ar": "ناميبيا",
			"de": "Namibia",
			"en": "Namibia",
			"es": "Namibia",
			"fr": "Namibie",
			"hi": "नामीबिया",
			"ja": "ナミビア",
			"ko": "나미비아",
			"pt": "Namíbia",
			"ru": "Намибия",
			"tr": "Namibya",
			"zh": "纳米比亚"
		},
		"countryCode": "NA",
		"visaCode": "154",
		"states": [
			"Erongo",
			"Hardap",
			"Kavango East",
			"Kavango West",
			"Karas",
			"Khomas",
			"Kunene",
			"Ohangwena",
			"Omaheke",
			"Omusati",
			"Oshana",
			"Oshikoto",
			"Otjozondjupa",
			"Zambezi"
		]
	},
	{
		"currency": "AUD",
		"callingCode": "674",
		"region": "Oceania",
		"subregion": "Micronesia",
		"slug": "nauru",
		"name": {
			"common": "Nauru",
			"ar": "ناورو",
			"de": "Nauru",
			"en": "Nauru",
			"es": "Nauru",
			"fr": "Nauru",
			"hi": "नाउरू",
			"ja": "ナウル",
			"ko": "나우루",
			"pt": "Nauru",
			"ru": "Науру",
			"tr": "Nauru",
			"zh": "瑙鲁"
		},
		"countryCode": "NR",
		"visaCode": "155",
		"states": [
			"Aiwo",
			"Anabar",
			"Anetan",
			"Anibare",
			"Baiti",
			"Boe",
			"Buada",
			"Denigomodu",
			"Ewa",
			"Ijuw",
			"Meneng",
			"Nibok",
			"Uaboe",
			"Yaren"
		]
	},
	{
		"currency": "NPR",
		"callingCode": "977",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "nepal",
		"name": {
			"common": "Nepal",
			"ar": "نيبال",
			"de": "Nepal",
			"en": "Nepal",
			"es": "Nepal",
			"fr": "Népal",
			"hi": "नेपाल",
			"ja": "ネパール",
			"ko": "네팔",
			"pt": "Nepal",
			"ru": "Непал",
			"tr": "Nepal",
			"zh": "尼泊尔"
		},
		"countryCode": "NP",
		"visaCode": "156",
		"states": [
			"Province No. 1",
			"Madhesh Province",
			"Bagmati Province",
			"Gandaki Province",
			"Lumbini Province",
			"Karnali Province",
			"Sudurpashchim Province"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "31",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "netherlands",
		"name": {
			"common": "Netherlands",
			"ar": "هولندا",
			"de": "Niederlande",
			"en": "Netherlands",
			"es": "Países Bajos",
			"fr": "Pays-Bas",
			"hi": "नीदरलैंड",
			"ja": "オランダ",
			"ko": "네덜란드",
			"pt": "Países Baixos",
			"ru": "Нидерланды",
			"tr": "Hollanda",
			"zh": "荷兰"
		},
		"countryCode": "NL",
		"visaCode": "157",
		"states": [
			"Drenthe",
			"Flevoland",
			"Friesland",
			"Gelderland",
			"Groningen",
			"Limburg",
			"Noord-Brabant",
			"Noord-Holland",
			"Overijssel",
			"Utrecht",
			"Zeeland",
			"Zuid-Holland"
		]
	},
	{
		"currency": "XPF",
		"callingCode": "687",
		"region": "Oceania",
		"subregion": "Melanesia",
		"slug": "new-caledonia",
		"name": {
			"common": "New Caledonia",
			"ar": "كاليدونيا الجديدة",
			"de": "Neukaledonien",
			"en": "New Caledonia",
			"es": "Nueva Caledonia",
			"fr": "Nouvelle-Calédonie",
			"hi": "न्यू कैलेडोनिया",
			"ja": "ニューカレドニア",
			"ko": "누벨칼레도니",
			"pt": "Nova Caledónia",
			"ru": "Новая Каледония",
			"tr": "Yeni Kaledonya",
			"zh": "新喀里多尼亚"
		},
		"countryCode": "NC",
		"visaCode": "159",
		"states": ["Iles Loyaute", "Nord", "Sud"]
	},
	{
		"currency": "NZD",
		"callingCode": "64",
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"slug": "new-zealand",
		"name": {
			"common": "New Zealand",
			"ar": "نيوزيلندا",
			"de": "Neuseeland",
			"en": "New Zealand",
			"es": "Nueva Zelanda",
			"fr": "Nouvelle-Zélande",
			"hi": "न्यूजीलैंड",
			"ja": "ニュージーランド",
			"ko": "뉴질랜드",
			"pt": "Nova Zelândia",
			"ru": "Новая Зеландия",
			"tr": "Yeni Zelanda",
			"zh": "新西兰"
		},
		"countryCode": "NZ",
		"visaCode": "160",
		"states": [
			"Auckland",
			"Bay of Plenty",
			"Canterbury",
			"Gisborne",
			"Hawke's Bay",
			"Marlborough",
			"Manawatu-Wanganui",
			"Northland",
			"Nelson",
			"Otago",
			"Southland",
			"Taranaki",
			"Tasman",
			"Waikato",
			"Wellington",
			"West Coast",
			"Chatham Islands Territory"
		]
	},
	{
		"currency": "NIO",
		"callingCode": "505",
		"region": "Americas",
		"subregion": "Central America",
		"slug": "nicaragua",
		"name": {
			"common": "Nicaragua",
			"ar": "نيكاراغوا",
			"de": "Nicaragua",
			"en": "Nicaragua",
			"es": "Nicaragua",
			"fr": "Nicaragua",
			"hi": "निकारागुआ",
			"ja": "ニカラグア",
			"ko": "니카라과",
			"pt": "Nicarágua",
			"ru": "Никарагуа",
			"tr": "Nikaragua",
			"zh": "尼加拉瓜"
		},
		"countryCode": "NI",
		"visaCode": "161",
		"states": [
			"Boaco",
			"Carazo",
			"Chinandega",
			"Chontales",
			"Estelí",
			"Granada",
			"Jinotega",
			"León",
			"Madriz",
			"Managua",
			"Masaya",
			"Matagalpa",
			"Nueva Segovia",
			"Río San Juan",
			"Rivas",
			"Atlántico Norte",
			"Atlántico Sur"
		]
	},
	{
		"currency": "XOF",
		"callingCode": "227",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "niger",
		"name": {
			"common": "Niger",
			"ar": "النيجر",
			"de": "Niger",
			"en": "Niger",
			"es": "Níger",
			"fr": "Niger",
			"hi": "नाइजर",
			"ja": "ニジェール",
			"ko": "니제르",
			"pt": "Níger",
			"ru": "Нигер",
			"tr": "Nijer",
			"zh": "尼日尔"
		},
		"countryCode": "NE",
		"visaCode": "162",
		"states": ["Agadez", "Diffa", "Dosso", "Maradi", "Niamey", "Tahoua", "Tillabéri", "Zinder"]
	},
	{
		"currency": "NGN",
		"callingCode": "234",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "nigeria",
		"name": {
			"common": "Nigeria",
			"ar": "نيجيريا",
			"de": "Nigeria",
			"en": "Nigeria",
			"es": "Nigeria",
			"fr": "Nigéria",
			"hi": "नाइजीरिया",
			"ja": "ナイジェリア",
			"ko": "나이지리아",
			"pt": "Nigéria",
			"ru": "Нигерия",
			"tr": "Nijerya",
			"zh": "尼日利亚"
		},
		"countryCode": "NG",
		"visaCode": "163",
		"states": [
			"Abia",
			"Abuja Federal Capital Territory",
			"Adamawa",
			"Akwa Ibom",
			"Anambra",
			"Bauchi",
			"Bayelsa",
			"Benue",
			"Borno",
			"Cross River",
			"Delta",
			"Ebonyi",
			"Edo",
			"Ekiti",
			"Enugu",
			"Gombe",
			"Imo",
			"Jigawa",
			"Kaduna",
			"Kano",
			"Katsina",
			"Kebbi",
			"Kogi",
			"Kwara",
			"Lagos",
			"Nasarawa",
			"Niger",
			"Ogun",
			"Ondo",
			"Osun",
			"Oyo",
			"Plateau",
			"Rivers",
			"Sokoto",
			"Taraba",
			"Yobe",
			"Zamfara"
		]
	},
	{
		"currency": "NZD",
		"callingCode": "683",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "niue",
		"name": {
			"common": "Niue",
			"ar": "نيوي",
			"de": "Niue",
			"en": "Niue",
			"es": "Niue",
			"fr": "Niue",
			"hi": "नियू",
			"ja": "ニウエ",
			"ko": "니우에",
			"pt": "Niue",
			"ru": "Ниуэ",
			"tr": "Niue",
			"zh": "纽埃"
		},
		"countryCode": "NU",
		"visaCode": "164",
		"states": ["Niue"]
	},
	{
		"currency": "AUD",
		"callingCode": "672",
		"region": "Oceania",
		"subregion": "Australia and New Zealand",
		"slug": "norfolk-island",
		"name": {
			"common": "Norfolk Island",
			"ar": "جزيرة نورفولك",
			"de": "Norfolkinsel",
			"en": "Norfolk Island",
			"es": "Isla Norfolk",
			"fr": "Île Norfolk",
			"hi": "नॉरफ़ॉक द्वीप",
			"ja": "ノーフォーク島",
			"ko": "노퍽 섬",
			"pt": "Ilha Norfolk",
			"ru": "Остров Норфолк",
			"tr": "Norfolk Adası",
			"zh": "诺福克岛"
		},
		"countryCode": "NF",
		"visaCode": "165",
		"states": ["Norfolk Island"]
	},
	{
		"currency": "KPW",
		"callingCode": "850",
		"region": "Asia",
		"subregion": "Eastern Asia",
		"slug": "north-korea",
		"name": {
			"common": "North Korea",
			"ar": "كوريا الشمالية",
			"de": "Nordkorea",
			"en": "North Korea",
			"es": "Corea del Norte",
			"fr": "Corée du Nord",
			"hi": "उत्तर कोरिया",
			"ja": "北朝鮮",
			"ko": "조선민주주의인민공화국",
			"pt": "Coreia do Norte",
			"ru": "Северная Корея",
			"tr": "Kuzey Kore",
			"zh": "朝鲜"
		},
		"countryCode": "KP",
		"visaCode": "118",
		"states": [
			"Chagang-do (Chagang Province)",
			"Hamgyong-bukto (North Hamgyong Province)",
			"Hamgyong-namdo (South Hamgyong Province)",
			"Hwanghae-bukto (North Hwanghae Province)",
			"Hwanghae-namdo (South Hwanghae Province)",
			"Kangwon-do (Kangwon Province)",
			"Nasŏn (Najin-Sŏnbong)",
			"P'yongan-bukto (North P'yongan Province)",
			"P'yongan-namdo (South P'yongan Province)",
			"P'yongyang-si (P'yongyang City)",
			"Yanggang-do (Yanggang Province)"
		]
	},
	{
		"currency": "USD",
		"callingCode": "1670",
		"region": "Oceania",
		"subregion": "Micronesia",
		"slug": "northern-mariana-islands",
		"name": {
			"common": "Northern Mariana Islands",
			"ar": "جزر ماريانا الشمالية",
			"de": "Nördliche Marianen",
			"en": "Northern Mariana Islands",
			"es": "Islas Marianas del Norte",
			"fr": "Îles Mariannes du Nord",
			"hi": "उत्तरी मारियाना द्वीप समूह",
			"ja": "北マリアナ諸島",
			"ko": "북마리아나 제도",
			"pt": "Marianas Setentrionais",
			"ru": "Северные Марианские острова",
			"tr": "Kuzey Mariana Adaları",
			"zh": "北马里亚纳群岛"
		},
		"countryCode": "MP",
		"visaCode": "166",
		"states": ["Northern Islands", "Rota", "Saipan", "Tinian"]
	},
	{
		"currency": "NOK",
		"callingCode": "47",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "norway",
		"name": {
			"common": "Norway",
			"ar": "النرويج",
			"de": "Norwegen",
			"en": "Norway",
			"es": "Noruega",
			"fr": "Norvège",
			"hi": "नॉर्वे",
			"ja": "ノルウェー",
			"ko": "노르웨이",
			"pt": "Noruega",
			"ru": "Норвегия",
			"tr": "Norveç",
			"zh": "挪威"
		},
		"countryCode": "NO",
		"visaCode": "167",
		"states": [
			"Agder",
			"Innlandet",
			"Jan Mayen",
			"Møre og Romsdal",
			"Nordland",
			"Oslo",
			"Rogaland",
			"Svalbard",
			"Troms og Finnmark",
			"Trøndelag",
			"Vestfold og Telemark",
			"Vestland",
			"Viken"
		]
	},
	{
		"currency": "OMR",
		"callingCode": "968",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "oman",
		"name": {
			"common": "Oman",
			"ar": "عمان",
			"de": "Oman",
			"en": "Oman",
			"es": "Omán",
			"fr": "Oman",
			"hi": "ओमान",
			"ja": "オマーン",
			"ko": "오만",
			"pt": "Omã",
			"ru": "Оман",
			"tr": "Umman",
			"zh": "阿曼"
		},
		"countryCode": "OM",
		"visaCode": "168",
		"states": [
			"Ad Dakhiliyah",
			"Al Buraymi",
			"Al Wusta",
			"Az Zahirah",
			"Janub al Batinah",
			"Janub ash Sharqiyah",
			"Masqat",
			"Musandam",
			"Shamal al Batinah",
			"Shamal ash Sharqiyah",
			"Zufar"
		]
	},
	{
		"currency": "PKR",
		"callingCode": "92",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "pakistan",
		"name": {
			"common": "Pakistan",
			"ar": "باكستان",
			"de": "Pakistan",
			"en": "Pakistan",
			"es": "Pakistán",
			"fr": "Pakistan",
			"hi": "पाकिस्तान",
			"ja": "パキスタン",
			"ko": "파키스탄",
			"pt": "Paquistão",
			"ru": "Пакистан",
			"tr": "Pakistan",
			"zh": "巴基斯坦"
		},
		"countryCode": "PK",
		"visaCode": "169",
		"states": [
			"Azad Kashmir",
			"Balochistan",
			"Gilgit-Baltistan",
			"Islamabad",
			"Khaibar Pakhtunkhwa",
			"Punjab",
			"Sindh",
			"Federally Administered Tribal Areas"
		]
	},
	{
		"currency": "USD",
		"callingCode": "680",
		"region": "Oceania",
		"subregion": "Micronesia",
		"slug": "palau",
		"name": {
			"common": "Palau",
			"ar": "بالاو",
			"de": "Palau",
			"en": "Palau",
			"es": "Palaos",
			"fr": "Palaos",
			"hi": "पलाऊ",
			"ja": "パラオ",
			"ko": "팔라우",
			"pt": "Palau",
			"ru": "Палау",
			"tr": "Palau",
			"zh": "帕劳"
		},
		"countryCode": "PW",
		"visaCode": "170",
		"states": [
			"Aimeliik",
			"Airai",
			"Angaur",
			"Hatobohei",
			"Kayangel",
			"Koror",
			"Melekeok",
			"Ngaraard",
			"Ngarchelong",
			"Ngardmau",
			"Ngatpang",
			"Ngchesar",
			"Ngeremlengui",
			"Ngiwal",
			"Peleliu",
			"Sonsoral"
		]
	},
	{
		"currency": "ILS",
		"callingCode": "970",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "palestine",
		"name": {
			"common": "Palestine",
			"ar": "فلسطين",
			"de": "Palästina",
			"en": "Palestine",
			"es": "Palestina",
			"fr": "Palestine",
			"hi": "फिलिस्तीन",
			"ja": "パレスチナ",
			"ko": "팔레스타인",
			"pt": "Palestina",
			"ru": "Палестина",
			"tr": "Filistin",
			"zh": "巴勒斯坦"
		},
		"countryCode": "PS",
		"states": [
			"Ak Khalīl",
			"Al Quds",
			"Arīḩā wal Aghwār",
			"Bayt Laḩm",
			"Dayr al Balaḩ",
			"Ghazzah",
			"Janīn",
			"Khān Yūnis",
			"Nāblus",
			"Qalqīyah",
			"Rafaḩ",
			"Rām Allāh wal Bīrah",
			"Salfīt",
			"Shamāl Ghazzah",
			"Ţūbās",
			"Ţūlkarm"
		]
	},
	{
		"currency": "USD",
		"callingCode": "507",
		"region": "Americas",
		"subregion": "Central America",
		"slug": "panama",
		"name": {
			"common": "Panama",
			"ar": "بنما",
			"de": "Panama",
			"en": "Panama",
			"es": "Panamá",
			"fr": "Panama",
			"hi": "पनामा",
			"ja": "パナマ",
			"ko": "파나마",
			"pt": "Panamá",
			"ru": "Панама",
			"tr": "Panama",
			"zh": "巴拿马"
		},
		"countryCode": "PA",
		"visaCode": "172",
		"states": [
			"Bocas del Toro",
			"Chiriquí",
			"Coclé",
			"Colón",
			"Darién",
			"Emberá",
			"Herrera",
			"Kuna Yala",
			"Los Santos",
			"Ngäbe-Buglé",
			"Panamá",
			"Panamá Oeste",
			"Veraguas"
		]
	},
	{
		"currency": "PGK",
		"callingCode": "675",
		"region": "Oceania",
		"subregion": "Melanesia",
		"slug": "papua-new-guinea",
		"name": {
			"common": "Papua New Guinea",
			"ar": "بابوا غينيا الجديدة",
			"de": "Papua-Neuguinea",
			"en": "Papua New Guinea",
			"es": "Papúa Nueva Guinea",
			"fr": "Papouasie-Nouvelle-Guinée",
			"hi": "पापुआ न्यू गिनी",
			"ja": "パプアニューギニア",
			"ko": "파푸아뉴기니",
			"pt": "Papua Nova Guiné",
			"ru": "Папуа — Новая Гвинея",
			"tr": "Papua Yeni Gine",
			"zh": "巴布亚新几内亚"
		},
		"countryCode": "PG",
		"visaCode": "173",
		"states": [
			"Bougainville",
			"Central",
			"Chimbu",
			"East New Britain",
			"East Sepik",
			"Eastern Highlands",
			"Enga",
			"Gulf",
			"Hela",
			"Jiwaka",
			"Madang",
			"Manus",
			"Milne Bay",
			"Morobe",
			"Port Moresby",
			"New Ireland",
			"Northern",
			"Southern Highlands",
			"West New Britain",
			"West Sepik",
			"Western",
			"Western Highlands"
		]
	},
	{
		"currency": "PYG",
		"callingCode": "595",
		"region": "Americas",
		"subregion": "South America",
		"slug": "paraguay",
		"name": {
			"common": "Paraguay",
			"ar": "باراغواي",
			"de": "Paraguay",
			"en": "Paraguay",
			"es": "Paraguay",
			"fr": "Paraguay",
			"hi": "पैराग्वे",
			"ja": "パラグアイ",
			"ko": "파라과이",
			"pt": "Paraguai",
			"ru": "Парагвай",
			"tr": "Paraguay",
			"zh": "巴拉圭"
		},
		"countryCode": "PY",
		"visaCode": "174",
		"states": [
			"Alto Paraguay",
			"Alto Parana",
			"Amambay",
			"Asuncion",
			"Caaguazu",
			"Caazapa",
			"Canindeyu",
			"Central",
			"Concepcion",
			"Cordillera",
			"Boqueron",
			"Guaira",
			"Itapua",
			"Misiones",
			"Neembucu",
			"Paraguari",
			"Presidente Hayes",
			"San Pedro"
		]
	},
	{
		"currency": "PEN",
		"callingCode": "51",
		"region": "Americas",
		"subregion": "South America",
		"slug": "peru",
		"name": {
			"common": "Peru",
			"ar": "بيرو",
			"de": "Peru",
			"en": "Peru",
			"es": "Perú",
			"fr": "Pérou",
			"hi": "पेरू",
			"ja": "ペルー",
			"ko": "페루",
			"pt": "Peru",
			"ru": "Перу",
			"tr": "Peru",
			"zh": "秘鲁"
		},
		"countryCode": "PE",
		"visaCode": "175",
		"states": [
			"Amazonas",
			"Ancash",
			"Apurimac",
			"Arequipa",
			"Ayacucho",
			"Cajamarca",
			"Callao",
			"Cusco",
			"Huancavelica",
			"Huanuco",
			"Ica",
			"Junin",
			"La Libertad",
			"Lambayeque",
			"Lima",
			"Loreto",
			"Madre de Dios",
			"Moquegua",
			"Municipalidad Metropolitana de Lima",
			"Pasco",
			"Piura",
			"Puno",
			"San Martin",
			"Tacna",
			"Tumbes",
			"Ucayali"
		]
	},
	{
		"currency": "PHP",
		"callingCode": "63",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "philippines",
		"name": {
			"common": "Philippines",
			"ar": "الفلبين",
			"de": "Philippinen",
			"en": "Philippines",
			"es": "Filipinas",
			"fr": "Philippines",
			"hi": "फिलीपींस",
			"ja": "フィリピン",
			"ko": "필리핀",
			"pt": "Filipinas",
			"ru": "Филиппины",
			"tr": "Filipinler",
			"zh": "菲律宾"
		},
		"countryCode": "PH",
		"visaCode": "176",
		"states": [
			"Autonomous Region in Muslim Mindanao",
			"Bicol",
			"Cagayan Valley",
			"Calabarzon",
			"Caraga",
			"Central Luzon",
			"Central Visayas",
			"Cordillera Administrative Region",
			"Davao",
			"Eastern Visayas",
			"Ilocos",
			"Mimaropa",
			"National Capital Region",
			"Northern Mindanao",
			"Soccsksargen",
			"Western Visayas",
			"Zamboanga Peninsula"
		]
	},
	{
		"currency": "NZD",
		"callingCode": "64",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "pitcairn-islands",
		"name": {
			"common": "Pitcairn Islands",
			"ar": "جزر بيتكيرن",
			"de": "Pitcairninseln",
			"en": "Pitcairn Islands",
			"es": "Islas Pitcairn",
			"fr": "Îles Pitcairn",
			"hi": "पिटकेर्न द्वीप",
			"ja": "ピトケアン諸島",
			"ko": "핏케언 제도",
			"pt": "Ilhas Pitcairn",
			"ru": "Острова Питкэрн",
			"tr": "Pitcairn Adaları",
			"zh": "皮特凯恩群岛"
		},
		"countryCode": "PN",
		"visaCode": "177",
		"states": ["Pitcairn Islands"]
	},
	{
		"currency": "PLN",
		"callingCode": "48",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "poland",
		"name": {
			"common": "Poland",
			"ar": "بولندا",
			"de": "Polen",
			"en": "Poland",
			"es": "Polonia",
			"fr": "Pologne",
			"hi": "पोलैंड",
			"ja": "ポーランド",
			"ko": "폴란드",
			"pt": "Polónia",
			"ru": "Польша",
			"tr": "Polonya",
			"zh": "波兰"
		},
		"countryCode": "PL",
		"visaCode": "178",
		"states": [
			"Dolnośląskie",
			"Kujawsko-pomorskie",
			"Łódzkie",
			"Lubelskie",
			"Lubuskie",
			"Małopolskie",
			"Mazowieckie",
			"Opolskie",
			"Podkarpackie",
			"Podlaskie",
			"Pomorskie",
			"Śląskie",
			"Świętokrzyskie",
			"Warmińsko-mazurskie",
			"Wielkopolskie",
			"Zachodniopomorskie"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "351",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "portugal",
		"name": {
			"common": "Portugal",
			"ar": "البرتغال",
			"de": "Portugal",
			"en": "Portugal",
			"es": "Portugal",
			"fr": "Portugal",
			"hi": "पुर्तगाल",
			"ja": "ポルトガル",
			"ko": "포르투갈",
			"pt": "Portugal",
			"ru": "Португалия",
			"tr": "Portekiz",
			"zh": "葡萄牙"
		},
		"countryCode": "PT",
		"visaCode": "179",
		"states": [
			"Açores",
			"Aveiro",
			"Beja",
			"Braga",
			"Bragança",
			"Castelo Branco",
			"Coimbra",
			"Évora",
			"Faro",
			"Guarda",
			"Leiria",
			"Lisboa",
			"Madeira",
			"Portalegre",
			"Porto",
			"Santarém",
			"Setúbal",
			"Viana do Castelo",
			"Vila Real",
			"Viseu"
		]
	},
	{
		"currency": "USD",
		"callingCode": "1787",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "puerto-rico",
		"name": {
			"common": "Puerto Rico",
			"ar": "بورتوريكو",
			"de": "Puerto Rico",
			"en": "Puerto Rico",
			"es": "Puerto Rico",
			"fr": "Porto Rico",
			"hi": "प्यूर्टो रिको",
			"ja": "プエルトリコ",
			"ko": "푸에르토리코",
			"pt": "Porto Rico",
			"ru": "Пуэрто-Рико",
			"tr": "Porto Riko",
			"zh": "波多黎各"
		},
		"countryCode": "PR",
		"visaCode": "180",
		"states": [
			"Adjuntas",
			"Aguada",
			"Aguadilla",
			"Aguas Buenas",
			"Aibonito",
			"Anasco",
			"Arecibo",
			"Arroyo",
			"Barceloneta",
			"Barranquitas",
			"Bayamon",
			"Cabo Rojo",
			"Caguas",
			"Camuy",
			"Canovanas",
			"Carolina",
			"Cat",
			"Ceiba",
			"Ciales",
			"Cidra",
			"Coamo",
			"Comerio",
			"Corozal",
			"Culebra",
			"Dorado",
			"Fajardo",
			"Florida",
			"Guanica",
			"Guayama",
			"Guayanilla",
			"Guaynabo",
			"Gurabo",
			"Hatillo",
			"Hormigueros",
			"Humacao",
			"Isabe",
			"Juana Diaz",
			"Juncos",
			"Lajas",
			"Lares",
			"Las Marias",
			"Las oiza",
			"Luquillo",
			"Manati",
			"Maricao",
			"Maunabo",
			"Mayaguez",
			"Moca",
			"Morovis",
			"Naguabo",
			"Naranjito",
			"Orocovis",
			"Patillas",
			"Penuelas",
			"Ponce",
			"Quebradillas",
			"Rincon",
			"Rio Grande",
			"Sabana linas",
			"San German",
			"San Juan",
			"San Lorenzo",
			"San Sebastian",
			"Santa Isabel",
			"Toa Alta",
			"Toa Baja",
			"Trujillo Alto",
			"Utuado",
			"Vega Alta",
			"Vega ues",
			"Villalba",
			"Yabucoa",
			"Yauco"
		]
	},
	{
		"currency": "QAR",
		"callingCode": "974",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "qatar",
		"name": {
			"common": "Qatar",
			"ar": "قطر",
			"de": "Katar",
			"en": "Qatar",
			"es": "Catar",
			"fr": "Qatar",
			"hi": "कतर",
			"ja": "カタール",
			"ko": "카타르",
			"pt": "Catar",
			"ru": "Катар",
			"tr": "Katar",
			"zh": "卡塔尔"
		},
		"countryCode": "QA",
		"visaCode": "181",
		"states": [
			"Ad Dawḩah",
			"Al Khawr wa adh Dhakhīrah",
			"Al Wakrah",
			"Ar Rayyān",
			"Ash Shamāl",
			"Az̧ Za̧`āyin",
			"Umm Şalāl"
		]
	},
	{
		"currency": "XAF",
		"callingCode": "242",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "republic-of-the-congo",
		"name": {
			"common": "Republic of the Congo",
			"ar": "جمهورية الكونغو",
			"de": "Kongo",
			"en": "Republic of the Congo",
			"es": "República del Congo",
			"fr": "République du Congo",
			"hi": "कांगो गणराज्य",
			"ja": "コンゴ共和国",
			"ko": "콩고 공화국",
			"pt": "República do Congo",
			"ru": "Республика Конго",
			"tr": "Kongo Cumhuriyeti",
			"zh": "刚果共和国"
		},
		"countryCode": "CG",
		"visaCode": "50",
		"states": [
			"Bouenza",
			"Brazzaville",
			"Cuvette",
			"Cuvette-Ouest",
			"Kouilou",
			"Lékoumou",
			"Likouala",
			"Niari",
			"Plateaux",
			"Pointe-Noire",
			"Pool",
			"Sangha"
		]
	},
	{
		"currency": "RON",
		"callingCode": "40",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "romania",
		"name": {
			"common": "Romania",
			"ar": "رومانيا",
			"de": "Rumänien",
			"en": "Romania",
			"es": "Rumania",
			"fr": "Roumanie",
			"hi": "रोमानिया",
			"ja": "ルーマニア",
			"ko": "루마니아",
			"pt": "Roménia",
			"ru": "Румыния",
			"tr": "Romanya",
			"zh": "罗马尼亚"
		},
		"countryCode": "RO",
		"visaCode": "183",
		"states": [
			"Alba",
			"Arad",
			"Arges",
			"Bacau",
			"Bihor",
			"Bistrita-Nasaud",
			"Botosani",
			"Braila",
			"Brasov",
			"Bucharest",
			"Buzau",
			"Calarasi",
			"Caras-Severin",
			"Cluj",
			"Constanta",
			"Covasna",
			"Dambovita",
			"Dolj",
			"Galati",
			"Giurgiu",
			"Gorj",
			"Harghita",
			"Hunedoara",
			"Ialomita",
			"Iasi",
			"Ilfov",
			"Maramures",
			"Mehedinti",
			"Mures",
			"Neamt",
			"Olt",
			"Prahova",
			"Salaj",
			"Satu Mare",
			"Sibiu",
			"Suceava",
			"Teleorman",
			"Timis",
			"Tulcea",
			"Valcea",
			"Vaslui",
			"Vrancea"
		]
	},
	{
		"currency": "RUB",
		"callingCode": "7",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "russia",
		"name": {
			"common": "Russia",
			"ar": "روسيا",
			"de": "Russland",
			"en": "Russia",
			"es": "Rusia",
			"fr": "Russie",
			"hi": "रूस",
			"ja": "ロシア",
			"ko": "러시아",
			"pt": "Rússia",
			"ru": "Россия",
			"tr": "Rusya",
			"zh": "俄罗斯"
		},
		"countryCode": "RU",
		"visaCode": "184",
		"states": [
			"Republic of Adygea",
			"Republic of Altai (Gorno-Altaysk)",
			"Altai Krai",
			"Amur Oblast",
			"Arkhangelsk Oblast",
			"Astrakhan Oblast",
			"Republic of Bashkortostan",
			"Belgorod Oblast",
			"Bryansk Oblast",
			"Republic of Buryatia",
			"Chechen Republic",
			"Chelyabinsk Oblast",
			"Chukotka Autonomous Okrug",
			"Chuvash Republic",
			"Republic of Dagestan",
			"Republic of Ingushetia",
			"Irkutsk Oblast",
			"Ivanovo Oblast",
			"Jewish Autonomous Oblast",
			"Kabardino-Balkar Republic",
			"Kaliningrad Oblast",
			"Republic of Kalmykia",
			"Kaluga Oblast",
			"Kamchatka Krai",
			"Karachay-Cherkess Republic",
			"Republic of Karelia",
			"Khabarovsk Krai",
			"Republic of Khakassia",
			"Khanty-Mansi Autonomous Okrug - Yugra",
			"Kemerovo Oblast",
			"Kirov Oblast",
			"Komi Republic",
			"Kostroma Oblast",
			"Krasnodar Krai",
			"Krasnoyarsk Krai",
			"Kurgan Oblast",
			"Kursk Oblast",
			"Leningrad Oblast",
			"Lipetsk Oblast",
			"Magadan Oblast",
			"Mari El Republic",
			"Republic of Mordovia",
			"Moscow Oblast",
			"Moscow",
			"Murmansk Oblast",
			"Nenets Autonomous Okrug",
			"Nizhny Novgorod Oblast",
			"Novgorod Oblast",
			"Novosibirsk Oblast",
			"Omsk Oblast",
			"Orenburg Oblast",
			"Oryol Oblast",
			"Penza Oblast",
			"Perm Krai",
			"Primorsky Krai",
			"Pskov Oblast",
			"Rostov Oblast",
			"Ryazan Oblast",
			"Saint Petersburg",
			"Sakha (Yakutia) Republic",
			"Sakhalin Oblast",
			"Samara Oblast",
			"Saratov Oblast",
			"Republic of North Ossetia-Alania",
			"Smolensk Oblast",
			"Stavropol Krai",
			"Sverdlovsk Oblast",
			"Tambov Oblast",
			"Republic of Tatarstan",
			"Tomsk Oblast",
			"Tuva Republic",
			"Tula Oblast",
			"Tver Oblast",
			"Tyumen Oblast",
			"Udmurt Republic",
			"Ulyanovsk Oblast",
			"Vladimir Oblast",
			"Volgograd Oblast",
			"Vologda Oblast",
			"Voronezh Oblast",
			"Yamalo-Nenets Autonomous Okrug",
			"Yaroslavl Oblast",
			"Zabaykalsky Krai"
		]
	},
	{
		"currency": "RWF",
		"callingCode": "250",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "rwanda",
		"name": {
			"common": "Rwanda",
			"ar": "رواندا",
			"de": "Ruanda",
			"en": "Rwanda",
			"es": "Ruanda",
			"fr": "Rwanda",
			"hi": "रवांडा",
			"ja": "ルワンダ",
			"ko": "르완다",
			"pt": "Ruanda",
			"ru": "Руанда",
			"tr": "Ruanda",
			"zh": "卢旺达"
		},
		"countryCode": "RW",
		"visaCode": "185",
		"states": ["Kigali", "Eastern", "Northern", "Western", "Southern"]
	},
	{
		"currency": "EUR",
		"callingCode": "262",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "reunion",
		"name": {
			"common": "Réunion",
			"ar": "Réunion",
			"de": "Réunion",
			"en": "Réunion",
			"es": "Reunión",
			"fr": "La Réunion",
			"hi": "रियूनियन",
			"ja": "レユニオン",
			"ko": "레위니옹",
			"pt": "Reunião",
			"ru": "Реюньон",
			"tr": "Réunion",
			"zh": "留尼汪"
		},
		"countryCode": "RE",
		"visayCode": "182",
		"states": ["Réunion"]
	},
	{
		"currency": "EUR",
		"callingCode": "590",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "saint-barthelemy",
		"name": {
			"common": "Saint Barthélemy",
			"ar": "سان بارتيلمي",
			"de": "Saint-Barthélemy",
			"en": "Saint Barthélemy",
			"es": "San Bartolomé",
			"fr": "Saint-Barthélemy",
			"hi": "सेंट बार्थेलेमी",
			"ja": "サン・バルテルミー",
			"ko": "생바르텔레미",
			"pt": "São Bartolomeu",
			"ru": "Сен-Бартелеми",
			"tr": "Saint Barthelemy",
			"zh": "圣巴泰勒米"
		},
		"countryCode": "BL",
		"states": ["Au Vent", "Sous le Vent"]
	},
	{
		"currency": "SHP",
		"callingCode": "290",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "saint-helena-ascension-and-tristan-da-cunha",
		"name": {
			"common": "Saint Helena, Ascension and Tristan da Cunha",
			"ar": "سانت هيلانة وأسنسيون وتريستان دا كونا",
			"de": "Sankt Helena, Ascension und Tristan da Cunha",
			"en": "Saint Helena, Ascension and Tristan da Cunha",
			"es": "Santa Elena, Ascensión y Tristán de Acuña",
			"fr": "Sainte-Hélène, Ascension et Tristan da Cunha",
			"hi": "सेंट हेलेना, असेंशन और ट्रिस्टन दा कुन्हा",
			"ja": "セントヘレナ・アセンションおよびトリスタンダクーニャ",
			"ko": "세인트헬레나 어센션 트리스탄다쿠냐",
			"pt": "Santa Helena, Ascensão e Tristão da Cunha",
			"ru": "Острова Святой Елены, Вознесения и Тристан-да-Кунья",
			"tr": "Saint Helena, Ascension ve Tristan da Cunha",
			"zh": "圣赫勒拿、阿森松和特里斯坦-达库尼亚"
		},
		"countryCode": "SH",
		"visaCode": "12",
		"states": ["Ascension", "Saint Helena", "Tristan da Cunha"]
	},
	{
		"currency": "XCD",
		"callingCode": "1869",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "saint-kitts-and-nevis",
		"name": {
			"common": "Saint Kitts and Nevis",
			"ar": "سانت كيتس ونيفيس",
			"de": "St. Kitts und Nevis",
			"en": "Saint Kitts and Nevis",
			"es": "San Cristóbal y Nieves",
			"fr": "Saint-Kitts-et-Nevis",
			"hi": "सेंट किट्स और नेविस",
			"ja": "セントクリストファー・ネーヴィス",
			"ko": "세인트키츠 네비스",
			"pt": "São Cristóvão e Neves",
			"ru": "Сент-Китс и Невис",
			"tr": "Saint Kitts ve Nevis",
			"zh": "圣基茨和尼维斯"
		},
		"countryCode": "KN",
		"visaCode": "186",
		"states": ["Saint Kitts", "Nevis"]
	},
	{
		"currency": "XCD",
		"callingCode": "1758",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "saint-lucia",
		"name": {
			"common": "Saint Lucia",
			"ar": "سانت لوسيا",
			"de": "St. Lucia",
			"en": "Saint Lucia",
			"es": "Santa Lucía",
			"fr": "Sainte-Lucie",
			"hi": "सेंट लूसिया",
			"ja": "セントルシア",
			"ko": "세인트루시아",
			"pt": "Santa Lúcia",
			"ru": "Сент-Люсия",
			"tr": "Saint Lucia",
			"zh": "圣卢西亚"
		},
		"countryCode": "LC",
		"visaCode": "187",
		"states": [
			"Anse-la-Raye",
			"Canaries",
			"Castries",
			"Choiseul",
			"Dennery",
			"Gros Islet",
			"Laborie",
			"Micoud",
			"Soufriere",
			"Vieux Fort"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "590",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "saint-martin",
		"name": {
			"common": "Saint Martin",
			"ar": "سانت مارتن",
			"de": "Saint-Martin",
			"en": "Saint Martin",
			"es": "San Martín",
			"fr": "Saint-Martin",
			"hi": "सेंट मार्टिन",
			"ja": "サン・マルタン",
			"ko": "생마르탱",
			"pt": "São Martinho",
			"ru": "Сен-Мартен",
			"tr": "Saint Martin",
			"zh": "圣马丁"
		},
		"countryCode": "MF",
		"states": ["Saint Martin"]
	},
	{
		"currency": "EUR",
		"callingCode": "508",
		"region": "Americas",
		"subregion": "North America",
		"slug": "saint-pierre-and-miquelon",
		"name": {
			"common": "Saint Pierre and Miquelon",
			"ar": "سان بيير وميكلون",
			"de": "Saint-Pierre und Miquelon",
			"en": "Saint Pierre and Miquelon",
			"es": "San Pedro y Miquelón",
			"fr": "Saint-Pierre-et-Miquelon",
			"hi": "सेंट पियरे और मिकेलॉन",
			"ja": "サンピエール島・ミクロン島",
			"ko": "생피에르 미클롱",
			"pt": "São Pedro e Miquelão",
			"ru": "Сен-Пьер и Микелон",
			"tr": "Saint Pierre ve Miquelon",
			"zh": "圣皮埃尔和密克隆"
		},
		"countryCode": "PM",
		"states": ["Miquelon", "Saint Pierre"]
	},
	{
		"currency": "XCD",
		"callingCode": "1784",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "saint-vincent-and-the-grenadines",
		"name": {
			"common": "Saint Vincent and the Grenadines",
			"ar": "سانت فنسنت والجرينادين",
			"de": "Saint Vincent und die Grenadinen",
			"en": "Saint Vincent and the Grenadines",
			"es": "San Vicente y las Granadinas",
			"fr": "Saint-Vincent-et-les-Grenadines",
			"hi": "सेंट विंसेंट और ग्रेनेडाइंस",
			"ja": "セントビンセントおよびグレナディーン諸島",
			"ko": "세인트빈센트 그레나딘",
			"pt": "São Vicente e Granadinas",
			"ru": "Сент-Винсент и Гренадины",
			"tr": "Saint Vincent ve Grenadinler",
			"zh": "圣文森特和格林纳丁斯"
		},
		"countryCode": "VC",
		"visaCode": "188",
		"states": [
			"Charlotte",
			"Grenadines",
			"Saint Andrew",
			"Saint David",
			"Saint George",
			"Saint Patrick"
		]
	},
	{
		"currency": "WST",
		"callingCode": "685",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "samoa",
		"name": {
			"common": "Samoa",
			"ar": "ساموا",
			"de": "Samoa",
			"en": "Samoa",
			"es": "Samoa",
			"fr": "Samoa",
			"hi": "समोआ",
			"ja": "サモア",
			"ko": "사모아",
			"pt": "Samoa",
			"ru": "Самоа",
			"tr": "Samoa",
			"zh": "萨摩亚"
		},
		"countryCode": "WS",
		"visaCode": "189",
		"states": [
			"A'ana",
			"Aiga-i-le-Tai",
			"Atua",
			"Fa'asaleleaga",
			"Gaga'emauga",
			"Gagaifomauga",
			"Palauli",
			"Satupa'itea",
			"Tuamasaga",
			"Va'a-o-Fonoti",
			"Vaisigano"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "378",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "san-marino",
		"name": {
			"common": "San Marino",
			"ar": "سان مارينو",
			"de": "San Marino",
			"en": "San Marino",
			"es": "San Marino",
			"fr": "Saint-Marin",
			"hi": "सैन मैरीनो",
			"ja": "サンマリノ",
			"ko": "산마리노",
			"pt": "São Marinho",
			"ru": "Сан-Марино",
			"tr": "San Marino",
			"zh": "圣马力诺"
		},
		"countryCode": "SM",
		"visaCode": "190",
		"states": [
			"Acquaviva",
			"Borgo Maggiore",
			"Chiesanuova",
			"Domagnano",
			"Faetano",
			"Fiorentino",
			"Montegiardino",
			"San Marino",
			"Serravalle"
		]
	},
	{
		"currency": "SAR",
		"callingCode": "966",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "saudi-arabia",
		"name": {
			"common": "Saudi Arabia",
			"ar": "المملكة العربية السعودية",
			"de": "Saudi-Arabien",
			"en": "Saudi Arabia",
			"es": "Arabia Saudita",
			"fr": "Arabie saoudite",
			"hi": "सऊदी अरब",
			"ja": "サウジアラビア",
			"ko": "사우디 아라비아",
			"pt": "Arábia Saudita",
			"ru": "Саудовская Аравия",
			"tr": "Suudi Arabistan",
			"zh": "沙特阿拉伯"
		},
		"countryCode": "SA",
		"visaCode": "192",
		"states": [
			"'Asir",
			"Al Bahah",
			"Al Hudud ash Shamaliyah",
			"Al Jawf",
			"Al Madinah al Munawwarah",
			"Al Qasim",
			"Ar Riyad",
			"Ash Sharqiyah",
			"Ha'il",
			"Jazan",
			"Makkah al Mukarramah",
			"Najran",
			"Tabuk"
		]
	},
	{
		"currency": "XOF",
		"callingCode": "221",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "senegal",
		"name": {
			"common": "Senegal",
			"ar": "السنغال",
			"de": "Senegal",
			"en": "Senegal",
			"es": "Senegal",
			"fr": "Sénégal",
			"hi": "सेनेगल",
			"ja": "セネガル",
			"ko": "세네갈",
			"pt": "Senegal",
			"ru": "Сенегал",
			"tr": "Senegal",
			"zh": "塞内加尔"
		},
		"countryCode": "SN",
		"visaCode": "193",
		"states": [
			"Dakar",
			"Diourbel",
			"Fatick",
			"Kaffrine",
			"Kaolack",
			"Kedougou",
			"Kolda",
			"Louga",
			"Matam",
			"Saint-Louis",
			"Sedhiou",
			"Tambacounda",
			"Thies",
			"Ziguinchor"
		]
	},
	{
		"currency": "RSD",
		"callingCode": "381",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "serbia",
		"name": {
			"common": "Serbia",
			"ar": "صربيا",
			"de": "Serbien",
			"en": "Serbia",
			"es": "Serbia",
			"fr": "Serbie",
			"hi": "सर्बिया",
			"ja": "セルビア",
			"ko": "세르비아",
			"pt": "Sérvia",
			"ru": "Сербия",
			"tr": "Sırbistan",
			"zh": "塞尔维亚"
		},
		"countryCode": "RS",
		"visaCode": "194",
		"states": [
			"Beograd (Belgrade)",
			"Borski",
			"Braničevski",
			"Jablanički",
			"Južnobački",
			"Južnobanatski",
			"Kolubarski",
			"Kosovski",
			"Kosovsko-Mitrovački",
			"Kosovsko-Pomoravski",
			"Mačvanski",
			"Moravički",
			"Nišavski",
			"Pčinjski",
			"Pećki",
			"Pirotski",
			"Podunavski",
			"Pomoravski",
			"Prizrenski",
			"Rasinski",
			"Raški",
			"Severnobački",
			"Severnobanatski",
			"Srednjebanatski",
			"Sremski",
			"Šumadijski",
			"Toplički",
			"Zaječarski",
			"Zapadnobački",
			"Zlatiborski"
		]
	},
	{
		"currency": "SCR",
		"callingCode": "248",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "seychelles",
		"name": {
			"common": "Seychelles",
			"ar": "سيشل",
			"de": "Seychellen",
			"en": "Seychelles",
			"es": "Seychelles",
			"fr": "Seychelles",
			"hi": "सेशेल्स",
			"ja": "セーシェル",
			"ko": "세이셸",
			"pt": "Seicheles",
			"ru": "Сейшельские Острова",
			"tr": "Seyşeller",
			"zh": "塞舌尔"
		},
		"countryCode": "SC",
		"visaCode": "195",
		"states": [
			"Anse aux Pins",
			"Anse Boileau",
			"Anse Etoile",
			"Anse Royale",
			"Anu Cap",
			"Baie Lazare",
			"Baie Sainte Anne",
			"Beau Vallon",
			"Bel Air",
			"Bel Ombre",
			"Cascade",
			"Glacis",
			"Grand'Anse Mahe",
			"Grand'Anse Praslin",
			"La Digue",
			"La Riviere Anglaise",
			"Les Mamelles",
			"Mont Buxton",
			"Mont Fleuri",
			"Plaisance",
			"Pointe La Rue",
			"Port Glaud",
			"Roche Caiman",
			"Saint Louis",
			"Takamaka"
		]
	},
	{
		"currency": "SLL",
		"callingCode": "232",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "sierra-leone",
		"name": {
			"common": "Sierra Leone",
			"ar": "سيرا ليون",
			"de": "Sierra Leone",
			"en": "Sierra Leone",
			"es": "Sierra Leone",
			"fr": "Sierra Leone",
			"hi": "सिएरा लियोन",
			"ja": "シエラレオネ",
			"ko": "시에라리온",
			"pt": "Serra Leoa",
			"ru": "Сьерра-Леоне",
			"tr": "Sierra Leone",
			"zh": "塞拉利昂"
		},
		"countryCode": "SL",
		"visaCode": "196",
		"states": ["Eastern", "Northern", "Southern", "Western"]
	},
	{
		"currency": "SGD",
		"callingCode": "65",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "singapore",
		"name": {
			"common": "Singapore",
			"ar": "سنغافورة",
			"de": "Singapur",
			"en": "Singapore",
			"es": "Singapur",
			"fr": "Singapour",
			"hi": "सिंगापुर",
			"ja": "シンガポール",
			"ko": "싱가포르",
			"pt": "Singapura",
			"ru": "Сингапур",
			"tr": "Singapur",
			"zh": "新加坡"
		},
		"countryCode": "SG",
		"visaCode": "197",
		"states": ["Central Singapore", "North East", "North West", "South East", "South West"]
	},
	{
		"currency": "ANG",
		"callingCode": "1721",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "sint-maarten",
		"name": {
			"common": "Sint Maarten",
			"ar": "سينت مارتن",
			"de": "Sint Maarten",
			"en": "Sint Maarten",
			"es": "San Martín",
			"fr": "Saint-Martin",
			"hi": "सिंट मार्टेन",
			"ja": "シント・マールテン",
			"ko": "신트마르턴",
			"pt": "São Martinho",
			"ru": "Синт-Мартен",
			"tr": "Sint Maarten",
			"zh": "圣马丁岛"
		},
		"countryCode": "SX",
		"visaCode": "254",
		"states": ["Sint Maarten"]
	},
	{
		"currency": "EUR",
		"callingCode": "421",
		"region": "Europe",
		"subregion": "Central Europe",
		"slug": "slovakia",
		"name": {
			"common": "Slovakia",
			"ar": "سلوفاكيا",
			"de": "Slowakei",
			"en": "Slovakia",
			"es": "Eslovaquia",
			"fr": "Slovaquie",
			"hi": "स्लोवाकिया",
			"ja": "スロバキア",
			"ko": "슬로바키아",
			"pt": "Eslováquia",
			"ru": "Словакия",
			"tr": "Slovakya",
			"zh": "斯洛伐克"
		},
		"countryCode": "SK",
		"visaCode": "198",
		"states": [
			"Banskobystricky",
			"Bratislavsky",
			"Kosicky",
			"Nitriansky",
			"Presovsky",
			"Trenciansky",
			"Trnavsky",
			"Zilinsky"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "386",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "slovenia",
		"name": {
			"common": "Slovenia",
			"ar": "سلوفينيا",
			"de": "Slowenien",
			"en": "Slovenia",
			"es": "Eslovenia",
			"fr": "Slovénie",
			"hi": "स्लोवेनिया",
			"ja": "スロベニア",
			"ko": "슬로베니아",
			"pt": "Eslovénia",
			"ru": "Словения",
			"tr": "Slovenya",
			"zh": "斯洛文尼亚"
		},
		"countryCode": "SI",
		"visaCode": "199",
		"states": [
			"Ajdovscina",
			"Apace",
			"Beltinci",
			"Benedikt",
			"Bistrica ob Sotli",
			"Bled",
			"Bloke",
			"Bohinj",
			"Borovnica",
			"Bovec",
			"Braslovce",
			"Brda",
			"Brezice",
			"Brezovica",
			"Cankova",
			"Celje",
			"Cerklje na Gorenjskem",
			"Cerknica",
			"Cerkno",
			"Cerkvenjak",
			"Cirkulane",
			"Crensovci",
			"Crna na Koroskem",
			"Crnomelj",
			"Destrnik",
			"Divaca",
			"Dobje",
			"Dobrepolje",
			"Dobrna",
			"Dobrova-Polhov Gradec",
			"Dobrovnik",
			"Dol pri Ljubljani",
			"Dolenjske Toplice",
			"Domzale",
			"Dornava",
			"Dravograd",
			"Duplek",
			"Gorenja Vas-Poljane",
			"Gorisnica",
			"Gorje",
			"Gornja Radgona",
			"Gornji Grad",
			"Gornji Petrovci",
			"Grad",
			"Grosuplje",
			"Hajdina",
			"Hoce-Slivnica",
			"Hodos",
			"Horjul",
			"Hrastnik",
			"Hrpelje-Kozina",
			"Idrija",
			"Ig",
			"Ilirska Bistrica",
			"Ivancna Gorica",
			"Izola",
			"Jesenice",
			"Jursinci",
			"Kamnik",
			"Kanal",
			"Kidricevo",
			"Kobarid",
			"Kobilje",
			"Kocevje",
			"Komen",
			"Komenda",
			"Koper",
			"Kodanjevica na Krki",
			"Kostel",
			"Kozje",
			"Kranj",
			"Kranjska Gora",
			"Krizevci",
			"Krsko",
			"Kungota",
			"Kuzma",
			"Lasko",
			"Lenart",
			"Lendava",
			"Litija",
			"Ljubljana",
			"Ljubno",
			"Ljutomer",
			"Log-Dragomer",
			"Logatec",
			"Loska Dolina",
			"Loski Potok",
			"Lovrenc na Pohorju",
			"Lukovica",
			"Luce",
			"Majsperk",
			"Makole",
			"Maribor",
			"Markovci",
			"Medvode",
			"Menges",
			"Metlika",
			"Mezica",
			"Miklavz na Dravskem Polju",
			"Miren-Kostanjevica",
			"Mirna",
			"Mirna Pec",
			"Mislinja",
			"Mokronog-Trebelno",
			"Moravce",
			"Moravske Toplice",
			"Mozirje",
			"Murska Sobota",
			"Naklo",
			"Nazarje",
			"Nova Gorica",
			"Novo Mesto",
			"Odranci",
			"Ormoz",
			"Osilnica",
			"Pesnica",
			"Piran",
			"Pivka",
			"Podcetrtek",
			"Podlehnik",
			"Podvelka",
			"Poljcane",
			"Postojna",
			"Prebold",
			"Preddvor",
			"Prevalje",
			"Ptuj",
			"Race-Fram",
			"Radece",
			"Radenci",
			"Radlje ob Dravi",
			"Radovljica",
			"Ravne na Koroskem",
			"Razkrizje",
			"Recica ob Savinji",
			"Rence-Vogrsko",
			"Ribnica",
			"Ribnica na Poboriu",
			"Rogaska Slatina",
			"Rogasovci",
			"Rogatec",
			"Ruse",
			"Salovci",
			"Selnica ob Dravi",
			"Semic",
			"Sempeter-Vrtojba",
			"Sencur",
			"Sentilj",
			"Sentjernej",
			"Sentjur",
			"Sentrupert",
			"Sevnica",
			"Sezana",
			"Skocjan",
			"Skofja Loka",
			"Skofljica",
			"Slovenj Gradec",
			"Slovenska Bistrica",
			"Slovenske Konjice",
			"Smarje pri elsah",
			"Smarjeske Toplice",
			"Smartno ob Paki",
			"Smartno pri Litiji",
			"Sodrazica",
			"Solcava",
			"Sostanj",
			"Sredisce ob Dravi",
			"Starse",
			"Store",
			"Straza",
			"Sveta Ana",
			"Sveta Trojica v Slovenskih Goricah",
			"Sveta Andraz v Slovenskih Goricah",
			"Sveti Jurij",
			"Sveti Jurij v Slovenskih Goricah",
			"Sveti Tomaz",
			"Tabor",
			"Tisina",
			"Tolmin",
			"Trbovlje",
			"Trebnje",
			"Trnovska Vas",
			"Trzin",
			"Trzic",
			"Turnisce",
			"Velenje",
			"Velika Polana",
			"Velike Lasce",
			"Verzej",
			"Videm",
			"Vipava",
			"Vitanje",
			"Vodice",
			"Vojnik",
			"Vransko",
			"Vrhnika",
			"Vuzenica",
			"Zagorje ob Savi",
			"Zavrc",
			"Zrece",
			"Zalec",
			"Zelezniki",
			"Zetale",
			"Ziri",
			"Zirovnica",
			"Zuzemberk"
		]
	},
	{
		"currency": "SBD",
		"callingCode": "677",
		"region": "Oceania",
		"subregion": "Melanesia",
		"slug": "solomon-islands",
		"name": {
			"common": "Solomon Islands",
			"ar": "جزر سليمان",
			"de": "Salomonen",
			"en": "Solomon Islands",
			"es": "Islas Salomón",
			"fr": "Îles Salomon",
			"hi": "सोलोमन द्वीपसमूह",
			"ja": "ソロモン諸島",
			"ko": "솔로몬 제도",
			"pt": "Ilhas Salomão",
			"ru": "Соломоновы Острова",
			"tr": "Solomon Adaları",
			"zh": "所罗门群岛"
		},
		"countryCode": "SB",
		"visaCode": "200",
		"states": [
			"Central",
			"Choiseul",
			"Guadalcanal",
			"Honiara",
			"Isabel",
			"Makira-Ulawa",
			"Malaita",
			"Rennell and Bellona",
			"Temotu",
			"Western"
		]
	},
	{
		"currency": "SOS",
		"callingCode": "252",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "somalia",
		"name": {
			"common": "Somalia",
			"ar": "الصومال",
			"de": "Somalia",
			"en": "Somalia",
			"es": "Somalia",
			"fr": "Somalie",
			"hi": "सोमालिया",
			"ja": "ソマリア",
			"ko": "소말리아",
			"pt": "Somália",
			"ru": "Сомали",
			"tr": "Somali",
			"zh": "索马里"
		},
		"countryCode": "SO",
		"visaCode": "201",
		"states": [
			"Awdal",
			"Bakool",
			"Banaadir",
			"Bari",
			"Bay",
			"Galguduud",
			"Gedo",
			"Hiiraan",
			"Jubbada Dhexe",
			"Jubbada Hoose",
			"Mudug",
			"Nugaal",
			"Sanaag",
			"Shabeellaha Dhexe",
			"Shabeellaha Hoose",
			"Sool",
			"Togdheer",
			"Woqooyi Galbeed"
		]
	},
	{
		"currency": "ZAR",
		"callingCode": "27",
		"region": "Africa",
		"subregion": "Southern Africa",
		"slug": "south-africa",
		"name": {
			"common": "South Africa",
			"ar": "جنوب أفريقيا",
			"de": "Südafrika",
			"en": "South Africa",
			"es": "Sudáfrica",
			"fr": "Afrique du Sud",
			"hi": "दक्षिण अफ्रीका",
			"ja": "南アフリカ",
			"ko": "남아프리카 공화국",
			"pt": "África do Sul",
			"ru": "Южная Африка",
			"tr": "Güney Afrika",
			"zh": "南非"
		},
		"countryCode": "ZA",
		"visaCode": "202",
		"states": [
			"Eastern Cape",
			"Free State",
			"Gauteng",
			"KwaZulu-Natal",
			"Limpopo",
			"Mpumalanga",
			"Northern Cape",
			"North West",
			"Western Cape"
		]
	},
	{
		"currency": "GBP",
		"callingCode": "500",
		"region": "Antarctic",
		"subregion": "",
		"slug": "south-georgia",
		"name": {
			"common": "South Georgia",
			"ar": "جورجيا الجنوبية",
			"de": "Südgeorgien",
			"en": "South Georgia",
			"es": "Georgia del Sur",
			"fr": "Géorgie du Sud",
			"hi": "दक्षिण जॉर्जिया",
			"ja": "サウスジョージア",
			"ko": "사우스조지아",
			"pt": "Geórgia do Sul",
			"ru": "Южная Георгия",
			"tr": "Güney Georgia",
			"zh": "南乔治亚"
		},
		"countryCode": "GS",
		"visaCode": "203",
		"states": [
			"Bird Island",
			"Bristol Island",
			"Clerke Rocks",
			"Montagu Island",
			"Saunders Island",
			"South Georgia",
			"Southern Thule",
			"Traversay Islands"
		]
	},
	{
		"currency": "KRW",
		"callingCode": "82",
		"region": "Asia",
		"subregion": "Eastern Asia",
		"slug": "south-korea",
		"name": {
			"common": "South Korea",
			"ar": "كوريا الجنوبية",
			"de": "Südkorea",
			"en": "South Korea",
			"es": "Corea del Sur",
			"fr": "Corée du Sud",
			"hi": "दक्षिण कोरिया",
			"ja": "韓国",
			"ko": "대한민국",
			"pt": "Coreia do Sul",
			"ru": "Южная Корея",
			"tr": "Güney Kore",
			"zh": "韩国"
		},
		"countryCode": "KR",
		"visaCode": "119",
		"states": [
			"Chungcheongbuk-do",
			"Chungcheongnam-do",
			"Jeju-teukbyeoljachido",
			"Jeollabuk-do",
			"Jeollanam-do",
			"Incheon-gwangyeoksi",
			"Gangwon-do",
			"Gwangju-gwangyeoksi",
			"Gyeonggi-do",
			"Gyeongsangbuk-do",
			"Gyeongsangnam-do",
			"Busan-gwangyeoksi",
			"Seoul-teukbyeolsi",
			"Sejong-teukbyeoljachisi",
			"Daegu-gwangyeoksi",
			"Daejeon-gwangyeoksi",
			"Ulsan-gwangyeoksi"
		]
	},
	{
		"currency": "SSP",
		"callingCode": "211",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "south-sudan",
		"name": {
			"common": "South Sudan",
			"ar": "جنوب السودان",
			"de": "Südsudan",
			"en": "South Sudan",
			"es": "Sudán del Sur",
			"fr": "Soudan du Sud",
			"hi": "दक्षिण सूडान",
			"ja": "南スーダン",
			"ko": "남수단",
			"pt": "Sudão do Sul",
			"ru": "Южный Судан",
			"tr": "Güney Sudan",
			"zh": "南苏丹"
		},
		"countryCode": "SS",
		"visaCode": "250",
		"states": [
			"Central Equatoria",
			"Eastern Equatoria",
			"Jonglei",
			"Lakes",
			"Northern Bahr el Ghazal",
			"Unity",
			"Upper Nile",
			"Warrap",
			"Western Bahr el Ghazal",
			"Western Equatoria"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "34",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "spain",
		"name": {
			"common": "Spain",
			"ar": "إسبانيا",
			"de": "Spanien",
			"en": "Spain",
			"es": "España",
			"fr": "Espagne",
			"hi": "स्पेन",
			"ja": "スペイン",
			"ko": "스페인",
			"pt": "Espanha",
			"ru": "Испания",
			"tr": "İspanya",
			"zh": "西班牙"
		},
		"countryCode": "ES",
		"visaCode": "204",
		"states": [
			"Andalucìa",
			"Albacete",
			"Alicante",
			"Almería",
			"Araba/Álava",
			"Asturias",
			"Ávila",
			"Aragòn",
			"Badajoz",
			"Barcelona",
			"Bizkaia",
			"Burgos",
			"Cáceres",
			"Cádiz",
			"Canarias",
			"Cantabria",
			"Castellón/Castelló",
			"Ceuta",
			"Ciudad Real",
			"Córdoba",
			"A Coruña",
			"Cuenca",
			"Gipuzkoa",
			"Girona",
			"Granada",
			"Guadalajara",
			"Huelva",
			"Huesca",
			"Illes Balears",
			"Jaén",
			"León",
			"Lleida",
			"Lugo",
			"Madrid",
			"Málaga",
			"Melilla",
			"Murcia",
			"Navarra/Nafarroa",
			"Ourense",
			"Palencia",
			"Las Palmas",
			"Pontevedra",
			"La Rioja",
			"Salamanca",
			"Santa Cruz de Tenerife",
			"Segovia",
			"Sevilla",
			"Soria",
			"Tarragona",
			"Teruel",
			"Toledo",
			"Valencia/València",
			"Valladolid",
			"Zamora",
			"Zaragoza"
		]
	},
	{
		"currency": "LKR",
		"callingCode": "94",
		"region": "Asia",
		"subregion": "Southern Asia",
		"slug": "sri-lanka",
		"name": {
			"common": "Sri Lanka",
			"ar": "سريلانكا",
			"de": "Sri Lanka",
			"en": "Sri Lanka",
			"es": "Sri Lanka",
			"fr": "Sri Lanka",
			"hi": "श्रीलंका",
			"ja": "スリランカ",
			"ko": "스리랑카",
			"pt": "Sri Lanka",
			"ru": "Шри-Ланка",
			"tr": "Sri Lanka",
			"zh": "斯里兰卡"
		},
		"countryCode": "LK",
		"visaCode": "205",
		"states": [
			"Basnahira",
			"Dakunu",
			"Madhyama",
			"Naegenahira",
			"Sabaragamuwa",
			"Uturu",
			"Uturumaeda",
			"Vayamba",
			"Uva"
		]
	},
	{
		"currency": "SDG",
		"callingCode": "249",
		"region": "Africa",
		"subregion": "Northern Africa",
		"slug": "sudan",
		"name": {
			"common": "Sudan",
			"ar": "السودان",
			"de": "Sudan",
			"en": "Sudan",
			"es": "Sudán",
			"fr": "Soudan",
			"hi": "सूडान",
			"ja": "スーダン",
			"ko": "수단",
			"pt": "Sudão",
			"ru": "Судан",
			"tr": "Sudan",
			"zh": "苏丹"
		},
		"countryCode": "SD",
		"visaCode": "208",
		"states": [
			"Al Bahr al Ahmar",
			"Al Jazirah",
			"Al Khartum",
			"Al Qadarif",
			"An Nil al Abyad",
			"An Nil al Azraq",
			"Ash Shamaliyah",
			"Gharb Darfur",
			"Gharb Kurdufan",
			"Janub Darfur",
			"Janub Kurdufan",
			"Kassala",
			"Nahr an Nil",
			"Shamal Darfur",
			"Sharq Darfur",
			"Shiamal Kurdufan",
			"Sinnar",
			"Wasat Darfur Zalinjay"
		]
	},
	{
		"currency": "SRD",
		"callingCode": "597",
		"region": "Americas",
		"subregion": "South America",
		"slug": "suriname",
		"name": {
			"common": "Suriname",
			"ar": "سورينام",
			"de": "Suriname",
			"en": "Suriname",
			"es": "Surinam",
			"fr": "Suriname",
			"hi": "सूरीनाम",
			"ja": "スリナム",
			"ko": "수리남",
			"pt": "Suriname",
			"ru": "Суринам",
			"tr": "Surinam",
			"zh": "苏里南"
		},
		"countryCode": "SR",
		"visaCode": "209",
		"states": [
			"Brokopondo",
			"Commewijne",
			"Coronie",
			"Marowijne",
			"Nickerie",
			"Para",
			"Paramaribo",
			"Saramacca",
			"Sipaliwini",
			"Wanica"
		]
	},
	{
		"currency": "NOK",
		"callingCode": "4779",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "svalbard-and-jan-mayen",
		"name": {
			"common": "Svalbard and Jan Mayen",
			"ar": "سفالبارد ويان ماين",
			"de": "Spitzbergen und Jan Mayen",
			"en": "Svalbard and Jan Mayen",
			"es": "Islas Svalbard y Jan Mayen",
			"fr": "Svalbard et Jan Mayen",
			"hi": "स्वालबार्ड और जान मेयेन",
			"ja": "スヴァールバル諸島およびヤンマイエン島",
			"ko": "스발바르 얀마옌 제도",
			"pt": "Svalbard e Jan Mayen",
			"ru": "Шпицберген и Ян-Майен",
			"tr": "Svalbard ve Jan Mayen",
			"zh": "斯瓦尔巴和扬马延"
		},
		"countryCode": "SJ",
		"regions": []
	},
	{
		"currency": "SEK",
		"callingCode": "46",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "sweden",
		"name": {
			"common": "Sweden",
			"ar": "السويد",
			"de": "Schweden",
			"en": "Sweden",
			"es": "Suecia",
			"fr": "Suède",
			"hi": "स्वीडन",
			"ja": "スウェーデン",
			"ko": "스웨덴",
			"pt": "Suécia",
			"ru": "Швеция",
			"tr": "İsveç",
			"zh": "瑞典"
		},
		"countryCode": "SE",
		"visaCode": "212",
		"states": [
			"Blekinge",
			"Dalarna",
			"Gävleborg",
			"Gotland",
			"Halland",
			"Jämtland",
			"Jönköping",
			"Kalmar",
			"Kronoberg",
			"Norrbotten",
			"Örebro",
			"Östergötland",
			"Skåne",
			"Södermanland",
			"Stockholm",
			"Uppsala",
			"Värmland",
			"Västerbotten",
			"Västernorrland",
			"Västmanland",
			"Västra Götaland"
		]
	},
	{
		"currency": "CHF",
		"callingCode": "41",
		"region": "Europe",
		"subregion": "Western Europe",
		"slug": "switzerland",
		"name": {
			"common": "Switzerland",
			"ar": "سويسرا",
			"de": "Schweiz",
			"en": "Switzerland",
			"es": "Suiza",
			"fr": "Suisse",
			"hi": "स्विट्जरलैंड",
			"ja": "スイス",
			"ko": "스위스",
			"pt": "Suíça",
			"ru": "Швейцария",
			"tr": "İsviçre",
			"zh": "瑞士"
		},
		"countryCode": "CH",
		"visaCode": "213",
		"states": [
			"Aargau",
			"Appenzell Ausserrhoden",
			"Appenzell Innerhoden",
			"Basel-Landschaft",
			"Basel-Stadt",
			"Bern",
			"Fribourg",
			"Genève",
			"Glarus",
			"Graubünden",
			"Jura",
			"Luzern",
			"Neuchâtel",
			"Nidwalden",
			"Obwalden",
			"Sankt Gallen",
			"Schaffhausen",
			"Schwyz",
			"Solothurn",
			"Thurgau",
			"Ticino",
			"Uri",
			"Valais",
			"Vaud",
			"Zug",
			"Zürich"
		]
	},
	{
		"currency": "SYP",
		"callingCode": "963",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "syria",
		"name": {
			"common": "Syria",
			"ar": "سوريا",
			"de": "Syrien",
			"en": "Syria",
			"es": "Siria",
			"fr": "Syrie",
			"hi": "सीरिया",
			"ja": "シリア",
			"ko": "시리아",
			"pt": "Síria",
			"ru": "Сирия",
			"tr": "Suriye",
			"zh": "叙利亚"
		},
		"countryCode": "SY",
		"visaCode": "214",
		"states": [
			"Al Hasakah",
			"Al Ladhiqiyah",
			"Al Qunaytirah",
			"Ar Raqqah",
			"As Suwayda'",
			"Dar'a",
			"Dayr az Zawr",
			"Dimashq",
			"Halab",
			"Hamah",
			"Hims",
			"Idlib",
			"Rif Dimashq",
			"Tartus"
		]
	},
	{
		"currency": "STD",
		"callingCode": "239",
		"region": "Africa",
		"subregion": "Middle Africa",
		"slug": "sao-tome-and-principe",
		"name": {
			"common": "São Tomé and Príncipe",
			"ar": "ساو تومي وبرينسيبي",
			"de": "São Tomé und Príncipe",
			"en": "São Tomé and Príncipe",
			"es": "Santo Tomé y Príncipe",
			"fr": "Sao Tomé-et-Principe",
			"hi": "साओ टोमे और प्रिंसिपे",
			"ja": "サントメ・プリンシペ",
			"ko": "상투메 프린시페",
			"pt": "São Tomé e Príncipe",
			"ru": "Сан-Томе и Принсипи",
			"tr": "São Tomé ve Príncipe",
			"zh": "圣多美和普林西比"
		},
		"countryCode": "ST",
		"visaCode": "191",
		"states": ["Principe", "Sao Tome"]
	},
	{
		"currency": "TWD",
		"callingCode": "886",
		"region": "Asia",
		"subregion": "Eastern Asia",
		"slug": "taiwan",
		"name": {
			"common": "Taiwan",
			"ar": "تايوان",
			"de": "Taiwan",
			"en": "Taiwan",
			"es": "Taiwán",
			"fr": "Taïwan",
			"hi": "ताइवान",
			"ja": "台湾",
			"ko": "대만",
			"pt": "Taiwan",
			"ru": "Тайвань",
			"tr": "Tayvan",
			"zh": "台湾"
		},
		"countryCode": "TW",
		"visaCode": "215",
		"states": [
			"Changhua",
			"Chiayi",
			"Hsinchu",
			"Hualien",
			"Kaohsiung",
			"Keelung",
			"Kinmen",
			"Lienchiang",
			"Miaoli",
			"Nantou",
			"Penghu",
			"New Taipei",
			"Pingtung",
			"Taichung",
			"Tainan",
			"Taipei",
			"Taitung",
			"Taoyuan",
			"Yilan",
			"Yunlin"
		]
	},
	{
		"currency": "TJS",
		"callingCode": "992",
		"region": "Asia",
		"subregion": "Central Asia",
		"slug": "tajikistan",
		"name": {
			"common": "Tajikistan",
			"ar": "طاجيكستان",
			"de": "Tadschikistan",
			"en": "Tajikistan",
			"es": "Tayikistán",
			"fr": "Tadjikistan",
			"hi": "ताजिकिस्तान",
			"ja": "タジキスタン",
			"ko": "타지키스탄",
			"pt": "Tajiquistão",
			"ru": "Таджикистан",
			"tr": "Tacikistan",
			"zh": "塔吉克斯坦"
		},
		"countryCode": "TJ",
		"visaCode": "216",
		"states": ["Dushanbe", "Kŭhistoni Badakhshon", "Khatlon", "Sughd"]
	},
	{
		"currency": "TZS",
		"callingCode": "255",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "tanzania",
		"name": {
			"common": "Tanzania",
			"ar": "تنزانيا",
			"de": "Tansania",
			"en": "Tanzania",
			"es": "Tanzania",
			"fr": "Tanzanie",
			"hi": "तंजानिया",
			"ja": "タンザニア",
			"ko": "탄자니아",
			"pt": "Tanzânia",
			"ru": "Танзания",
			"tr": "Tanzanya",
			"zh": "坦桑尼亚"
		},
		"countryCode": "TZ",
		"visaCode": "217",
		"states": [
			"Arusha",
			"Coast",
			"Dar es Salaam",
			"Dodoma",
			"Iringa",
			"Kagera",
			"Kigoma",
			"Kilimanjaro",
			"Lindi",
			"Manyara",
			"Mara",
			"Mbeya",
			"Morogoro",
			"Mtwara",
			"Mwanza",
			"Pemba North",
			"Pemba South",
			"Rukwa",
			"Ruvuma",
			"Shinyanga",
			"Singida",
			"Tabora",
			"Tanga",
			"Zanzibar North",
			"Zanzibar Central/South",
			"Zanzibar Urban/West"
		]
	},
	{
		"currency": "THB",
		"callingCode": "66",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "thailand",
		"name": {
			"common": "Thailand",
			"ar": "تايلاند",
			"de": "Thailand",
			"en": "Thailand",
			"es": "Tailandia",
			"fr": "Thaïlande",
			"hi": "थाईलैंड",
			"ja": "タイ",
			"ko": "태국",
			"pt": "Tailândia",
			"ru": "Таиланд",
			"tr": "Tayland",
			"zh": "泰国"
		},
		"countryCode": "TH",
		"visaCode": "218",
		"states": [
			"Amnat Charoen",
			"Ang Thong",
			"Bueng Kan",
			"Buri Ram",
			"Chachoengsao",
			"Chai Nat",
			"Chaiyaphum",
			"Chanthaburi",
			"Chiang Mai",
			"Chiang Rai",
			"Chon Buri",
			"Chumphon",
			"Kalasin",
			"Kamphaeng Phet",
			"Kanchanaburi",
			"Khon Kaen",
			"Krabi",
			"Krung Thep Mahanakhon (Bangkok)",
			"Lampang",
			"Lamphun",
			"Loei",
			"Lop Buri",
			"Mae Hong Son",
			"Maha Sarakham",
			"Mukdahan",
			"Nakhon Nayok",
			"Nakhon Phathom",
			"Nakhon Phanom",
			"Nakhon Ratchasima",
			"Nakhon Sawan",
			"Nakhon Si Thammarat",
			"Nan",
			"Narathiwat",
			"Nong Bua Lam Phu",
			"Nong Khai",
			"Nonthaburi",
			"Pathum Thani",
			"Pattani",
			"Phangnga",
			"Phatthalung",
			"Phayao",
			"Phetchabun",
			"Phetchaburi",
			"Phichit",
			"Phitsanulok",
			"Phra Nakhon Si Ayutthaya",
			"Phrae",
			"Phuket",
			"Prachin Buri",
			"Prachuap Khiri Khan",
			"Ranong",
			"Ratchaburi",
			"Rayong",
			"Roi Et",
			"Sa Kaeo",
			"Sakon Nakhon",
			"Samut Prakan",
			"Samut Sakhon",
			"Samut Songkhram",
			"Saraburi",
			"Satun",
			"Sing Buri",
			"Si Sa ket",
			"Songkhla",
			"Sukhothai",
			"Suphan Buri",
			"Surat Thani",
			"Surin",
			"Tak",
			"Trang",
			"Trat",
			"Ubon Ratchathani",
			"Udon Thani",
			"Uthai Thani",
			"Uttaradit",
			"Yala",
			"Yasothon"
		]
	},
	{
		"currency": "USD",
		"callingCode": "670",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "timor-leste",
		"name": {
			"common": "Timor-Leste",
			"ar": "تيمور الشرقية",
			"de": "Osttimor",
			"en": "Timor-Leste",
			"es": "Timor Oriental",
			"fr": "Timor oriental",
			"hi": "तिमोर-लेस्ते",
			"ja": "東ティモール",
			"ko": "동티모르",
			"pt": "Timor-Leste",
			"ru": "Восточный Тимор",
			"tr": "Timor-Leste",
			"zh": "东帝汶"
		},
		"countryCode": "TL",
		"visaCode": "220",
		"states": [
			"Aileu",
			"Ainaro",
			"Baucau",
			"Bobonaro",
			"Cova Lima",
			"Dili",
			"Ermera",
			"Lautem",
			"Liquica",
			"Manatuto",
			"Manufahi",
			"Oecussi",
			"Viqueque"
		]
	},
	{
		"currency": "XOF",
		"callingCode": "228",
		"region": "Africa",
		"subregion": "Western Africa",
		"slug": "togo",
		"name": {
			"common": "Togo",
			"ar": "توغو",
			"de": "Togo",
			"en": "Togo",
			"es": "Togo",
			"fr": "Togo",
			"hi": "टोगो",
			"ja": "トーゴ",
			"ko": "토고",
			"pt": "Togo",
			"ru": "Того",
			"tr": "Togo",
			"zh": "多哥"
		},
		"countryCode": "TG",
		"visaCode": "221",
		"states": ["Centre", "Kara", "Maritime", "Plateaux", "Savannes"]
	},
	{
		"currency": "NZD",
		"callingCode": "690",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "tokelau",
		"name": {
			"common": "Tokelau",
			"ar": "توكيلاو",
			"de": "Tokelau",
			"en": "Tokelau",
			"es": "Tokelau",
			"fr": "Tokelau",
			"hi": "टोकेलाऊ",
			"ja": "トケラウ",
			"ko": "토켈라우",
			"pt": "Tokelau",
			"ru": "Токелау",
			"tr": "Tokelau",
			"zh": "托克劳"
		},
		"countryCode": "TK",
		"visaCode": "222",
		"states": ["Atafu", "Fakaofo", "Nukunonu"]
	},
	{
		"currency": "TOP",
		"callingCode": "676",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "tonga",
		"name": {
			"common": "Tonga",
			"ar": "تونغا",
			"de": "Tonga",
			"en": "Tonga",
			"es": "Tonga",
			"fr": "Tonga",
			"hi": "टोंगा",
			"ja": "トンガ",
			"ko": "통가",
			"pt": "Tonga",
			"ru": "Тонга",
			"tr": "Tonga",
			"zh": "汤加"
		},
		"countryCode": "TO",
		"visaCode": "223",
		"states": ["'Eua", "Ha'apai", "Niuas", "Tongatapu", "Vava'u"]
	},
	{
		"currency": "TTD",
		"callingCode": "1868",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "trinidad-and-tobago",
		"name": {
			"common": "Trinidad and Tobago",
			"ar": "ترينيداد وتوباغو",
			"de": "Trinidad und Tobago",
			"en": "Trinidad and Tobago",
			"es": "Trinidad y Tobago",
			"fr": "Trinité-et-Tobago",
			"hi": "त्रिनिदाद और टोबैगो",
			"ja": "トリニダード・トバゴ",
			"ko": "트리니다드 토바고",
			"pt": "Trindade e Tobago",
			"ru": "Тринидад и Тобаго",
			"tr": "Trinidad ve Tobago",
			"zh": "特立尼达和多巴哥"
		},
		"countryCode": "TT",
		"visaCode": "224",
		"states": [
			"Arima",
			"Chaguanas",
			"Couva-Tabaquite-Talparo",
			"Diefo Martin",
			"Mayaro-Rio Claro",
			"Penal-Debe",
			"Point Fortin",
			"Port-of-Spain",
			"Princes Town",
			"San Fernando",
			"San Juan-Laventille",
			"Sangre Grande",
			"Siparia",
			"Tobago",
			"Tunapuna-Piarco"
		]
	},
	{
		"currency": "TND",
		"callingCode": "216",
		"region": "Africa",
		"subregion": "Northern Africa",
		"slug": "tunisia",
		"name": {
			"common": "Tunisia",
			"ar": "تونس",
			"de": "Tunesien",
			"en": "Tunisia",
			"es": "Túnez",
			"fr": "Tunisie",
			"hi": "ट्यूनीशिया",
			"ja": "チュニジア",
			"ko": "튀니지",
			"pt": "Tunísia",
			"ru": "Тунис",
			"tr": "Tunus",
			"zh": "突尼斯"
		},
		"countryCode": "TN",
		"visaCode": "225",
		"states": [
			"Ariana",
			"Beja",
			"Ben Arous",
			"Bizerte",
			"Gabes",
			"Gafsa",
			"Jendouba",
			"Kairouan",
			"Kasserine",
			"Kebili",
			"Kef",
			"Mahdia",
			"Medenine",
			"Monastir",
			"Nabeul",
			"Sfax",
			"Sidi Bouzid",
			"Siliana",
			"Sousse",
			"Tataouine",
			"Tozeur",
			"Tunis",
			"Zaghouan"
		]
	},
	{
		"currency": "TRY",
		"callingCode": "90",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "turkey",
		"name": {
			"common": "Turkey",
			"ar": "تركيا",
			"de": "Türkei",
			"en": "Turkey",
			"es": "Turquía",
			"fr": "Turquie",
			"hi": "तुर्की",
			"ja": "トルコ",
			"ko": "튀르키예",
			"pt": "Turquia",
			"ru": "Турция",
			"tr": "Türkiye",
			"zh": "土耳其"
		},
		"countryCode": "TR",
		"visaCode": "226",
		"states": [
			"Adana",
			"Adiyaman",
			"Afyonkarahisar",
			"Agri",
			"Aksaray",
			"Amasya",
			"Ankara",
			"Antalya",
			"Ardahan",
			"Artvin",
			"Aydin",
			"Balikesir",
			"Bartin",
			"Batman",
			"Bayburt",
			"Bilecik",
			"Bingol",
			"Bitlis",
			"Bolu",
			"Burdur",
			"Bursa",
			"Canakkale",
			"Cankiri",
			"Corum",
			"Denizli",
			"Diyarbakir",
			"Duzce",
			"Edirne",
			"Elazig",
			"Erzincan",
			"Erzurum",
			"Eskisehir",
			"Gaziantep",
			"Giresun",
			"Gumushane",
			"Hakkari",
			"Hatay",
			"Igdir",
			"Isparta",
			"Istanbul",
			"Izmir",
			"Kahramanmaras",
			"Karabuk",
			"Karaman",
			"Kars",
			"Kastamonu",
			"Kayseri",
			"Kilis",
			"Kirikkale",
			"Kirklareli",
			"Kirsehir",
			"Kocaeli",
			"Konya",
			"Kutahya",
			"Malatya",
			"Manisa",
			"Mardin",
			"Mersin",
			"Mugla",
			"Mus",
			"Nevsehir",
			"Nigde",
			"Ordu",
			"Osmaniye",
			"Rize",
			"Sakarya",
			"Samsun",
			"Sanliurfa",
			"Siirt",
			"Sinop",
			"Sirnak",
			"Sivas",
			"Tekirdag",
			"Tokat",
			"Trabzon",
			"Tunceli",
			"Usak",
			"Van",
			"Yalova",
			"Yozgat",
			"Zonguldak"
		]
	},
	{
		"currency": "TMT",
		"callingCode": "993",
		"region": "Asia",
		"subregion": "Central Asia",
		"slug": "turkmenistan",
		"name": {
			"common": "Turkmenistan",
			"ar": "تركمانستان",
			"de": "Turkmenistan",
			"en": "Turkmenistan",
			"es": "Turkmenistán",
			"fr": "Turkménistan",
			"hi": "तुर्कमेनिस्तान",
			"ja": "トルクメニスタン",
			"ko": "투르크메니스탄",
			"pt": "Turquemenistão",
			"ru": "Туркменистан",
			"tr": "Türkmenistan",
			"zh": "土库曼斯坦"
		},
		"countryCode": "TM",
		"visaCode": "227",
		"states": ["Ahal", "Asgabat", "Balkan", "Dashoguz", "Lebap", "Mary"]
	},
	{
		"currency": "USD",
		"callingCode": "1649",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "turks-and-caicos-islands",
		"name": {
			"common": "Turks and Caicos Islands",
			"ar": "جزر تركس وكايكوس",
			"de": "Turks- und Caicosinseln",
			"en": "Turks and Caicos Islands",
			"es": "Islas Turcas y Caicos",
			"fr": "Îles Turques-et-Caïques",
			"hi": "तुर्क और कैकोस द्वीपसमूह",
			"ja": "タークス・カイコス諸島",
			"ko": "터크스 케이커스 제도",
			"pt": "Ilhas Turcas e Caicos",
			"ru": "Острова Тёркс и Кайкос",
			"tr": "Turks ve Caicos Adaları",
			"zh": "特克斯和凯科斯群岛"
		},
		"countryCode": "TC",
		"visaCode": "228",
		"states": ["Turks and Caicos Islands"]
	},
	{
		"currency": "AUD",
		"callingCode": "688",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "tuvalu",
		"name": {
			"common": "Tuvalu",
			"ar": "توفالو",
			"de": "Tuvalu",
			"en": "Tuvalu",
			"es": "Tuvalu",
			"fr": "Tuvalu",
			"hi": "तुवालू",
			"ja": "ツバル",
			"ko": "투발루",
			"pt": "Tuvalu",
			"ru": "Тувалу",
			"tr": "Tuvalu",
			"zh": "图瓦卢"
		},
		"countryCode": "TV",
		"visaCode": "229",
		"states": [
			"Funafuti",
			"Nanumanga",
			"Nanumea",
			"Niutao",
			"Nui",
			"Nukufetau",
			"Nukulaelae",
			"Vaitupu"
		]
	},
	{
		"currency": "UGX",
		"callingCode": "256",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "uganda",
		"name": {
			"common": "Uganda",
			"ar": "أوغندا",
			"de": "Uganda",
			"en": "Uganda",
			"es": "Uganda",
			"fr": "Ouganda",
			"hi": "युगांडा",
			"ja": "ウガンダ",
			"ko": "우간다",
			"pt": "Uganda",
			"ru": "Уганда",
			"tr": "Uganda",
			"zh": "乌干达"
		},
		"countryCode": "UG",
		"visaCode": "230",
		"states": [
			"Abim",
			"Adjumani",
			"Amolatar",
			"Amuria",
			"Amuru",
			"Apac",
			"Arua",
			"Budaka",
			"Bududa",
			"Bugiri",
			"Bukedea",
			"Bukwa",
			"Buliisa",
			"Bundibugyo",
			"Bushenyi",
			"Busia",
			"Butaleja",
			"Dokolo",
			"Gulu",
			"Hoima",
			"Ibanda",
			"Iganga",
			"Isingiro",
			"Jinja",
			"Kaabong",
			"Kabale",
			"Kabarole",
			"Kaberamaido",
			"Kalangala",
			"Kaliro",
			"Kampala",
			"Kamuli",
			"Kamwenge",
			"Kanungu",
			"Kapchorwa",
			"Kasese",
			"Katakwi",
			"Kayunga",
			"Kibaale",
			"Kiboga",
			"Kiruhura",
			"Kisoro",
			"Kitgum",
			"Koboko",
			"Kotido",
			"Kumi",
			"Kyenjojo",
			"Lira",
			"Luwero",
			"Lyantonde",
			"Manafwa",
			"Maracha",
			"Masaka",
			"Masindi",
			"Mayuge",
			"Mbale",
			"Mbarara",
			"Mityana",
			"Moroto",
			"Moyo",
			"Mpigi",
			"Mubende",
			"Mukono",
			"Nakapiripirit",
			"Nakaseke",
			"Nakasongola",
			"Namutumba",
			"Nebbi",
			"Ntungamo",
			"Oyam",
			"Pader",
			"Pallisa",
			"Rakai",
			"Rukungiri",
			"Sembabule",
			"Sironko",
			"Soroti",
			"Tororo",
			"Wakiso",
			"Yumbe"
		]
	},
	{
		"currency": "UAH",
		"callingCode": "380",
		"region": "Europe",
		"subregion": "Eastern Europe",
		"slug": "ukraine",
		"name": {
			"common": "Ukraine",
			"ar": "أوكرانيا",
			"de": "Ukraine",
			"en": "Ukraine",
			"es": "Ucrania",
			"fr": "Ukraine",
			"hi": "यूक्रेन",
			"ja": "ウクライナ",
			"ko": "우크라이나",
			"pt": "Ucrânia",
			"ru": "Украина",
			"tr": "Ukrayna",
			"zh": "乌克兰"
		},
		"countryCode": "UA",
		"visaCode": "231",
		"states": [
			"Cherkaska oblast",
			"Chernihivska oblast",
			"Chernivetska oblast",
			"Dnipropetrovska oblast",
			"Donetska oblast",
			"Ivano-Frankivska oblast",
			"Kharkivska oblast",
			"Khersonska oblast",
			"Khmelnytska oblast",
			"Kyivska oblast",
			"Kirovohradska oblast",
			"Luhanska oblast",
			"Lvivska oblast",
			"Mykolaivska oblast",
			"Odeska oblast",
			"Poltavska oblast",
			"Rivnenska oblast",
			"Sumska oblast",
			"Ternopilska oblast",
			"Vinnytska oblast",
			"Volynska oblast",
			"Zakarpatska oblast",
			"Zaporizka oblast",
			"Zhytomyrska oblast",
			"Avtonomna Respublika Krym",
			"Kyiv",
			"Sevastopol"
		]
	},
	{
		"currency": "AED",
		"callingCode": "971",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "united-arab-emirates",
		"name": {
			"common": "United Arab Emirates",
			"ar": "الإمارات العربية المتحدة",
			"de": "Vereinigte Arabische Emirate",
			"en": "United Arab Emirates",
			"es": "Emiratos Árabes Unidos",
			"fr": "Émirats arabes unis",
			"hi": "संयुक्त अरब अमीरात",
			"ja": "アラブ首長国連邦",
			"ko": "아랍에미리트",
			"pt": "Emirados Árabes Unidos",
			"ru": "Объединённые Арабские Эмираты",
			"tr": "Birleşik Arap Emirlikleri",
			"zh": "阿拉伯联合酋长国"
		},
		"countryCode": "AE",
		"visaCode": "232",
		"states": [
			"Abu Dhabi",
			"Ajman",
			"Dubai",
			"Fujairah",
			"Ras al Khaimah",
			"Sharjah",
			"Umm Al Quwain"
		]
	},
	{
		"currency": "GBP",
		"callingCode": "44",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "united-kingdom",
		"name": {
			"common": "United Kingdom",
			"ar": "المملكة المتحدة",
			"de": "Vereinigtes Königreich",
			"en": "United Kingdom",
			"es": "Reino Unido",
			"fr": "Royaume-Uni",
			"hi": "यूनाइटेड किंगडम",
			"ja": "イギリス",
			"ko": "영국",
			"pt": "Reino Unido",
			"ru": "Великобритания",
			"tr": "Birleşik Krallık",
			"zh": "英国"
		},
		"countryCode": "GB",
		"visaCode": "233",
		"states": [
			"Aberdeen City",
			"Aberdeenshire",
			"Angus",
			"Antrim and Newtownabbey",
			"Ards and North Down",
			"Argyll and Bute",
			"Armagh City, Banbridge and Craigavon",
			"Barking and Dagenham",
			"Barnet",
			"Barnsley",
			"Bath and North East Somerset",
			"Bedford",
			"Belfast City",
			"Berkshire",
			"Bexley",
			"Birmingham",
			"Blackburn with Darwen",
			"Blackpool",
			"Blaenau Gwent",
			"Bolton",
			"Bournemouth, Christchurch and Poole",
			"Bracknell Forest",
			"Bradford",
			"Brent",
			"Bridgend",
			"Brighton and Hove",
			"Bristol, City of",
			"Bromley",
			"Buckinghamshire",
			"Bury",
			"Caerphilly",
			"Calderdale",
			"Cambridgeshire",
			"Camden",
			"Cardiff",
			"Carmarthenshire",
			"Causeway Coast and Glens",
			"Central Bedfordshire",
			"Ceredigion",
			"Cheshire East",
			"Cheshire West and Chester",
			"Clackmannanshire",
			"Conwy",
			"Cornwall",
			"Coventry",
			"Croydon",
			"Cumbria",
			"Darlington",
			"Denbighshire",
			"Derby",
			"Derbyshire",
			"Derry and Strabane",
			"Devon",
			"Doncaster",
			"Dorset",
			"Dudley",
			"Dumfries and Galloway",
			"Dundee City",
			"Durham, County",
			"Ealing",
			"East Ayrshire",
			"East Dunbartonshire",
			"East Lothian",
			"East Renfrewshire",
			"East Riding of Yorkshire",
			"East Sussex",
			"Edinburgh, City of",
			"Eilean Siar",
			"Enfield",
			"Essex",
			"Falkirk",
			"Fermanagh and Omagh",
			"Fife",
			"Flintshire",
			"Gateshead",
			"Glasgow City",
			"Gloucestershire",
			"Greenwich",
			"Gwynedd",
			"Hackney",
			"Halton",
			"Hammersmith and Fulham",
			"Hampshire",
			"Haringey",
			"Harrow",
			"Hartlepool",
			"Havering",
			"Herefordshire",
			"Hertfordshire",
			"Highland",
			"Hillingdon",
			"Hounslow",
			"Inverclyde",
			"Isle of Anglesey",
			"Isle of Wight",
			"Isles of Scilly",
			"Islington",
			"Kensington and Chelsea",
			"Kent",
			"Kingston upon Hull",
			"Kingston upon Thames",
			"Kirklees",
			"Knowsley",
			"Lambeth",
			"Lancashire",
			"Leeds",
			"Leicester",
			"Leicestershire",
			"Lewisham",
			"Lincolnshire",
			"Lisburn and Castlereagh",
			"Liverpool",
			"London, City of",
			"Luton",
			"Manchester",
			"Medway",
			"Merthyr Tydfil",
			"Merton",
			"Mid and East Antrim",
			"Mid-Ulster",
			"Middlesbrough",
			"Midlothian",
			"Milton Keynes",
			"Monmouthshire",
			"Moray",
			"Neath Port Talbot",
			"Newcastle upon Tyne",
			"Newham",
			"Newport",
			"Newry, Mourne and Down",
			"Norfolk",
			"North Ayrshire",
			"North East Lincolnshire",
			"North Lanarkshire",
			"North Lincolnshire",
			"North Somerset",
			"North Tyneside",
			"North Yorkshire",
			"Northamptonshire",
			"Northumberland",
			"Nottingham",
			"Nottinghamshire",
			"Oldham",
			"Orkney Islands",
			"Oxfordshire",
			"Pembrokeshire",
			"Perth and Kinross",
			"Peterborough",
			"Plymouth",
			"Portsmouth",
			"Powys",
			"Reading",
			"Redbridge",
			"Redcar and Cleveland",
			"Renfrewshire",
			"Rhondda Cynon Taff",
			"Richmond upon Thames",
			"Rochdale",
			"Rotherham",
			"Rutland",
			"Salford",
			"Sandwell",
			"Scottish Borders",
			"Sefton",
			"Sheffield",
			"Shetland Islands",
			"Shropshire",
			"Slough",
			"Solihull",
			"Somerset",
			"South Ayrshire",
			"South Gloucestershire",
			"South Lanarkshire",
			"South Tyneside",
			"Southampton",
			"Southend-on-Sea",
			"Southwark",
			"St. Helens",
			"Staffordshire",
			"Stirling",
			"Stockport",
			"Stockton-on-Tees",
			"Stoke-on-Trent",
			"Suffolk",
			"Sunderland",
			"Surrey",
			"Sutton",
			"Swansea",
			"Swindon",
			"Tameside",
			"Telford and Wrekin",
			"Thurrock",
			"Torbay",
			"Torfaen",
			"Tower Hamlets",
			"Trafford",
			"Vale of Glamorgan, The",
			"Wakefield",
			"Walsall",
			"Waltham Forest",
			"Wandsworth",
			"Warrington",
			"Warwickshire",
			"West Berkshire",
			"West Dunbartonshire",
			"West Lothian",
			"West Sussex",
			"Westminster",
			"Wigan",
			"Wiltshire",
			"Windsor and Maidenhead",
			"Wirral",
			"Wokingham",
			"Wolverhampton",
			"Worcestershire",
			"Wrexham",
			"York"
		]
	},
	{
		"currency": "USD",
		"callingCode": "1",
		"region": "Americas",
		"subregion": "North America",
		"slug": "united-states",
		"name": {
			"common": "United States",
			"ar": "الولايات المتحدة",
			"de": "Vereinigte Staaten",
			"en": "United States",
			"es": "Estados Unidos",
			"fr": "États-Unis",
			"hi": "संयुक्त राज्य अमेरिका",
			"ja": "アメリカ合衆国",
			"ko": "미국",
			"pt": "Estados Unidos",
			"ru": "Соединённые Штаты Америки",
			"tr": "Amerika Birleşik Devletleri",
			"zh": "美国"
		},
		"countryCode": "US",
		"visaCode": "234",
		"states": [
			"Alabama",
			"Alaska",
			"American Samoa",
			"Arizona",
			"Arkansas",
			"California",
			"Colorado",
			"Connecticut",
			"Delaware",
			"District of Columbia",
			"Micronesia",
			"Florida",
			"Georgia",
			"Guam",
			"Hawaii",
			"Idaho",
			"Illinois",
			"Indiana",
			"Iowa",
			"Kansas",
			"Kentucky",
			"Louisiana",
			"Maine",
			"Marshall Islands",
			"Maryland",
			"Massachusetts",
			"Michigan",
			"Minnesota",
			"Mississippi",
			"Missouri",
			"Montana",
			"Nebraska",
			"Nevada",
			"New Hampshire",
			"New Jersey",
			"New Mexico",
			"New York",
			"North Carolina",
			"North Dakota",
			"Northern Mariana Islands",
			"Ohio",
			"Oklahoma",
			"Oregon",
			"Palau",
			"Pennsylvania",
			"Puerto Rico",
			"Rhode Island",
			"South Carolina",
			"South Dakota",
			"Tennessee",
			"Texas",
			"Utah",
			"Vermont",
			"Virgin Islands",
			"Virginia",
			"Washington",
			"West Virginia",
			"Wisconsin",
			"Wyoming",
			"Armed Forces Americas",
			"Armed Forces Europe, Canada, Africa and Middle East",
			"Armed Forces Pacific"
		]
	},
	{
		"currency": "USD",
		"region": "Americas",
		"subregion": "North America",
		"slug": "united-states-minor-outlying-islands",
		"name": {
			"common": "United States Minor Outlying Islands",
			"ar": "جزر الولايات المتحدة الصغيرة النائية",
			"de": "Kleinere abgelegene Inseln der Vereinigten Staaten",
			"en": "United States Minor Outlying Islands",
			"es": "Islas menores alejadas de los Estados Unidos",
			"fr": "Îles mineures éloignées des États-Unis",
			"hi": "संयुक्त राज्य अमेरिका के छोटे बाहरी द्वीप",
			"ja": "合衆国領有小離島",
			"ko": "미국령 군소 제도",
			"pt": "Ilhas Menores Distantes dos Estados Unidos",
			"ru": "Внешние малые острова США",
			"tr": "Amerika Birleşik Devletleri Küçük Dış Adaları",
			"zh": "美国本土外小岛屿"
		},
		"countryCode": "UM",
		"visaCode": "235",
		"states": [
			"Baker Island",
			"Howland Island",
			"Jarvis Island",
			"Johnston Atoll",
			"Kingman Reef",
			"Midway Islands",
			"Navassa Island",
			"Palmyra Atoll",
			"Wake Island",
			"Bajo Nuevo Bank",
			"Serranilla Bank"
		]
	},
	{
		"currency": "USD",
		"callingCode": "1340",
		"region": "Americas",
		"subregion": "Caribbean",
		"slug": "united-states-virgin-islands",
		"name": {
			"common": "United States Virgin Islands",
			"ar": "جزر العذراء الأمريكية",
			"de": "Amerikanische Jungferninseln",
			"en": "United States Virgin Islands",
			"es": "Islas Vírgenes de los Estados Unidos",
			"fr": "Îles Vierges des États-Unis",
			"hi": "संयुक्त राज्य वर्जिन द्वीप",
			"ja": "アメリカ領ヴァージン諸島",
			"ko": "미국령 버진아일랜드",
			"pt": "Ilhas Virgens Americanas",
			"ru": "Виргинские Острова",
			"tr": "Amerika Birleşik Devletleri Virjin Adaları",
			"zh": "美属维尔京群岛"
		},
		"countryCode": "VI",
		"visaCode": "242",
		"states": ["St. Thomas", "St. John", "St. Croix"]
	},
	{
		"currency": "UYU",
		"callingCode": "598",
		"region": "Americas",
		"subregion": "South America",
		"slug": "uruguay",
		"name": {
			"common": "Uruguay",
			"ar": "الأوروغواي",
			"de": "Uruguay",
			"en": "Uruguay",
			"es": "Uruguay",
			"fr": "Uruguay",
			"hi": "उरुग्वे",
			"ja": "ウルグアイ",
			"ko": "우루과이",
			"pt": "Uruguai",
			"ru": "Уругвай",
			"tr": "Uruguay",
			"zh": "乌拉圭"
		},
		"countryCode": "UY",
		"visaCode": "236",
		"states": [
			"Artigas",
			"Canelones",
			"Cerro Largo",
			"Colonia",
			"Durazno",
			"Flores",
			"Florida",
			"Lavalleja",
			"Maldonado",
			"Montevideo",
			"Paysandú",
			"Río Negro",
			"Rivera",
			"Rocha",
			"Salto",
			"San José",
			"Soriano",
			"Tacuarembó",
			"Treinta y Tres"
		]
	},
	{
		"currency": "UZS",
		"callingCode": "998",
		"region": "Asia",
		"subregion": "Central Asia",
		"slug": "uzbekistan",
		"name": {
			"common": "Uzbekistan",
			"ar": "أوزبكستان",
			"de": "Usbekistan",
			"en": "Uzbekistan",
			"es": "Uzbekistán",
			"fr": "Ouzbékistan",
			"hi": "उज़्बेकिस्तान",
			"ja": "ウズベキスタン",
			"ko": "우즈베키스탄",
			"pt": "Uzbequistão",
			"ru": "Узбекистан",
			"tr": "Özbekistan",
			"zh": "乌兹别克斯坦"
		},
		"countryCode": "UZ",
		"visaCode": "237",
		"states": [
			"Toshkent shahri",
			"Andijon",
			"Buxoro",
			"Farg‘ona",
			"Jizzax",
			"Namangan",
			"Navoiy",
			"Qashqadaryo (Qarshi)",
			"Samarqand",
			"Sirdaryo (Guliston)",
			"Surxondaryo (Termiz)",
			"Toshkent wiloyati",
			"Xorazm (Urganch)",
			"Qoraqalpog‘iston Respublikasi (Nukus)"
		]
	},
	{
		"currency": "VUV",
		"callingCode": "678",
		"region": "Oceania",
		"subregion": "Melanesia",
		"slug": "vanuatu",
		"name": {
			"common": "Vanuatu",
			"ar": "فانواتو",
			"de": "Vanuatu",
			"en": "Vanuatu",
			"es": "Vanuatu",
			"fr": "Vanuatu",
			"hi": "वानुअतु",
			"ja": "バヌアツ",
			"ko": "바누아투",
			"pt": "Vanuatu",
			"ru": "Вануату",
			"tr": "Vanuatu",
			"zh": "瓦努阿图"
		},
		"countryCode": "VU",
		"visaCode": "238",
		"states": ["Malampa", "Pénama", "Sanma", "Shéfa", "Taféa", "Torba"]
	},
	{
		"currency": "EUR",
		"callingCode": "3906698",
		"region": "Europe",
		"subregion": "Southern Europe",
		"slug": "vatican-city",
		"name": {
			"common": "Vatican City",
			"ar": "الفاتيكان",
			"de": "Vatikanstadt",
			"en": "Vatican City",
			"es": "Ciudad del Vaticano",
			"fr": "Cité du Vatican",
			"hi": "वैटिकन सिटी",
			"ja": "バチカン市国",
			"ko": "바티칸 시국",
			"pt": "Cidade do Vaticano",
			"ru": "Ватикан",
			"tr": "Vatikan",
			"zh": "梵蒂冈"
		},
		"countryCode": "VA",
		"visaCode": "248",
		"states": ["Holy See (Vatican City)"]
	},
	{
		"currency": "VEF",
		"callingCode": "58",
		"region": "Americas",
		"subregion": "South America",
		"slug": "venezuela",
		"name": {
			"common": "Venezuela",
			"ar": "فنزويلا",
			"de": "Venezuela",
			"en": "Venezuela",
			"es": "Venezuela",
			"fr": "Venezuela",
			"hi": "वेनेजुएला",
			"ja": "ベネズエラ",
			"ko": "베네수엘라",
			"pt": "Venezuela",
			"ru": "Венесуэла",
			"tr": "Venezuela",
			"zh": "委内瑞拉"
		},
		"countryCode": "VE",
		"visaCode": "239",
		"states": [
			"Dependencias Federales",
			"Distrito Federal",
			"Amazonas",
			"Anzoátegui",
			"Apure",
			"Aragua",
			"Barinas",
			"Bolívar",
			"Carabobo",
			"Cojedes",
			"Delta Amacuro",
			"Falcón",
			"Guárico",
			"Lara",
			"Mérida",
			"Miranda",
			"Monagas",
			"Nueva Esparta",
			"Portuguesa",
			"Sucre",
			"Táchira",
			"Trujillo",
			"Vargas",
			"Yaracuy",
			"Zulia"
		]
	},
	{
		"currency": "VND",
		"callingCode": "84",
		"region": "Asia",
		"subregion": "South-Eastern Asia",
		"slug": "vietnam",
		"name": {
			"common": "Vietnam",
			"ar": "فيتنام",
			"de": "Vietnam",
			"en": "Vietnam",
			"es": "Vietnam",
			"fr": "Viêt Nam",
			"hi": "वियतनाम",
			"ja": "ベトナム",
			"ko": "베트남",
			"pt": "Vietname",
			"ru": "Вьетнам",
			"tr": "Vietnam",
			"zh": "越南"
		},
		"countryCode": "VN",
		"visaCode": "240",
		"states": [
			"An Giang",
			"Bà Rịa - Vũng Tàu",
			"Bình Dương",
			"Bình Phước",
			"Bình Định",
			"Bình Thuận",
			"Bạc Liêu",
			"Bắc Giang",
			"Bắc Kạn",
			"Bắc Ninh",
			"Bến Tre",
			"Cao Bằng",
			"Cà Mau",
			"Đắk Lắk",
			"Đắk Nông",
			"Điện Biên",
			"Đồng Nai",
			"Đồng Tháp",
			"Gia Lai",
			"Hà Giang",
			"Hà Nam",
			"Hà Tây",
			"Hà Tĩnh",
			"Hải Dương",
			"Hậu Giang",
			"Hòa Bình",
			"Hưng Yên",
			"Khánh Hòa",
			"Kiên Giang",
			"Kon Tum",
			"Lai Châu",
			"Lâm Đồng",
			"Lạng Sơn",
			"Lào Cai",
			"Long An",
			"Nam Định",
			"Nghệ An",
			"Ninh Bình",
			"Ninh Thuận",
			"Phú Thọ",
			"Phú Yên",
			"Quảng Bình",
			"Quảng Nam",
			"Quảng Ngãi",
			"Quảng Ninh",
			"Quảng Trị",
			"Sóc Trăng",
			"Sơn La",
			"Tây Ninh",
			"Thái Bình",
			"Thái Nguyên",
			"Thanh Hóa",
			"Thừa Thiên–Huế",
			"Tiền Giang",
			"Trà Vinh",
			"Tuyên Quang",
			"Vĩnh Long",
			"Vĩnh Phúc",
			"Yên Bái",
			"Cần Thơ",
			"Đà Nẵng",
			"Hà Nội",
			"Hải Phòng",
			"Hồ Chí Minh (Sài Gòn)"
		]
	},
	{
		"currency": "XPF",
		"callingCode": "681",
		"region": "Oceania",
		"subregion": "Polynesia",
		"slug": "wallis-and-futuna",
		"name": {
			"common": "Wallis and Futuna",
			"ar": "واليس وفوتونا",
			"de": "Wallis und Futuna",
			"en": "Wallis and Futuna",
			"es": "Wallis y Futuna",
			"fr": "Wallis-et-Futuna",
			"hi": "वालिस और फ़्यूचूना",
			"ja": "ウォリス・フツナ",
			"ko": "왈리스 푸투나",
			"pt": "Wallis e Futuna",
			"ru": "Уоллис и Футуна",
			"tr": "Wallis ve Futuna",
			"zh": "瓦利斯和富图纳"
		},
		"countryCode": "WF",
		"visaCode": "243",
		"states": ["Alo", "Sigave", "Wallis"]
	},
	{
		"currency": "MAD",
		"callingCode": "212",
		"region": "Africa",
		"subregion": "Northern Africa",
		"slug": "western-sahara",
		"name": {
			"common": "Western Sahara",
			"ar": "الصحراء الغربية",
			"de": "Westsahara",
			"en": "Western Sahara",
			"es": "Sahara Occidental",
			"fr": "Sahara occidental",
			"hi": "पश्चिमी सहारा",
			"ja": "西サハラ",
			"ko": "서사하라",
			"pt": "Saara Ocidental",
			"ru": "Западная Сахара",
			"tr": "Batı Sahra",
			"zh": "西撒哈拉"
		},
		"countryCode": "EH",
		"visaCode": "244",
		"states": ["Es Smara", "Boujdour", "Laâyoune", "Aousserd", "Oued ed Dahab"]
	},
	{
		"currency": "YER",
		"callingCode": "967",
		"region": "Asia",
		"subregion": "Western Asia",
		"slug": "yemen",
		"name": {
			"common": "Yemen",
			"ar": "اليمن",
			"de": "Jemen",
			"en": "Yemen",
			"es": "Yemen",
			"fr": "Yémen",
			"hi": "यमन",
			"ja": "イエメン",
			"ko": "예멘",
			"pt": "Iémen",
			"ru": "Йемен",
			"tr": "Yemen",
			"zh": "也门"
		},
		"countryCode": "YE",
		"visaCode": "245",
		"states": [
			"Abyān",
			"'Adan",
			"Aḑ Ḑāli'",
			"Al Bayḑā'",
			"Al Ḩudaydah",
			"Al Jawf",
			"Al Mahrah",
			"Al Maḩwīt",
			"'Amrān",
			"Dhamār",
			"Ḩaḑramawt",
			"Ḩajjah",
			"Ibb",
			"Laḩij",
			"Ma'rib",
			"Raymah",
			"Şā‘dah",
			"Şan‘ā'",
			"Shabwah",
			"Tā‘izz"
		]
	},
	{
		"currency": "ZMW",
		"callingCode": "260",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "zambia",
		"name": {
			"common": "Zambia",
			"ar": "زامبيا",
			"de": "Sambia",
			"en": "Zambia",
			"es": "Zambia",
			"fr": "Zambie",
			"hi": "जाम्बिया",
			"ja": "ザンビア",
			"ko": "잠비아",
			"pt": "Zâmbia",
			"ru": "Замбия",
			"tr": "Zambiya",
			"zh": "赞比亚"
		},
		"countryCode": "ZM",
		"visaCode": "246",
		"states": [
			"Central",
			"Copperbelt",
			"Eastern",
			"Luapula",
			"Lusaka",
			"Muchinga",
			"Northern",
			"North-Western",
			"Southern",
			"Western"
		]
	},
	{
		"currency": "USD",
		"callingCode": "263",
		"region": "Africa",
		"subregion": "Eastern Africa",
		"slug": "zimbabwe",
		"name": {
			"common": "Zimbabwe",
			"ar": "زيمبابوي",
			"de": "Simbabwe",
			"en": "Zimbabwe",
			"es": "Zimbabue",
			"fr": "Zimbabwe",
			"hi": "जिम्बाब्वे",
			"ja": "ジンバブエ",
			"ko": "짐바브웨",
			"pt": "Zimbabwe",
			"ru": "Зимбабве",
			"tr": "Zimbabve",
			"zh": "津巴布韦"
		},
		"countryCode": "ZW",
		"visaCode": "247",
		"states": [
			"Bulawayo",
			"Harare",
			"Manicaland",
			"Mashonaland Central",
			"Mashonaland East",
			"Mashonaland West",
			"Masvingo",
			"Matabeleland North",
			"Matabeleland South",
			"Midlands"
		]
	},
	{
		"currency": "EUR",
		"callingCode": "358",
		"region": "Europe",
		"subregion": "Northern Europe",
		"slug": "aland-islands",
		"name": {
			"common": "Åland Islands",
			"ar": "جزر أولاند",
			"de": "Aland",
			"en": "Åland Islands",
			"es": "Islas Åland",
			"fr": "Åland",
			"hi": "ऑलैंड द्वीप",
			"ja": "オーランド諸島",
			"ko": "올란드 제도",
			"pt": "Ilhas Åland",
			"ru": "Аландские острова",
			"tr": "Åland Adaları",
			"zh": "奥兰群岛"
		},
		"countryCode": "AX",
		"states": [
			"Brändö",
			"Eckerö",
			"Finström",
			"Föglö",
			"Geta",
			"Hammarland",
			"Jomala",
			"Kumlinge",
			"Kökar",
			"Lemland",
			"Lumparland",
			"Mariehamn",
			"Saltvik",
			"Sottunga",
			"Sund",
			"Vårdö"
		]
	}
]
